/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
    [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
    T extends { [key: string]: unknown },
    K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
    | T
    | {
          [P in keyof T]?: P extends ' $fragmentName' | '__typename'
              ? T[P]
              : never;
      };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
    /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
    DateTime: { input: any; output: any };
    /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
    JSON: { input: any; output: any };
    /** The `Money` scalar type represents monetary values and supports signed double-precision fractional values as specified by [IEEE 754](https://en.wikipedia.org/wiki/IEEE_floating_point). */
    Money: { input: number; output: number };
    /** The `Upload` scalar type represents a file upload. */
    Upload: { input: any; output: any };
};

export type ActivationGroup = Node & {
    __typename?: 'ActivationGroup';
    activated: Scalars['Boolean']['output'];
    booster?: Maybe<Scalars['Boolean']['output']>;
    complementar?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['ID']['output'];
    minQuantityActivation: Scalars['Int']['output'];
    name: Scalars['String']['output'];
    variants?: Maybe<ProductVariantList>;
};

export type ActivationGroupVariantsArgs = {
    options?: InputMaybe<ProductVariantListOptions>;
};

export type ActivationGroupList = PaginatedList & {
    __typename?: 'ActivationGroupList';
    items: Array<ActivationGroup>;
    totalItems: Scalars['Int']['output'];
};

export type AddBulkItemsToShoppingListError = ErrorResult & {
    __typename?: 'AddBulkItemsToShoppingListError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

export type AddBulkItemsToShoppingListInput = {
    productVariantsIds: Array<Scalars['ID']['input']>;
    shoppingListIds: Array<Scalars['ID']['input']>;
};

export type AddBulkItemsToShoppingListResult =
    | AddBulkItemsToShoppingListError
    | AddBulkItemsToShoppingListSuccess;

export type AddBulkItemsToShoppingListSuccess = {
    __typename?: 'AddBulkItemsToShoppingListSuccess';
    success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddFulfillmentToOrderResult =
    | CreateFulfillmentError
    | EmptyOrderLineSelectionError
    | Fulfillment
    | FulfillmentStateTransitionError
    | InsufficientStockOnHandError
    | InvalidFulfillmentHandlerError
    | ItemsAlreadyFulfilledError;

export type AddItemInput = {
    customFields?: InputMaybe<OrderLineCustomFieldsInput>;
    productVariantId: Scalars['ID']['input'];
    quantity: Scalars['Int']['input'];
};

export type AddItemToDraftOrderInput = {
    customFields?: InputMaybe<OrderLineCustomFieldsInput>;
    productVariantId: Scalars['ID']['input'];
    quantity: Scalars['Int']['input'];
};

export type AddManualPaymentToOrderResult = ManualPaymentStateError | Order;

export type AddNoteToCustomerInput = {
    id: Scalars['ID']['input'];
    isPublic: Scalars['Boolean']['input'];
    note: Scalars['String']['input'];
};

export type AddNoteToOrderInput = {
    id: Scalars['ID']['input'];
    isPublic: Scalars['Boolean']['input'];
    note: Scalars['String']['input'];
};

export type Address = Node & {
    __typename?: 'Address';
    city?: Maybe<Scalars['String']['output']>;
    company?: Maybe<Scalars['String']['output']>;
    country: Country;
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<AddressCustomFields>;
    defaultBillingAddress?: Maybe<Scalars['Boolean']['output']>;
    defaultShippingAddress?: Maybe<Scalars['Boolean']['output']>;
    fullName?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    phoneNumber?: Maybe<Scalars['String']['output']>;
    postalCode?: Maybe<Scalars['String']['output']>;
    province?: Maybe<Scalars['String']['output']>;
    streetLine1: Scalars['String']['output'];
    streetLine2?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTime']['output'];
};

export type AddressCustomFields = {
    __typename?: 'AddressCustomFields';
    neighborhood?: Maybe<Scalars['String']['output']>;
    number?: Maybe<Scalars['String']['output']>;
};

export type AdjustDraftOrderLineInput = {
    customFields?: InputMaybe<OrderLineCustomFieldsInput>;
    orderLineId: Scalars['ID']['input'];
    quantity: Scalars['Int']['input'];
};

export type Adjustment = {
    __typename?: 'Adjustment';
    adjustmentSource: Scalars['String']['output'];
    amount: Scalars['Money']['output'];
    data?: Maybe<Scalars['JSON']['output']>;
    description: Scalars['String']['output'];
    type: AdjustmentType;
};

export enum AdjustmentType {
    DISTRIBUTED_ORDER_PROMOTION = 'DISTRIBUTED_ORDER_PROMOTION',
    OTHER = 'OTHER',
    PROMOTION = 'PROMOTION',
}

export type Administrator = Node & {
    __typename?: 'Administrator';
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<AdministratorCustomFields>;
    emailAddress: Scalars['String']['output'];
    firstName: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    lastName: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
    user: User;
};

export type AdministratorCustomFields = {
    __typename?: 'AdministratorCustomFields';
    customerPortfolio?: Maybe<Array<Administrator>>;
    externalId?: Maybe<Scalars['String']['output']>;
    phoneNumber?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['String']['output']>;
};

export type AdministratorFilterParameter = {
    _and?: InputMaybe<Array<AdministratorFilterParameter>>;
    _or?: InputMaybe<Array<AdministratorFilterParameter>>;
    createdAt?: InputMaybe<DateOperators>;
    emailAddress?: InputMaybe<StringOperators>;
    externalId?: InputMaybe<StringOperators>;
    firstName?: InputMaybe<StringOperators>;
    id?: InputMaybe<IdOperators>;
    lastName?: InputMaybe<StringOperators>;
    phoneNumber?: InputMaybe<StringOperators>;
    type?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type AdministratorList = PaginatedList & {
    __typename?: 'AdministratorList';
    items: Array<Administrator>;
    totalItems: Scalars['Int']['output'];
};

export type AdministratorListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<AdministratorFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<AdministratorSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type AdministratorPaymentInput = {
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    paymentMethod?: InputMaybe<Scalars['String']['input']>;
};

export type AdministratorRefundInput = {
    /**
     * The amount to be refunded to this particular Payment. This was introduced in
     * v2.2.0 as the preferred way to specify the refund amount. The `lines`, `shipping` and `adjustment`
     * fields will be removed in a future version.
     */
    amount?: InputMaybe<Scalars['Money']['input']>;
    paymentId: Scalars['ID']['input'];
    reason?: InputMaybe<Scalars['String']['input']>;
};

export type AdministratorSortParameter = {
    createdAt?: InputMaybe<SortOrder>;
    emailAddress?: InputMaybe<SortOrder>;
    externalId?: InputMaybe<SortOrder>;
    firstName?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrder>;
    phoneNumber?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AdvancedMetricSeries = {
    __typename?: 'AdvancedMetricSeries';
    name: Scalars['String']['output'];
    values: Array<Scalars['Float']['output']>;
};

export type AdvancedMetricSummary = {
    __typename?: 'AdvancedMetricSummary';
    allowProductSelection: Scalars['Boolean']['output'];
    code: Scalars['String']['output'];
    labels: Array<Scalars['String']['output']>;
    series: Array<AdvancedMetricSeries>;
    title: Scalars['String']['output'];
    type: AdvancedMetricType;
};

export type AdvancedMetricSummaryInput = {
    variantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum AdvancedMetricType {
    currency = 'currency',
    number = 'number',
}

export type Allocation = Node &
    StockMovement & {
        __typename?: 'Allocation';
        createdAt: Scalars['DateTime']['output'];
        customFields?: Maybe<Scalars['JSON']['output']>;
        id: Scalars['ID']['output'];
        orderLine: OrderLine;
        productVariant: ProductVariant;
        quantity: Scalars['Int']['output'];
        type: StockMovementType;
        updatedAt: Scalars['DateTime']['output'];
    };

/** Returned if an attempting to refund an OrderItem which has already been refunded */
export type AlreadyRefundedError = ErrorResult & {
    __typename?: 'AlreadyRefundedError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
    refundId: Scalars['ID']['output'];
};

export type ApplyCouponCodeResult =
    | CouponCodeExpiredError
    | CouponCodeInvalidError
    | CouponCodeLimitError
    | Order;

export type Asset = Node & {
    __typename?: 'Asset';
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<Scalars['JSON']['output']>;
    fileSize: Scalars['Int']['output'];
    focalPoint?: Maybe<Coordinate>;
    height: Scalars['Int']['output'];
    id: Scalars['ID']['output'];
    mimeType: Scalars['String']['output'];
    name: Scalars['String']['output'];
    preview: Scalars['String']['output'];
    source: Scalars['String']['output'];
    tags: Array<Tag>;
    type: AssetType;
    updatedAt: Scalars['DateTime']['output'];
    width: Scalars['Int']['output'];
};

export type AssetFilterParameter = {
    _and?: InputMaybe<Array<AssetFilterParameter>>;
    _or?: InputMaybe<Array<AssetFilterParameter>>;
    createdAt?: InputMaybe<DateOperators>;
    fileSize?: InputMaybe<NumberOperators>;
    height?: InputMaybe<NumberOperators>;
    id?: InputMaybe<IdOperators>;
    mimeType?: InputMaybe<StringOperators>;
    name?: InputMaybe<StringOperators>;
    preview?: InputMaybe<StringOperators>;
    source?: InputMaybe<StringOperators>;
    type?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
    width?: InputMaybe<NumberOperators>;
};

export type AssetList = PaginatedList & {
    __typename?: 'AssetList';
    items: Array<Asset>;
    totalItems: Scalars['Int']['output'];
};

export type AssetListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<AssetFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<AssetSortParameter>;
    tags?: InputMaybe<Array<Scalars['String']['input']>>;
    tagsOperator?: InputMaybe<LogicalOperator>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type AssetNotFoundError = {
    __typename?: 'AssetNotFoundError';
    errorCode: Scalars['String']['output'];
    message: Scalars['String']['output'];
};

export type AssetSortParameter = {
    createdAt?: InputMaybe<SortOrder>;
    fileSize?: InputMaybe<SortOrder>;
    height?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    mimeType?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    preview?: InputMaybe<SortOrder>;
    source?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    width?: InputMaybe<SortOrder>;
};

export enum AssetType {
    BINARY = 'BINARY',
    IMAGE = 'IMAGE',
    VIDEO = 'VIDEO',
}

export type AssignAssetsToChannelInput = {
    assetIds: Array<Scalars['ID']['input']>;
    channelId: Scalars['ID']['input'];
};

export type AssignBannerToChannelsInput = {
    bannerIds: Array<Scalars['ID']['input']>;
    channelIds: Array<Scalars['ID']['input']>;
};

export type AssignBranchToChannelsResult = BranchDoesExistError | Success;

export type AssignCollectionsToChannelInput = {
    channelId: Scalars['ID']['input'];
    collectionIds: Array<Scalars['ID']['input']>;
};

export type AssignCustomerToBranchInput = {
    channelIds: Array<Scalars['ID']['input']>;
    customerId: Scalars['ID']['input'];
};

export type AssignCustomerToBranchResult = BranchDoesExistError | Success;

export type AssignFacetsToChannelInput = {
    channelId: Scalars['ID']['input'];
    facetIds: Array<Scalars['ID']['input']>;
};

export type AssignPaymentMethodsToChannelInput = {
    channelId: Scalars['ID']['input'];
    paymentMethodIds: Array<Scalars['ID']['input']>;
};

export type AssignProductVariantsToChannelInput = {
    channelId: Scalars['ID']['input'];
    priceFactor?: InputMaybe<Scalars['Float']['input']>;
    productVariantIds: Array<Scalars['ID']['input']>;
};

export type AssignProductsToChannelInput = {
    channelId: Scalars['ID']['input'];
    priceFactor?: InputMaybe<Scalars['Float']['input']>;
    productIds: Array<Scalars['ID']['input']>;
};

export type AssignPromotionsToChannelInput = {
    channelId: Scalars['ID']['input'];
    promotionIds: Array<Scalars['ID']['input']>;
};

export type AssignShippingMethodsToChannelInput = {
    channelId: Scalars['ID']['input'];
    shippingMethodIds: Array<Scalars['ID']['input']>;
};

export type AssignStockLocationsToChannelInput = {
    channelId: Scalars['ID']['input'];
    stockLocationIds: Array<Scalars['ID']['input']>;
};

export type AssignWorkBrandsToChannelsInput = {
    channelIds: Array<Scalars['ID']['input']>;
    workBrandsIds: Array<Scalars['ID']['input']>;
};

export type AssociateAllBuyersWithShoppingListError = ErrorResult & {
    __typename?: 'AssociateAllBuyersWithShoppingListError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

export type AssociateAllBuyersWithShoppingListInput = {
    shoppingListIds: Array<Scalars['ID']['input']>;
    userIdsFromCustomers: Array<Scalars['ID']['input']>;
};

export type AssociateAllBuyersWithShoppingListSuccess = {
    __typename?: 'AssociateAllBuyersWithShoppingListSuccess';
    message: Scalars['String']['output'];
    success: Scalars['Boolean']['output'];
};

export type AssociateBuyersWithShoppingListError = ErrorResult & {
    __typename?: 'AssociateBuyersWithShoppingListError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

export type AssociateBuyersWithShoppingListInput = {
    shoppingListId: Scalars['ID']['input'];
    userIdFromCustomer: Scalars['ID']['input'];
};

export type AssociateBuyersWithShoppingListSuccess = {
    __typename?: 'AssociateBuyersWithShoppingListSuccess';
    message: Scalars['String']['output'];
    success: Scalars['Boolean']['output'];
};

export type AuthenticationInput = {
    native?: InputMaybe<NativeAuthInput>;
};

export type AuthenticationMethod = Node & {
    __typename?: 'AuthenticationMethod';
    createdAt: Scalars['DateTime']['output'];
    id: Scalars['ID']['output'];
    strategy: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type AuthenticationResult = CurrentUser | InvalidCredentialsError;

export type AutomaticAnticipationSettings = {
    __typename?: 'AutomaticAnticipationSettings';
    delay?: Maybe<Scalars['Int']['output']>;
    enabled?: Maybe<Scalars['Boolean']['output']>;
    type?: Maybe<Scalars['String']['output']>;
    volume_percentage?: Maybe<Scalars['Int']['output']>;
};

export type AutomaticAnticipationSettingsInput = {
    delay?: InputMaybe<Scalars['String']['input']>;
    enabled?: InputMaybe<Scalars['Boolean']['input']>;
    type?: InputMaybe<Scalars['String']['input']>;
    volume_percentage?: InputMaybe<Scalars['String']['input']>;
};

export type BankAccount = {
    __typename?: 'BankAccount';
    account_check_digit?: Maybe<Scalars['String']['output']>;
    account_number?: Maybe<Scalars['String']['output']>;
    bank?: Maybe<Scalars['String']['output']>;
    branch_check_digit?: Maybe<Scalars['String']['output']>;
    branch_number?: Maybe<Scalars['String']['output']>;
    created_at?: Maybe<Scalars['String']['output']>;
    geteway_recipients?: Maybe<Array<Maybe<GatewayRecipient>>>;
    holder_document?: Maybe<Scalars['String']['output']>;
    holder_name?: Maybe<Scalars['String']['output']>;
    holder_type?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    metadata?: Maybe<Scalars['JSON']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['String']['output']>;
    updated_at?: Maybe<Scalars['String']['output']>;
};

export type BankAccountInput = {
    account_check_digit: Scalars['String']['input'];
    account_number: Scalars['String']['input'];
    bank: Scalars['String']['input'];
    branch_check_digit?: InputMaybe<Scalars['String']['input']>;
    branch_number: Scalars['String']['input'];
    holder_document: Scalars['String']['input'];
    holder_name: Scalars['String']['input'];
    holder_type: Scalars['String']['input'];
    type: Scalars['String']['input'];
};

export type BankSlipPaymentCondition = {
    __typename?: 'BankSlipPaymentCondition';
    id: Scalars['ID']['output'];
    minOrderValue: Scalars['Float']['output'];
    name: Scalars['String']['output'];
    priceIndex: Scalars['Float']['output'];
};

export type Banner = Node & {
    __typename?: 'Banner';
    channels?: Maybe<Array<Maybe<Channel>>>;
    createdAt: Scalars['DateTime']['output'];
    enabled: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    items?: Maybe<Array<Maybe<BannerItem>>>;
    page: BannerPage;
    position: BannerPosition;
    public: Scalars['Boolean']['output'];
    slug: Scalars['String']['output'];
    type: BannerType;
    updatedAt: Scalars['DateTime']['output'];
};

export type BannerFilterParameter = {
    _and?: InputMaybe<Array<BannerFilterParameter>>;
    _or?: InputMaybe<Array<BannerFilterParameter>>;
    createdAt?: InputMaybe<DateOperators>;
    enabled?: InputMaybe<BooleanOperators>;
    id?: InputMaybe<IdOperators>;
    page?: InputMaybe<StringOperators>;
    position?: InputMaybe<StringOperators>;
    public?: InputMaybe<BooleanOperators>;
    slug?: InputMaybe<StringOperators>;
    type?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type BannerItem = Node & {
    __typename?: 'BannerItem';
    asset: Asset;
    banner: Banner;
    createdAt: Scalars['DateTime']['output'];
    description?: Maybe<Scalars['String']['output']>;
    end?: Maybe<Scalars['DateTime']['output']>;
    id: Scalars['ID']['output'];
    link: Scalars['String']['output'];
    mobile?: Maybe<Asset>;
    name?: Maybe<Scalars['String']['output']>;
    start: Scalars['DateTime']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type BannerItemFilterParameter = {
    _and?: InputMaybe<Array<BannerItemFilterParameter>>;
    _or?: InputMaybe<Array<BannerItemFilterParameter>>;
    createdAt?: InputMaybe<DateOperators>;
    description?: InputMaybe<StringOperators>;
    end?: InputMaybe<DateOperators>;
    id?: InputMaybe<IdOperators>;
    link?: InputMaybe<StringOperators>;
    name?: InputMaybe<StringOperators>;
    start?: InputMaybe<DateOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type BannerItemList = PaginatedList & {
    __typename?: 'BannerItemList';
    items: Array<BannerItem>;
    totalItems: Scalars['Int']['output'];
};

export type BannerItemListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<BannerItemFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<BannerItemSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type BannerItemSortParameter = {
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    end?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    link?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    start?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type BannerItemTranslationInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type BannerList = PaginatedList & {
    __typename?: 'BannerList';
    items: Array<Banner>;
    totalItems: Scalars['Int']['output'];
};

export type BannerListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<BannerFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<BannerSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export enum BannerPage {
    HOME = 'HOME',
    HOME_PROMOTIONS = 'HOME_PROMOTIONS',
    LIST_PRODUCT = 'LIST_PRODUCT',
    PROMOTIONS = 'PROMOTIONS',
}

export enum BannerPosition {
    BOTTOM = 'BOTTOM',
    HERO = 'HERO',
    MIDDLE = 'MIDDLE',
    SIDEBAR = 'SIDEBAR',
    TOP = 'TOP',
}

export type BannerSortParameter = {
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    slug?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type BannerTranslation = {
    __typename?: 'BannerTranslation';
    createdAt: Scalars['DateTime']['output'];
    id: Scalars['ID']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type BannerTranslationInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export enum BannerType {
    GRID = 'GRID',
    MAIN = 'MAIN',
    SINGLE = 'SINGLE',
    SPECIAL = 'SPECIAL',
}

export type BaseResult = {
    __typename?: 'BaseResult';
    message: Scalars['String']['output'];
    success: Scalars['Boolean']['output'];
};

export type BooleanCustomFieldConfig = CustomField & {
    __typename?: 'BooleanCustomFieldConfig';
    description?: Maybe<Array<LocalizedString>>;
    internal?: Maybe<Scalars['Boolean']['output']>;
    label?: Maybe<Array<LocalizedString>>;
    list: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    nullable?: Maybe<Scalars['Boolean']['output']>;
    readonly?: Maybe<Scalars['Boolean']['output']>;
    requiresPermission?: Maybe<Array<Permission>>;
    type: Scalars['String']['output'];
    ui?: Maybe<Scalars['JSON']['output']>;
};

/** Operators for filtering on a list of Boolean fields */
export type BooleanListOperators = {
    inList: Scalars['Boolean']['input'];
};

/** Operators for filtering on a Boolean field */
export type BooleanOperators = {
    eq?: InputMaybe<Scalars['Boolean']['input']>;
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BooleanStructFieldConfig = StructField & {
    __typename?: 'BooleanStructFieldConfig';
    description?: Maybe<Array<LocalizedString>>;
    label?: Maybe<Array<LocalizedString>>;
    list: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    type: Scalars['String']['output'];
    ui?: Maybe<Scalars['JSON']['output']>;
};

export type Branch = Node & {
    __typename?: 'Branch';
    channels?: Maybe<Array<Channel>>;
    code: Scalars['String']['output'];
    createdAt: Scalars['DateTime']['output'];
    customers?: Maybe<Array<Customer>>;
    id: Scalars['ID']['output'];
    location: Address;
    locationId: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type BranchDoesExistError = {
    __typename?: 'BranchDoesExistError';
    errorCode: Scalars['String']['output'];
    message: Scalars['String']['output'];
};

export type BranchFilterParameter = {
    _and?: InputMaybe<Array<BranchFilterParameter>>;
    _or?: InputMaybe<Array<BranchFilterParameter>>;
    code?: InputMaybe<StringOperators>;
    createdAt?: InputMaybe<DateOperators>;
    id?: InputMaybe<IdOperators>;
    locationId?: InputMaybe<IdOperators>;
    name?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type BranchList = PaginatedList & {
    __typename?: 'BranchList';
    items: Array<Branch>;
    totalItems: Scalars['Int']['output'];
};

export type BranchListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<BranchFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<BranchSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type BranchSortParameter = {
    code?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    locationId?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

/** Returned if an attempting to cancel lines from an Order which is still active */
export type CancelActiveOrderError = ErrorResult & {
    __typename?: 'CancelActiveOrderError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
    orderState: Scalars['String']['output'];
};

export type CancelOrderInput = {
    /** Specify whether the shipping charges should also be cancelled. Defaults to false */
    cancelShipping?: InputMaybe<Scalars['Boolean']['input']>;
    /** Optionally specify which OrderLines to cancel. If not provided, all OrderLines will be cancelled */
    lines?: InputMaybe<Array<OrderLineInput>>;
    /** The id of the order to be cancelled */
    orderId: Scalars['ID']['input'];
    reason?: InputMaybe<Scalars['String']['input']>;
};

export type CancelOrderResult =
    | CancelActiveOrderError
    | EmptyOrderLineSelectionError
    | MultipleOrderError
    | Order
    | OrderStateTransitionError
    | QuantityTooGreatError;

/** Returned if the Payment cancellation fails */
export type CancelPaymentError = ErrorResult & {
    __typename?: 'CancelPaymentError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
    paymentErrorMessage: Scalars['String']['output'];
};

export type CancelPaymentResult =
    | CancelPaymentError
    | Payment
    | PaymentStateTransitionError;

export type Cancellation = Node &
    StockMovement & {
        __typename?: 'Cancellation';
        createdAt: Scalars['DateTime']['output'];
        customFields?: Maybe<Scalars['JSON']['output']>;
        id: Scalars['ID']['output'];
        orderLine: OrderLine;
        productVariant: ProductVariant;
        quantity: Scalars['Int']['output'];
        type: StockMovementType;
        updatedAt: Scalars['DateTime']['output'];
    };

export type Card = {
    __typename?: 'Card';
    brand?: Maybe<Scalars['String']['output']>;
    expMonth?: Maybe<Scalars['String']['output']>;
    expYear?: Maybe<Scalars['String']['output']>;
    firstSixDigits?: Maybe<Scalars['String']['output']>;
    holderName?: Maybe<Scalars['String']['output']>;
    label?: Maybe<Scalars['String']['output']>;
    lastFourDigits?: Maybe<Scalars['String']['output']>;
};

export type CardBrand = Node & {
    __typename?: 'CardBrand';
    brandName: Scalars['String']['output'];
    createdAt: Scalars['DateTime']['output'];
    fees: Array<CardFee>;
    id: Scalars['ID']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type CardBrandFilterParameter = {
    _and?: InputMaybe<Array<CardBrandFilterParameter>>;
    _or?: InputMaybe<Array<CardBrandFilterParameter>>;
    brandName?: InputMaybe<StringOperators>;
    createdAt?: InputMaybe<DateOperators>;
    id?: InputMaybe<IdOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type CardBrandList = PaginatedList & {
    __typename?: 'CardBrandList';
    items: Array<CardBrand>;
    totalItems: Scalars['Int']['output'];
};

export type CardBrandListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<CardBrandFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<CardBrandSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type CardBrandSortParameter = {
    brandName?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type CardFee = Node & {
    __typename?: 'CardFee';
    brand: CardBrand;
    createdAt: Scalars['DateTime']['output'];
    feePercentage: Scalars['Float']['output'];
    id: Scalars['ID']['output'];
    installments: Scalars['Int']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type CardFeeFilterParameter = {
    _and?: InputMaybe<Array<CardFeeFilterParameter>>;
    _or?: InputMaybe<Array<CardFeeFilterParameter>>;
    createdAt?: InputMaybe<DateOperators>;
    feePercentage?: InputMaybe<NumberOperators>;
    id?: InputMaybe<IdOperators>;
    installments?: InputMaybe<NumberOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type CardFeeList = PaginatedList & {
    __typename?: 'CardFeeList';
    items: Array<CardFee>;
    totalItems: Scalars['Int']['output'];
};

export type CardFeeListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<CardFeeFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<CardFeeSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type CardFeeSortParameter = {
    createdAt?: InputMaybe<SortOrder>;
    feePercentage?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    installments?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type Channel = Node & {
    __typename?: 'Channel';
    availableCurrencyCodes: Array<CurrencyCode>;
    availableLanguageCodes?: Maybe<Array<LanguageCode>>;
    code: Scalars['String']['output'];
    createdAt: Scalars['DateTime']['output'];
    /** @deprecated Use defaultCurrencyCode instead */
    currencyCode: CurrencyCode;
    customFields?: Maybe<ChannelCustomFields>;
    defaultCurrencyCode: CurrencyCode;
    defaultLanguageCode: LanguageCode;
    defaultShippingZone?: Maybe<Zone>;
    defaultTaxZone?: Maybe<Zone>;
    id: Scalars['ID']['output'];
    /** Not yet used - will be implemented in a future release. */
    outOfStockThreshold?: Maybe<Scalars['Int']['output']>;
    pricesIncludeTax: Scalars['Boolean']['output'];
    seller?: Maybe<Seller>;
    token: Scalars['String']['output'];
    /** Not yet used - will be implemented in a future release. */
    trackInventory?: Maybe<Scalars['Boolean']['output']>;
    updatedAt: Scalars['DateTime']['output'];
};

export type ChannelCustomFields = {
    __typename?: 'ChannelCustomFields';
    channelCode?: Maybe<Scalars['String']['output']>;
    channelName?: Maybe<Scalars['String']['output']>;
    color?: Maybe<Array<Scalars['String']['output']>>;
    enable?: Maybe<Scalars['Boolean']['output']>;
    externalId?: Maybe<Scalars['String']['output']>;
    logo?: Maybe<Asset>;
    recipientId?: Maybe<Scalars['String']['output']>;
    stateCode?: Maybe<Scalars['Int']['output']>;
};

/**
 * Returned when the default LanguageCode of a Channel is no longer found in the `availableLanguages`
 * of the GlobalSettings
 */
export type ChannelDefaultLanguageError = ErrorResult & {
    __typename?: 'ChannelDefaultLanguageError';
    channelCode: Scalars['String']['output'];
    errorCode: ErrorCode;
    language: Scalars['String']['output'];
    message: Scalars['String']['output'];
};

export type ChannelFilterParameter = {
    _and?: InputMaybe<Array<ChannelFilterParameter>>;
    _or?: InputMaybe<Array<ChannelFilterParameter>>;
    channelCode?: InputMaybe<StringOperators>;
    channelName?: InputMaybe<StringOperators>;
    code?: InputMaybe<StringOperators>;
    color?: InputMaybe<StringListOperators>;
    createdAt?: InputMaybe<DateOperators>;
    currencyCode?: InputMaybe<StringOperators>;
    defaultCurrencyCode?: InputMaybe<StringOperators>;
    defaultLanguageCode?: InputMaybe<StringOperators>;
    enable?: InputMaybe<BooleanOperators>;
    externalId?: InputMaybe<StringOperators>;
    id?: InputMaybe<IdOperators>;
    outOfStockThreshold?: InputMaybe<NumberOperators>;
    pricesIncludeTax?: InputMaybe<BooleanOperators>;
    recipientId?: InputMaybe<StringOperators>;
    stateCode?: InputMaybe<NumberOperators>;
    token?: InputMaybe<StringOperators>;
    trackInventory?: InputMaybe<BooleanOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type ChannelList = PaginatedList & {
    __typename?: 'ChannelList';
    items: Array<Channel>;
    totalItems: Scalars['Int']['output'];
};

export type ChannelListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<ChannelFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<ChannelSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type ChannelLogo = {
    __typename?: 'ChannelLogo';
    focalPoint?: Maybe<Coordinate>;
    height?: Maybe<Scalars['Int']['output']>;
    preview?: Maybe<Scalars['String']['output']>;
    source?: Maybe<Scalars['String']['output']>;
    width?: Maybe<Scalars['Int']['output']>;
};

export type ChannelNotFoundError = {
    __typename?: 'ChannelNotFoundError';
    errorCode: Scalars['String']['output'];
    message: Scalars['String']['output'];
};

export type ChannelSocialMedia = {
    __typename?: 'ChannelSocialMedia';
    channel: Channel;
    createdAt: Scalars['DateTime']['output'];
    deletedAt?: Maybe<Scalars['DateTime']['output']>;
    id: Scalars['ID']['output'];
    link: Scalars['String']['output'];
    nome: SocialMediaName;
    title?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTime']['output'];
};

export type ChannelSocialMediaList = {
    __typename?: 'ChannelSocialMediaList';
    items: Array<ChannelSocialMedia>;
    totalItems: Scalars['Int']['output'];
};

export type ChannelSocialMediaResult =
    | ChannelSocialMedia
    | SocialMediaAlreadyRegisteredError;

export type ChannelSortParameter = {
    channelCode?: InputMaybe<SortOrder>;
    channelName?: InputMaybe<SortOrder>;
    code?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    enable?: InputMaybe<SortOrder>;
    externalId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    logo?: InputMaybe<SortOrder>;
    outOfStockThreshold?: InputMaybe<SortOrder>;
    recipientId?: InputMaybe<SortOrder>;
    stateCode?: InputMaybe<SortOrder>;
    token?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type Collection = Node & {
    __typename?: 'Collection';
    assets: Array<Asset>;
    breadcrumbs: Array<CollectionBreadcrumb>;
    channels: Array<Channel>;
    children?: Maybe<Array<Collection>>;
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<CollectionCustomFields>;
    description: Scalars['String']['output'];
    featuredAsset?: Maybe<Asset>;
    filters: Array<ConfigurableOperation>;
    id: Scalars['ID']['output'];
    inheritFilters: Scalars['Boolean']['output'];
    isPrivate: Scalars['Boolean']['output'];
    languageCode?: Maybe<LanguageCode>;
    name: Scalars['String']['output'];
    parent?: Maybe<Collection>;
    parentId: Scalars['ID']['output'];
    position: Scalars['Int']['output'];
    productVariants: ProductVariantList;
    slug: Scalars['String']['output'];
    translations: Array<CollectionTranslation>;
    updatedAt: Scalars['DateTime']['output'];
};

export type CollectionProductVariantsArgs = {
    options?: InputMaybe<ProductVariantListOptions>;
};

export type CollectionBreadcrumb = {
    __typename?: 'CollectionBreadcrumb';
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    slug: Scalars['String']['output'];
};

export type CollectionCustomFields = {
    __typename?: 'CollectionCustomFields';
    collectionLevel?: Maybe<Scalars['String']['output']>;
    externalId?: Maybe<Scalars['String']['output']>;
    facebookImage?: Maybe<Asset>;
    seoDescription?: Maybe<Scalars['String']['output']>;
    seoTitle?: Maybe<Scalars['String']['output']>;
    twitterImage?: Maybe<Asset>;
};

export type CollectionFilterParameter = {
    _and?: InputMaybe<Array<CollectionFilterParameter>>;
    _or?: InputMaybe<Array<CollectionFilterParameter>>;
    collectionLevel?: InputMaybe<StringOperators>;
    createdAt?: InputMaybe<DateOperators>;
    description?: InputMaybe<StringOperators>;
    externalId?: InputMaybe<StringOperators>;
    id?: InputMaybe<IdOperators>;
    inheritFilters?: InputMaybe<BooleanOperators>;
    isPrivate?: InputMaybe<BooleanOperators>;
    languageCode?: InputMaybe<StringOperators>;
    name?: InputMaybe<StringOperators>;
    parentId?: InputMaybe<IdOperators>;
    position?: InputMaybe<NumberOperators>;
    seoDescription?: InputMaybe<StringOperators>;
    seoTitle?: InputMaybe<StringOperators>;
    slug?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type CollectionList = PaginatedList & {
    __typename?: 'CollectionList';
    items: Array<Collection>;
    totalItems: Scalars['Int']['output'];
};

export type CollectionListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<CollectionFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<CollectionSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
    topLevelOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Which Collections are present in the products returned
 * by the search, and in what quantity.
 */
export type CollectionResult = {
    __typename?: 'CollectionResult';
    collection: Collection;
    count: Scalars['Int']['output'];
};

export type CollectionSortParameter = {
    collectionLevel?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    externalId?: InputMaybe<SortOrder>;
    facebookImage?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    parentId?: InputMaybe<SortOrder>;
    position?: InputMaybe<SortOrder>;
    seoDescription?: InputMaybe<SortOrder>;
    seoTitle?: InputMaybe<SortOrder>;
    slug?: InputMaybe<SortOrder>;
    twitterImage?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type CollectionTranslation = {
    __typename?: 'CollectionTranslation';
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<CollectionTranslationCustomFields>;
    description: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    languageCode: LanguageCode;
    name: Scalars['String']['output'];
    slug: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type CollectionTranslationCustomFields = {
    __typename?: 'CollectionTranslationCustomFields';
    seoDescription?: Maybe<Scalars['String']['output']>;
    seoTitle?: Maybe<Scalars['String']['output']>;
};

export type ConfigArg = {
    __typename?: 'ConfigArg';
    name: Scalars['String']['output'];
    value: Scalars['String']['output'];
};

export type ConfigArgDefinition = {
    __typename?: 'ConfigArgDefinition';
    defaultValue?: Maybe<Scalars['JSON']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    label?: Maybe<Scalars['String']['output']>;
    list: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    required: Scalars['Boolean']['output'];
    type: Scalars['String']['output'];
    ui?: Maybe<Scalars['JSON']['output']>;
};

export type ConfigArgInput = {
    name: Scalars['String']['input'];
    /** A JSON stringified representation of the actual value */
    value: Scalars['String']['input'];
};

export type ConfigurableOperation = {
    __typename?: 'ConfigurableOperation';
    args: Array<ConfigArg>;
    code: Scalars['String']['output'];
};

export type ConfigurableOperationDefinition = {
    __typename?: 'ConfigurableOperationDefinition';
    args: Array<ConfigArgDefinition>;
    code: Scalars['String']['output'];
    description: Scalars['String']['output'];
};

export type ConfigurableOperationInput = {
    arguments: Array<ConfigArgInput>;
    code: Scalars['String']['input'];
};

export type Coordinate = {
    __typename?: 'Coordinate';
    x: Scalars['Float']['output'];
    y: Scalars['Float']['output'];
};

export type CoordinateInput = {
    x: Scalars['Float']['input'];
    y: Scalars['Float']['input'];
};

/**
 * A Country of the world which your shop operates in.
 *
 * The `code` field is typically a 2-character ISO code such as "GB", "US", "DE" etc. This code is used in certain inputs such as
 * `UpdateAddressInput` and `CreateAddressInput` to specify the country.
 */
export type Country = Node &
    Region & {
        __typename?: 'Country';
        code: Scalars['String']['output'];
        createdAt: Scalars['DateTime']['output'];
        customFields?: Maybe<Scalars['JSON']['output']>;
        enabled: Scalars['Boolean']['output'];
        id: Scalars['ID']['output'];
        languageCode: LanguageCode;
        name: Scalars['String']['output'];
        parent?: Maybe<Region>;
        parentId?: Maybe<Scalars['ID']['output']>;
        translations: Array<RegionTranslation>;
        type: Scalars['String']['output'];
        updatedAt: Scalars['DateTime']['output'];
    };

export type CountryFilterParameter = {
    _and?: InputMaybe<Array<CountryFilterParameter>>;
    _or?: InputMaybe<Array<CountryFilterParameter>>;
    code?: InputMaybe<StringOperators>;
    createdAt?: InputMaybe<DateOperators>;
    enabled?: InputMaybe<BooleanOperators>;
    id?: InputMaybe<IdOperators>;
    languageCode?: InputMaybe<StringOperators>;
    name?: InputMaybe<StringOperators>;
    parentId?: InputMaybe<IdOperators>;
    type?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type CountryList = PaginatedList & {
    __typename?: 'CountryList';
    items: Array<Country>;
    totalItems: Scalars['Int']['output'];
};

export type CountryListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<CountryFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<CountrySortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type CountrySortParameter = {
    code?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    parentId?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type CountryTranslationInput = {
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    languageCode: LanguageCode;
    name?: InputMaybe<Scalars['String']['input']>;
};

/** Returned if the provided coupon code is invalid */
export type CouponCodeExpiredError = ErrorResult & {
    __typename?: 'CouponCodeExpiredError';
    couponCode: Scalars['String']['output'];
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

/** Returned if the provided coupon code is invalid */
export type CouponCodeInvalidError = ErrorResult & {
    __typename?: 'CouponCodeInvalidError';
    couponCode: Scalars['String']['output'];
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

/** Returned if the provided coupon code is invalid */
export type CouponCodeLimitError = ErrorResult & {
    __typename?: 'CouponCodeLimitError';
    couponCode: Scalars['String']['output'];
    errorCode: ErrorCode;
    limit: Scalars['Int']['output'];
    message: Scalars['String']['output'];
};

export type CreateAddressCustomFieldsInput = {
    neighborhood?: InputMaybe<Scalars['String']['input']>;
    number?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input used to create an Address.
 *
 * The countryCode must correspond to a `code` property of a Country that has been defined in the
 * Vendure server. The `code` property is typically a 2-character ISO code such as "GB", "US", "DE" etc.
 * If an invalid code is passed, the mutation will fail.
 */
export type CreateAddressInput = {
    city?: InputMaybe<Scalars['String']['input']>;
    company?: InputMaybe<Scalars['String']['input']>;
    countryCode: Scalars['String']['input'];
    customFields?: InputMaybe<CreateAddressCustomFieldsInput>;
    defaultBillingAddress?: InputMaybe<Scalars['Boolean']['input']>;
    defaultShippingAddress?: InputMaybe<Scalars['Boolean']['input']>;
    fullName?: InputMaybe<Scalars['String']['input']>;
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
    postalCode?: InputMaybe<Scalars['String']['input']>;
    province?: InputMaybe<Scalars['String']['input']>;
    streetLine1: Scalars['String']['input'];
    streetLine2?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAdministratorCustomFieldsInput = {
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAdministratorInput = {
    customFields?: InputMaybe<CreateAdministratorCustomFieldsInput>;
    emailAddress: Scalars['String']['input'];
    firstName: Scalars['String']['input'];
    lastName: Scalars['String']['input'];
    password: Scalars['String']['input'];
    roleIds: Array<Scalars['ID']['input']>;
};

export type CreateAssetInput = {
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    file: Scalars['Upload']['input'];
    tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateAssetResult = Asset | MimeTypeError;

export type CreateBannerInput = {
    enabled: Scalars['Boolean']['input'];
    page: BannerPage;
    position: BannerPosition;
    public: Scalars['Boolean']['input'];
    slug: Scalars['String']['input'];
    type: BannerType;
};

export type CreateBannerItemInput = {
    asset: Scalars['ID']['input'];
    banner: Scalars['ID']['input'];
    description?: InputMaybe<Scalars['String']['input']>;
    end?: InputMaybe<Scalars['String']['input']>;
    link: Scalars['String']['input'];
    mobile?: InputMaybe<Scalars['ID']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    start: Scalars['String']['input'];
};

export type CreateBranchInput = {
    code: Scalars['String']['input'];
    location: CreateAddressInput;
    name: Scalars['String']['input'];
};

export type CreateCardBrandInput = {
    brandName: Scalars['String']['input'];
};

export type CreateCardFeeInput = {
    brandId: Scalars['ID']['input'];
    feePercentage: Scalars['Float']['input'];
    installments?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateChannelCustomFieldsInput = {
    color?: InputMaybe<Array<Scalars['String']['input']>>;
    enable?: InputMaybe<Scalars['Boolean']['input']>;
    logoId?: InputMaybe<Scalars['ID']['input']>;
    recipientId?: InputMaybe<Scalars['String']['input']>;
    stateCode?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateChannelInput = {
    availableCurrencyCodes?: InputMaybe<Array<CurrencyCode>>;
    availableLanguageCodes?: InputMaybe<Array<LanguageCode>>;
    code: Scalars['String']['input'];
    customFields?: InputMaybe<CreateChannelCustomFieldsInput>;
    defaultCurrencyCode?: InputMaybe<CurrencyCode>;
    defaultLanguageCode: LanguageCode;
    defaultShippingZoneId: Scalars['ID']['input'];
    defaultTaxZoneId: Scalars['ID']['input'];
    outOfStockThreshold?: InputMaybe<Scalars['Int']['input']>;
    pricesIncludeTax: Scalars['Boolean']['input'];
    sellerId?: InputMaybe<Scalars['ID']['input']>;
    token: Scalars['String']['input'];
    trackInventory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateChannelResult = Channel | LanguageNotAvailableError;

export type CreateChannelSocialMediaInput = {
    link: Scalars['String']['input'];
    nome: SocialMediaName;
    title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCollectionCustomFieldsInput = {
    collectionLevel?: InputMaybe<Scalars['String']['input']>;
    facebookImageId?: InputMaybe<Scalars['ID']['input']>;
    twitterImageId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCollectionInput = {
    assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    customFields?: InputMaybe<CreateCollectionCustomFieldsInput>;
    featuredAssetId?: InputMaybe<Scalars['ID']['input']>;
    filters: Array<ConfigurableOperationInput>;
    inheritFilters?: InputMaybe<Scalars['Boolean']['input']>;
    isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
    parentId?: InputMaybe<Scalars['ID']['input']>;
    translations: Array<CreateCollectionTranslationInput>;
};

export type CreateCollectionTranslationInput = {
    customFields?: InputMaybe<CreateCollectionTranslationInputCustomFields>;
    description: Scalars['String']['input'];
    languageCode: LanguageCode;
    name: Scalars['String']['input'];
    slug: Scalars['String']['input'];
};

export type CreateCollectionTranslationInputCustomFields = {
    seoDescription?: InputMaybe<Scalars['String']['input']>;
    seoTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCountryInput = {
    code: Scalars['String']['input'];
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    enabled: Scalars['Boolean']['input'];
    translations: Array<CountryTranslationInput>;
};

export type CreateCustomerCustomFieldsInput = {
    avatarId?: InputMaybe<Scalars['ID']['input']>;
    birthDate?: InputMaybe<Scalars['String']['input']>;
    businessLine?: InputMaybe<Scalars['String']['input']>;
    businessPhone?: InputMaybe<Scalars['String']['input']>;
    cellphone?: InputMaybe<Scalars['String']['input']>;
    channelFindOut?: InputMaybe<Scalars['String']['input']>;
    companyName?: InputMaybe<Scalars['String']['input']>;
    emailForInvoice?: InputMaybe<Scalars['String']['input']>;
    establishmentSize?: InputMaybe<Scalars['String']['input']>;
    exemptStateRegistration?: InputMaybe<Scalars['Boolean']['input']>;
    nationalRegistry?: InputMaybe<Scalars['String']['input']>;
    nationalRegistryIssuer?: InputMaybe<Scalars['String']['input']>;
    numberOfBoxes?: InputMaybe<Scalars['Int']['input']>;
    ownersDocument?: InputMaybe<Scalars['String']['input']>;
    serviceRegion?: InputMaybe<Scalars['String']['input']>;
    stateRegistration?: InputMaybe<Scalars['String']['input']>;
    tradeName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCustomerGroupInput = {
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    customerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    name: Scalars['String']['input'];
};

export type CreateCustomerInput = {
    customFields?: InputMaybe<CreateCustomerCustomFieldsInput>;
    emailAddress: Scalars['String']['input'];
    firstName: Scalars['String']['input'];
    lastName: Scalars['String']['input'];
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCustomerResult = Customer | EmailAddressConflictError;

export type CreateFacetInput = {
    code: Scalars['String']['input'];
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    isPrivate: Scalars['Boolean']['input'];
    translations: Array<FacetTranslationInput>;
    values?: InputMaybe<Array<CreateFacetValueWithFacetInput>>;
};

export type CreateFacetValueInput = {
    code: Scalars['String']['input'];
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    facetId: Scalars['ID']['input'];
    translations: Array<FacetValueTranslationInput>;
};

export type CreateFacetValueWithFacetInput = {
    code: Scalars['String']['input'];
    translations: Array<FacetValueTranslationInput>;
};

/** Returned if an error is thrown in a FulfillmentHandler's createFulfillment method */
export type CreateFulfillmentError = ErrorResult & {
    __typename?: 'CreateFulfillmentError';
    errorCode: ErrorCode;
    fulfillmentHandlerError: Scalars['String']['output'];
    message: Scalars['String']['output'];
};

export type CreateGroupOptionInput = {
    code: Scalars['String']['input'];
    translations: Array<ProductOptionGroupTranslationInput>;
};

export type CreatePackageInput = {
    distanceUnit: DistanceUnit;
    enabled: Scalars['Boolean']['input'];
    height: Scalars['Float']['input'];
    length: Scalars['Float']['input'];
    massUnit: MassUnit;
    name: Scalars['String']['input'];
    weight: Scalars['Float']['input'];
    width: Scalars['Float']['input'];
};

export type CreatePartnerResult =
    | AssetNotFoundError
    | ChannelNotFoundError
    | PartnerAlreadyExistsError
    | PartnerNameAlreadyExistsError
    | Success;

export type CreatePaymentMethodInput = {
    checker?: InputMaybe<ConfigurableOperationInput>;
    code: Scalars['String']['input'];
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    enabled: Scalars['Boolean']['input'];
    handler: ConfigurableOperationInput;
    translations: Array<PaymentMethodTranslationInput>;
};

export type CreateProductCustomFieldsInput = {
    externalId?: InputMaybe<Scalars['String']['input']>;
    facebookImageId?: InputMaybe<Scalars['ID']['input']>;
    primaryCollection?: InputMaybe<Scalars['String']['input']>;
    relatedProductsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    twitterImageId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateProductInput = {
    assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    customFields?: InputMaybe<CreateProductCustomFieldsInput>;
    enabled?: InputMaybe<Scalars['Boolean']['input']>;
    facetValueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    featuredAssetId?: InputMaybe<Scalars['ID']['input']>;
    translations: Array<ProductTranslationInput>;
};

export type CreateProductOptionGroupInput = {
    code: Scalars['String']['input'];
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    options: Array<CreateGroupOptionInput>;
    translations: Array<ProductOptionGroupTranslationInput>;
};

export type CreateProductOptionInput = {
    code: Scalars['String']['input'];
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    productOptionGroupId: Scalars['ID']['input'];
    translations: Array<ProductOptionGroupTranslationInput>;
};

export type CreateProductVariantCustomFieldsInput = {
    additionalDeliveryTime?: InputMaybe<Scalars['Int']['input']>;
    boxQuantity?: InputMaybe<Scalars['Int']['input']>;
    distanceUnit?: InputMaybe<Scalars['String']['input']>;
    height?: InputMaybe<Scalars['Float']['input']>;
    length?: InputMaybe<Scalars['Float']['input']>;
    massUnit?: InputMaybe<Scalars['String']['input']>;
    measurementUnit?: InputMaybe<Scalars['String']['input']>;
    minimumQuantity?: InputMaybe<Scalars['Int']['input']>;
    multiple?: InputMaybe<Scalars['Int']['input']>;
    orderPaymentConditionType?: InputMaybe<Scalars['String']['input']>;
    weight?: InputMaybe<Scalars['Float']['input']>;
    width?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateProductVariantInput = {
    assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    customFields?: InputMaybe<CreateProductVariantCustomFieldsInput>;
    enabled?: InputMaybe<Scalars['Boolean']['input']>;
    facetValueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    featuredAssetId?: InputMaybe<Scalars['ID']['input']>;
    optionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    outOfStockThreshold?: InputMaybe<Scalars['Int']['input']>;
    price?: InputMaybe<Scalars['Money']['input']>;
    prices?: InputMaybe<Array<InputMaybe<CreateProductVariantPriceInput>>>;
    productId: Scalars['ID']['input'];
    sku: Scalars['String']['input'];
    stockLevels?: InputMaybe<Array<StockLevelInput>>;
    stockOnHand?: InputMaybe<Scalars['Int']['input']>;
    taxCategoryId?: InputMaybe<Scalars['ID']['input']>;
    trackInventory?: InputMaybe<GlobalFlag>;
    translations: Array<ProductVariantTranslationInput>;
    useGlobalOutOfStockThreshold?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateProductVariantOptionInput = {
    code: Scalars['String']['input'];
    optionGroupId: Scalars['ID']['input'];
    translations: Array<ProductOptionTranslationInput>;
};

export type CreateProductVariantPriceInput = {
    currencyCode: CurrencyCode;
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    price: Scalars['Money']['input'];
};

export type CreatePromotionCustomFieldsInput = {
    assetId?: InputMaybe<Scalars['ID']['input']>;
    mobileId?: InputMaybe<Scalars['ID']['input']>;
    progressiveDiscountType?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePromotionInput = {
    actions: Array<ConfigurableOperationInput>;
    conditions: Array<ConfigurableOperationInput>;
    couponCode?: InputMaybe<Scalars['String']['input']>;
    customFields?: InputMaybe<CreatePromotionCustomFieldsInput>;
    enabled: Scalars['Boolean']['input'];
    endsAt?: InputMaybe<Scalars['DateTime']['input']>;
    perCustomerUsageLimit?: InputMaybe<Scalars['Int']['input']>;
    startsAt?: InputMaybe<Scalars['DateTime']['input']>;
    translations: Array<PromotionTranslationInput>;
    usageLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatePromotionResult = MissingConditionsError | Promotion;

export type CreateProvinceInput = {
    code: Scalars['String']['input'];
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    enabled: Scalars['Boolean']['input'];
    translations: Array<ProvinceTranslationInput>;
};

export type CreateRecipientInput = {
    automatic_anticipation_settings?: InputMaybe<AutomaticAnticipationSettingsInput>;
    code?: InputMaybe<Scalars['String']['input']>;
    default_bank_account: BankAccountInput;
    description?: InputMaybe<Scalars['String']['input']>;
    document: Scalars['String']['input'];
    email: Scalars['String']['input'];
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    name: Scalars['String']['input'];
    transfer_settings?: InputMaybe<TransferSettingsInput>;
    type: Scalars['String']['input'];
};

export type CreateRecipientResponse = Error | Recipient;

export type CreateRefundRequestInput = {
    assets?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    orderCode: Scalars['String']['input'];
    reason?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRoleInput = {
    channelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    code: Scalars['String']['input'];
    description: Scalars['String']['input'];
    permissions: Array<Permission>;
};

export type CreateSellerCustomFieldsInput = {
    externalId?: InputMaybe<Scalars['String']['input']>;
    phone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSellerInput = {
    customFields?: InputMaybe<CreateSellerCustomFieldsInput>;
    name: Scalars['String']['input'];
};

export type CreateSellerTokenResult = CreateTokenResult | NoSellerAssignedError;

export type CreateShippingMethodInput = {
    calculator: ConfigurableOperationInput;
    checker: ConfigurableOperationInput;
    code: Scalars['String']['input'];
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    fulfillmentHandler: Scalars['String']['input'];
    translations: Array<ShippingMethodTranslationInput>;
};

export type CreateShoppingListError = ErrorResult & {
    __typename?: 'CreateShoppingListError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

export type CreateShoppingListInput = {
    buyers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    description?: InputMaybe<Scalars['String']['input']>;
    enabled?: InputMaybe<Scalars['Boolean']['input']>;
    endDate?: InputMaybe<Scalars['DateTime']['input']>;
    imageId?: InputMaybe<Scalars['ID']['input']>;
    isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    originType?: InputMaybe<Scalars['String']['input']>;
    productVariants?: InputMaybe<
        Array<InputMaybe<ShoppingListProductVariantInput>>
    >;
    startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateShoppingListResult =
    | CreateShoppingListError
    | CreateShoppingListSuccess;

export type CreateShoppingListSuccess = {
    __typename?: 'CreateShoppingListSuccess';
    shoppingListId: Scalars['String']['output'];
    success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateStockLocationInput = {
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
};

export type CreateSynonymGroupInput = {
    enabled?: InputMaybe<Scalars['Boolean']['input']>;
    label: Scalars['String']['input'];
    terms: Array<Scalars['String']['input']>;
};

export type CreateSynonymGroupResult =
    | Success
    | SynonymGroupLabelAlreadyExistsError
    | SynonymGroupTooFewTermsError;

export type CreateTagInput = {
    value: Scalars['String']['input'];
};

export type CreateTaxCategoryInput = {
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    isDefault?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
};

export type CreateTaxRateInput = {
    categoryId: Scalars['ID']['input'];
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    customerGroupId?: InputMaybe<Scalars['ID']['input']>;
    enabled: Scalars['Boolean']['input'];
    name: Scalars['String']['input'];
    value: Scalars['Float']['input'];
    zoneId: Scalars['ID']['input'];
};

export type CreateTokenResult = {
    __typename?: 'CreateTokenResult';
    sellerId: Scalars['String']['output'];
    token: Scalars['String']['output'];
    url: Scalars['String']['output'];
};

export type CreateWorkBrandInput = {
    asset: Scalars['ID']['input'];
    description?: InputMaybe<Scalars['String']['input']>;
    facetValueId?: InputMaybe<Scalars['ID']['input']>;
    name: Scalars['String']['input'];
    websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateZoneInput = {
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    memberIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    name: Scalars['String']['input'];
};

/**
 * @description
 * ISO 4217 currency code
 *
 * @docsCategory common
 */
export enum CurrencyCode {
    /** United Arab Emirates dirham */
    AED = 'AED',
    /** Afghan afghani */
    AFN = 'AFN',
    /** Albanian lek */
    ALL = 'ALL',
    /** Armenian dram */
    AMD = 'AMD',
    /** Netherlands Antillean guilder */
    ANG = 'ANG',
    /** Angolan kwanza */
    AOA = 'AOA',
    /** Argentine peso */
    ARS = 'ARS',
    /** Australian dollar */
    AUD = 'AUD',
    /** Aruban florin */
    AWG = 'AWG',
    /** Azerbaijani manat */
    AZN = 'AZN',
    /** Bosnia and Herzegovina convertible mark */
    BAM = 'BAM',
    /** Barbados dollar */
    BBD = 'BBD',
    /** Bangladeshi taka */
    BDT = 'BDT',
    /** Bulgarian lev */
    BGN = 'BGN',
    /** Bahraini dinar */
    BHD = 'BHD',
    /** Burundian franc */
    BIF = 'BIF',
    /** Bermudian dollar */
    BMD = 'BMD',
    /** Brunei dollar */
    BND = 'BND',
    /** Boliviano */
    BOB = 'BOB',
    /** Brazilian real */
    BRL = 'BRL',
    /** Bahamian dollar */
    BSD = 'BSD',
    /** Bhutanese ngultrum */
    BTN = 'BTN',
    /** Botswana pula */
    BWP = 'BWP',
    /** Belarusian ruble */
    BYN = 'BYN',
    /** Belize dollar */
    BZD = 'BZD',
    /** Canadian dollar */
    CAD = 'CAD',
    /** Congolese franc */
    CDF = 'CDF',
    /** Swiss franc */
    CHF = 'CHF',
    /** Chilean peso */
    CLP = 'CLP',
    /** Renminbi (Chinese) yuan */
    CNY = 'CNY',
    /** Colombian peso */
    COP = 'COP',
    /** Costa Rican colon */
    CRC = 'CRC',
    /** Cuban convertible peso */
    CUC = 'CUC',
    /** Cuban peso */
    CUP = 'CUP',
    /** Cape Verde escudo */
    CVE = 'CVE',
    /** Czech koruna */
    CZK = 'CZK',
    /** Djiboutian franc */
    DJF = 'DJF',
    /** Danish krone */
    DKK = 'DKK',
    /** Dominican peso */
    DOP = 'DOP',
    /** Algerian dinar */
    DZD = 'DZD',
    /** Egyptian pound */
    EGP = 'EGP',
    /** Eritrean nakfa */
    ERN = 'ERN',
    /** Ethiopian birr */
    ETB = 'ETB',
    /** Euro */
    EUR = 'EUR',
    /** Fiji dollar */
    FJD = 'FJD',
    /** Falkland Islands pound */
    FKP = 'FKP',
    /** Pound sterling */
    GBP = 'GBP',
    /** Georgian lari */
    GEL = 'GEL',
    /** Ghanaian cedi */
    GHS = 'GHS',
    /** Gibraltar pound */
    GIP = 'GIP',
    /** Gambian dalasi */
    GMD = 'GMD',
    /** Guinean franc */
    GNF = 'GNF',
    /** Guatemalan quetzal */
    GTQ = 'GTQ',
    /** Guyanese dollar */
    GYD = 'GYD',
    /** Hong Kong dollar */
    HKD = 'HKD',
    /** Honduran lempira */
    HNL = 'HNL',
    /** Croatian kuna */
    HRK = 'HRK',
    /** Haitian gourde */
    HTG = 'HTG',
    /** Hungarian forint */
    HUF = 'HUF',
    /** Indonesian rupiah */
    IDR = 'IDR',
    /** Israeli new shekel */
    ILS = 'ILS',
    /** Indian rupee */
    INR = 'INR',
    /** Iraqi dinar */
    IQD = 'IQD',
    /** Iranian rial */
    IRR = 'IRR',
    /** Icelandic króna */
    ISK = 'ISK',
    /** Jamaican dollar */
    JMD = 'JMD',
    /** Jordanian dinar */
    JOD = 'JOD',
    /** Japanese yen */
    JPY = 'JPY',
    /** Kenyan shilling */
    KES = 'KES',
    /** Kyrgyzstani som */
    KGS = 'KGS',
    /** Cambodian riel */
    KHR = 'KHR',
    /** Comoro franc */
    KMF = 'KMF',
    /** North Korean won */
    KPW = 'KPW',
    /** South Korean won */
    KRW = 'KRW',
    /** Kuwaiti dinar */
    KWD = 'KWD',
    /** Cayman Islands dollar */
    KYD = 'KYD',
    /** Kazakhstani tenge */
    KZT = 'KZT',
    /** Lao kip */
    LAK = 'LAK',
    /** Lebanese pound */
    LBP = 'LBP',
    /** Sri Lankan rupee */
    LKR = 'LKR',
    /** Liberian dollar */
    LRD = 'LRD',
    /** Lesotho loti */
    LSL = 'LSL',
    /** Libyan dinar */
    LYD = 'LYD',
    /** Moroccan dirham */
    MAD = 'MAD',
    /** Moldovan leu */
    MDL = 'MDL',
    /** Malagasy ariary */
    MGA = 'MGA',
    /** Macedonian denar */
    MKD = 'MKD',
    /** Myanmar kyat */
    MMK = 'MMK',
    /** Mongolian tögrög */
    MNT = 'MNT',
    /** Macanese pataca */
    MOP = 'MOP',
    /** Mauritanian ouguiya */
    MRU = 'MRU',
    /** Mauritian rupee */
    MUR = 'MUR',
    /** Maldivian rufiyaa */
    MVR = 'MVR',
    /** Malawian kwacha */
    MWK = 'MWK',
    /** Mexican peso */
    MXN = 'MXN',
    /** Malaysian ringgit */
    MYR = 'MYR',
    /** Mozambican metical */
    MZN = 'MZN',
    /** Namibian dollar */
    NAD = 'NAD',
    /** Nigerian naira */
    NGN = 'NGN',
    /** Nicaraguan córdoba */
    NIO = 'NIO',
    /** Norwegian krone */
    NOK = 'NOK',
    /** Nepalese rupee */
    NPR = 'NPR',
    /** New Zealand dollar */
    NZD = 'NZD',
    /** Omani rial */
    OMR = 'OMR',
    /** Panamanian balboa */
    PAB = 'PAB',
    /** Peruvian sol */
    PEN = 'PEN',
    /** Papua New Guinean kina */
    PGK = 'PGK',
    /** Philippine peso */
    PHP = 'PHP',
    /** Pakistani rupee */
    PKR = 'PKR',
    /** Polish złoty */
    PLN = 'PLN',
    /** Paraguayan guaraní */
    PYG = 'PYG',
    /** Qatari riyal */
    QAR = 'QAR',
    /** Romanian leu */
    RON = 'RON',
    /** Serbian dinar */
    RSD = 'RSD',
    /** Russian ruble */
    RUB = 'RUB',
    /** Rwandan franc */
    RWF = 'RWF',
    /** Saudi riyal */
    SAR = 'SAR',
    /** Solomon Islands dollar */
    SBD = 'SBD',
    /** Seychelles rupee */
    SCR = 'SCR',
    /** Sudanese pound */
    SDG = 'SDG',
    /** Swedish krona/kronor */
    SEK = 'SEK',
    /** Singapore dollar */
    SGD = 'SGD',
    /** Saint Helena pound */
    SHP = 'SHP',
    /** Sierra Leonean leone */
    SLL = 'SLL',
    /** Somali shilling */
    SOS = 'SOS',
    /** Surinamese dollar */
    SRD = 'SRD',
    /** South Sudanese pound */
    SSP = 'SSP',
    /** São Tomé and Príncipe dobra */
    STN = 'STN',
    /** Salvadoran colón */
    SVC = 'SVC',
    /** Syrian pound */
    SYP = 'SYP',
    /** Swazi lilangeni */
    SZL = 'SZL',
    /** Thai baht */
    THB = 'THB',
    /** Tajikistani somoni */
    TJS = 'TJS',
    /** Turkmenistan manat */
    TMT = 'TMT',
    /** Tunisian dinar */
    TND = 'TND',
    /** Tongan paʻanga */
    TOP = 'TOP',
    /** Turkish lira */
    TRY = 'TRY',
    /** Trinidad and Tobago dollar */
    TTD = 'TTD',
    /** New Taiwan dollar */
    TWD = 'TWD',
    /** Tanzanian shilling */
    TZS = 'TZS',
    /** Ukrainian hryvnia */
    UAH = 'UAH',
    /** Ugandan shilling */
    UGX = 'UGX',
    /** United States dollar */
    USD = 'USD',
    /** Uruguayan peso */
    UYU = 'UYU',
    /** Uzbekistan som */
    UZS = 'UZS',
    /** Venezuelan bolívar soberano */
    VES = 'VES',
    /** Vietnamese đồng */
    VND = 'VND',
    /** Vanuatu vatu */
    VUV = 'VUV',
    /** Samoan tala */
    WST = 'WST',
    /** CFA franc BEAC */
    XAF = 'XAF',
    /** East Caribbean dollar */
    XCD = 'XCD',
    /** CFA franc BCEAO */
    XOF = 'XOF',
    /** CFP franc (franc Pacifique) */
    XPF = 'XPF',
    /** Yemeni rial */
    YER = 'YER',
    /** South African rand */
    ZAR = 'ZAR',
    /** Zambian kwacha */
    ZMW = 'ZMW',
    /** Zimbabwean dollar */
    ZWL = 'ZWL',
}

export type CurrentUser = {
    __typename?: 'CurrentUser';
    channels: Array<CurrentUserChannel>;
    id: Scalars['ID']['output'];
    identifier: Scalars['String']['output'];
};

export type CurrentUserChannel = {
    __typename?: 'CurrentUserChannel';
    code: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    permissions: Array<Permission>;
    token: Scalars['String']['output'];
};

export type CustomField = {
    description?: Maybe<Array<LocalizedString>>;
    internal?: Maybe<Scalars['Boolean']['output']>;
    label?: Maybe<Array<LocalizedString>>;
    list: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    nullable?: Maybe<Scalars['Boolean']['output']>;
    readonly?: Maybe<Scalars['Boolean']['output']>;
    requiresPermission?: Maybe<Array<Permission>>;
    type: Scalars['String']['output'];
    ui?: Maybe<Scalars['JSON']['output']>;
};

export type CustomFieldConfig =
    | BooleanCustomFieldConfig
    | DateTimeCustomFieldConfig
    | FloatCustomFieldConfig
    | IntCustomFieldConfig
    | LocaleStringCustomFieldConfig
    | LocaleTextCustomFieldConfig
    | RelationCustomFieldConfig
    | StringCustomFieldConfig
    | StructCustomFieldConfig
    | TextCustomFieldConfig;

/**
 * This type is deprecated in v2.2 in favor of the EntityCustomFields type,
 * which allows custom fields to be defined on user-supplied entities.
 */
export type CustomFields = {
    __typename?: 'CustomFields';
    Address: Array<CustomFieldConfig>;
    Administrator: Array<CustomFieldConfig>;
    Asset: Array<CustomFieldConfig>;
    Channel: Array<CustomFieldConfig>;
    Collection: Array<CustomFieldConfig>;
    Customer: Array<CustomFieldConfig>;
    CustomerGroup: Array<CustomFieldConfig>;
    Facet: Array<CustomFieldConfig>;
    FacetValue: Array<CustomFieldConfig>;
    Fulfillment: Array<CustomFieldConfig>;
    GlobalSettings: Array<CustomFieldConfig>;
    HistoryEntry: Array<CustomFieldConfig>;
    Order: Array<CustomFieldConfig>;
    OrderLine: Array<CustomFieldConfig>;
    Payment: Array<CustomFieldConfig>;
    PaymentMethod: Array<CustomFieldConfig>;
    Product: Array<CustomFieldConfig>;
    ProductOption: Array<CustomFieldConfig>;
    ProductOptionGroup: Array<CustomFieldConfig>;
    ProductVariant: Array<CustomFieldConfig>;
    ProductVariantPrice: Array<CustomFieldConfig>;
    Promotion: Array<CustomFieldConfig>;
    Refund: Array<CustomFieldConfig>;
    Region: Array<CustomFieldConfig>;
    Seller: Array<CustomFieldConfig>;
    Session: Array<CustomFieldConfig>;
    ShippingLine: Array<CustomFieldConfig>;
    ShippingMethod: Array<CustomFieldConfig>;
    StockLevel: Array<CustomFieldConfig>;
    StockLocation: Array<CustomFieldConfig>;
    StockMovement: Array<CustomFieldConfig>;
    TaxCategory: Array<CustomFieldConfig>;
    TaxRate: Array<CustomFieldConfig>;
    User: Array<CustomFieldConfig>;
    Zone: Array<CustomFieldConfig>;
};

export type Customer = Node & {
    __typename?: 'Customer';
    addresses?: Maybe<Array<Address>>;
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<CustomerCustomFields>;
    emailAddress: Scalars['String']['output'];
    firstName: Scalars['String']['output'];
    groups: Array<CustomerGroup>;
    history: HistoryEntryList;
    id: Scalars['ID']['output'];
    lastName: Scalars['String']['output'];
    normalizeAccountStatus: NormalizeAccountStatus;
    orders: OrderList;
    phoneNumber?: Maybe<Scalars['String']['output']>;
    preferredPaymentExist: Scalars['Boolean']['output'];
    title?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTime']['output'];
    user?: Maybe<User>;
};

export type CustomerHistoryArgs = {
    options?: InputMaybe<HistoryEntryListOptions>;
};

export type CustomerOrdersArgs = {
    options?: InputMaybe<OrderListOptions>;
};

export type CustomerCustomFields = {
    __typename?: 'CustomerCustomFields';
    acceptTerms?: Maybe<Scalars['Boolean']['output']>;
    avatar?: Maybe<Asset>;
    birthDate?: Maybe<Scalars['String']['output']>;
    businessLine?: Maybe<Scalars['String']['output']>;
    businessPhone?: Maybe<Scalars['String']['output']>;
    cellphone?: Maybe<Scalars['String']['output']>;
    channelFindOut?: Maybe<Scalars['String']['output']>;
    companyName?: Maybe<Scalars['String']['output']>;
    document?: Maybe<Scalars['String']['output']>;
    emailForInvoice?: Maybe<Scalars['String']['output']>;
    establishmentImage?: Maybe<Asset>;
    establishmentSize?: Maybe<Scalars['String']['output']>;
    exemptStateRegistration?: Maybe<Scalars['Boolean']['output']>;
    externalId?: Maybe<Scalars['String']['output']>;
    nationalRegistry?: Maybe<Scalars['String']['output']>;
    nationalRegistryIssuer?: Maybe<Scalars['String']['output']>;
    nickName?: Maybe<Scalars['String']['output']>;
    numberOfBoxes?: Maybe<Scalars['Int']['output']>;
    ownersDocument?: Maybe<Scalars['String']['output']>;
    pagarmeCustomerId?: Maybe<Scalars['String']['output']>;
    profileAnalysis?: Maybe<Scalars['String']['output']>;
    proofOfResidence?: Maybe<Asset>;
    purchaseApproved?: Maybe<Scalars['Boolean']['output']>;
    sellerPortfolios?: Maybe<Array<SellerCustomerPortfolio>>;
    serviceRegion?: Maybe<Scalars['String']['output']>;
    stateRegistration?: Maybe<Scalars['String']['output']>;
    tradeName?: Maybe<Scalars['String']['output']>;
    visibility?: Maybe<Array<CustomerVisibilityStruct>>;
};

export type CustomerFilterParameter = {
    _and?: InputMaybe<Array<CustomerFilterParameter>>;
    _or?: InputMaybe<Array<CustomerFilterParameter>>;
    acceptTerms?: InputMaybe<BooleanOperators>;
    birthDate?: InputMaybe<StringOperators>;
    businessLine?: InputMaybe<StringOperators>;
    businessPhone?: InputMaybe<StringOperators>;
    cellphone?: InputMaybe<StringOperators>;
    channelFindOut?: InputMaybe<StringOperators>;
    companyName?: InputMaybe<StringOperators>;
    createdAt?: InputMaybe<DateOperators>;
    document?: InputMaybe<StringOperators>;
    emailAddress?: InputMaybe<StringOperators>;
    emailForInvoice?: InputMaybe<StringOperators>;
    establishmentSize?: InputMaybe<StringOperators>;
    exemptStateRegistration?: InputMaybe<BooleanOperators>;
    externalId?: InputMaybe<StringOperators>;
    firstName?: InputMaybe<StringOperators>;
    id?: InputMaybe<IdOperators>;
    lastName?: InputMaybe<StringOperators>;
    nationalRegistry?: InputMaybe<StringOperators>;
    nationalRegistryIssuer?: InputMaybe<StringOperators>;
    nickName?: InputMaybe<StringOperators>;
    numberOfBoxes?: InputMaybe<NumberOperators>;
    ownersDocument?: InputMaybe<StringOperators>;
    pagarmeCustomerId?: InputMaybe<StringOperators>;
    phoneNumber?: InputMaybe<StringOperators>;
    postalCode?: InputMaybe<StringOperators>;
    preferredPaymentExist?: InputMaybe<BooleanOperators>;
    profileAnalysis?: InputMaybe<StringOperators>;
    purchaseApproved?: InputMaybe<BooleanOperators>;
    serviceRegion?: InputMaybe<StringOperators>;
    stateRegistration?: InputMaybe<StringOperators>;
    title?: InputMaybe<StringOperators>;
    tradeName?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type CustomerGroup = Node & {
    __typename?: 'CustomerGroup';
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<Scalars['JSON']['output']>;
    customers: CustomerList;
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type CustomerGroupCustomersArgs = {
    options?: InputMaybe<CustomerListOptions>;
};

export type CustomerGroupFilterParameter = {
    _and?: InputMaybe<Array<CustomerGroupFilterParameter>>;
    _or?: InputMaybe<Array<CustomerGroupFilterParameter>>;
    createdAt?: InputMaybe<DateOperators>;
    id?: InputMaybe<IdOperators>;
    name?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type CustomerGroupList = PaginatedList & {
    __typename?: 'CustomerGroupList';
    items: Array<CustomerGroup>;
    totalItems: Scalars['Int']['output'];
};

export type CustomerGroupListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<CustomerGroupFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<CustomerGroupSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerGroupSortParameter = {
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type CustomerList = PaginatedList & {
    __typename?: 'CustomerList';
    items: Array<Customer>;
    totalItems: Scalars['Int']['output'];
};

export type CustomerListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<CustomerFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<CustomerSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerProductVisibilityResult = {
    __typename?: 'CustomerProductVisibilityResult';
    channelId: Scalars['ID']['output'];
    customerId: Scalars['ID']['output'];
    isVisible: Scalars['Boolean']['output'];
    productVariantId: Scalars['ID']['output'];
};

export type CustomerPromotion = {
    __typename?: 'CustomerPromotion';
    createdAt: Scalars['DateTime']['output'];
    customer: Customer;
    customerId?: Maybe<Scalars['ID']['output']>;
    id: Scalars['ID']['output'];
    promotion: Promotion;
    promotionId?: Maybe<Scalars['ID']['output']>;
    qtPurchased: Scalars['Int']['output'];
    specialPromotionIndex?: Maybe<SpecialPromotionIndex>;
    specialPromotionIndexId?: Maybe<Scalars['ID']['output']>;
    status: CustomerPromotionStatus;
    updatedAt: Scalars['DateTime']['output'];
    valuePurchasedWithDiscount?: Maybe<Scalars['Int']['output']>;
    valuePurchasedWithoutDiscount?: Maybe<Scalars['Int']['output']>;
};

export enum CustomerPromotionStatus {
    active = 'active',
    completed = 'completed',
    expired = 'expired',
}

export type CustomerSortParameter = {
    acceptTerms?: InputMaybe<SortOrder>;
    avatar?: InputMaybe<SortOrder>;
    birthDate?: InputMaybe<SortOrder>;
    businessLine?: InputMaybe<SortOrder>;
    businessPhone?: InputMaybe<SortOrder>;
    cellphone?: InputMaybe<SortOrder>;
    channelFindOut?: InputMaybe<SortOrder>;
    companyName?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    document?: InputMaybe<SortOrder>;
    emailAddress?: InputMaybe<SortOrder>;
    emailForInvoice?: InputMaybe<SortOrder>;
    establishmentImage?: InputMaybe<SortOrder>;
    establishmentSize?: InputMaybe<SortOrder>;
    exemptStateRegistration?: InputMaybe<SortOrder>;
    externalId?: InputMaybe<SortOrder>;
    firstName?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrder>;
    nationalRegistry?: InputMaybe<SortOrder>;
    nationalRegistryIssuer?: InputMaybe<SortOrder>;
    nickName?: InputMaybe<SortOrder>;
    numberOfBoxes?: InputMaybe<SortOrder>;
    ownersDocument?: InputMaybe<SortOrder>;
    pagarmeCustomerId?: InputMaybe<SortOrder>;
    phoneNumber?: InputMaybe<SortOrder>;
    profileAnalysis?: InputMaybe<SortOrder>;
    proofOfResidence?: InputMaybe<SortOrder>;
    purchaseApproved?: InputMaybe<SortOrder>;
    serviceRegion?: InputMaybe<SortOrder>;
    stateRegistration?: InputMaybe<SortOrder>;
    title?: InputMaybe<SortOrder>;
    tradeName?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type CustomerVisibilityStruct = {
    __typename?: 'CustomerVisibilityStruct';
    channelId?: Maybe<Scalars['String']['output']>;
    code?: Maybe<Scalars['String']['output']>;
};

export type CustomerVisibilityStructInput = {
    channelId?: InputMaybe<Scalars['String']['input']>;
    code?: InputMaybe<Scalars['String']['input']>;
};

/** Operators for filtering on a list of Date fields */
export type DateListOperators = {
    inList: Scalars['DateTime']['input'];
};

/** Operators for filtering on a DateTime field */
export type DateOperators = {
    after?: InputMaybe<Scalars['DateTime']['input']>;
    before?: InputMaybe<Scalars['DateTime']['input']>;
    between?: InputMaybe<DateRange>;
    eq?: InputMaybe<Scalars['DateTime']['input']>;
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DateRange = {
    end: Scalars['DateTime']['input'];
    start: Scalars['DateTime']['input'];
};

/**
 * Expects the same validation formats as the `<input type="datetime-local">` HTML element.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/datetime-local#Additional_attributes
 */
export type DateTimeCustomFieldConfig = CustomField & {
    __typename?: 'DateTimeCustomFieldConfig';
    description?: Maybe<Array<LocalizedString>>;
    internal?: Maybe<Scalars['Boolean']['output']>;
    label?: Maybe<Array<LocalizedString>>;
    list: Scalars['Boolean']['output'];
    max?: Maybe<Scalars['String']['output']>;
    min?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    nullable?: Maybe<Scalars['Boolean']['output']>;
    readonly?: Maybe<Scalars['Boolean']['output']>;
    requiresPermission?: Maybe<Array<Permission>>;
    step?: Maybe<Scalars['Int']['output']>;
    type: Scalars['String']['output'];
    ui?: Maybe<Scalars['JSON']['output']>;
};

/**
 * Expects the same validation formats as the `<input type="datetime-local">` HTML element.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/datetime-local#Additional_attributes
 */
export type DateTimeStructFieldConfig = StructField & {
    __typename?: 'DateTimeStructFieldConfig';
    description?: Maybe<Array<LocalizedString>>;
    label?: Maybe<Array<LocalizedString>>;
    list: Scalars['Boolean']['output'];
    max?: Maybe<Scalars['String']['output']>;
    min?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    step?: Maybe<Scalars['Int']['output']>;
    type: Scalars['String']['output'];
    ui?: Maybe<Scalars['JSON']['output']>;
};

export type DeleteAssetInput = {
    assetId: Scalars['ID']['input'];
    deleteFromAllChannels?: InputMaybe<Scalars['Boolean']['input']>;
    force?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteAssetsInput = {
    assetIds: Array<Scalars['ID']['input']>;
    deleteFromAllChannels?: InputMaybe<Scalars['Boolean']['input']>;
    force?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeletePricesForVariantResult = PriceSyncError | Success;

export type DeleteStockLocationInput = {
    id: Scalars['ID']['input'];
    transferToLocationId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeletionResponse = {
    __typename?: 'DeletionResponse';
    message?: Maybe<Scalars['String']['output']>;
    result: DeletionResult;
};

export enum DeletionResult {
    /** The entity was successfully deleted */
    DELETED = 'DELETED',
    /** Deletion did not take place, reason given in message */
    NOT_DELETED = 'NOT_DELETED',
}

export type Discount = {
    __typename?: 'Discount';
    adjustmentSource: Scalars['String']['output'];
    amount: Scalars['Money']['output'];
    amountWithTax: Scalars['Money']['output'];
    description: Scalars['String']['output'];
    type: AdjustmentType;
};

export enum DistanceUnit {
    cm = 'cm',
    ft = 'ft',
    in = 'in',
}

export type DuplicateEntityError = ErrorResult & {
    __typename?: 'DuplicateEntityError';
    duplicationError: Scalars['String']['output'];
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

export type DuplicateEntityInput = {
    duplicatorInput: ConfigurableOperationInput;
    entityId: Scalars['ID']['input'];
    entityName: Scalars['String']['input'];
};

export type DuplicateEntityResult =
    | DuplicateEntityError
    | DuplicateEntitySuccess;

export type DuplicateEntitySuccess = {
    __typename?: 'DuplicateEntitySuccess';
    newEntityId: Scalars['ID']['output'];
};

export type Email = Node & {
    __typename?: 'Email';
    createdAt: Scalars['DateTime']['output'];
    email: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type EmailAddInput = {
    email: Scalars['String']['input'];
    name: Scalars['String']['input'];
};

/** Returned when attempting to create a Customer with an email address already registered to an existing User. */
export type EmailAddressConflictError = ErrorResult & {
    __typename?: 'EmailAddressConflictError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

export type EmailFilterParameter = {
    _and?: InputMaybe<Array<EmailFilterParameter>>;
    _or?: InputMaybe<Array<EmailFilterParameter>>;
    createdAt?: InputMaybe<DateOperators>;
    email?: InputMaybe<StringOperators>;
    id?: InputMaybe<IdOperators>;
    name?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type EmailList = PaginatedList & {
    __typename?: 'EmailList';
    items: Array<Email>;
    totalItems: Scalars['Int']['output'];
};

export type EmailListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<EmailFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<EmailSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type EmailSortParameter = {
    createdAt?: InputMaybe<SortOrder>;
    email?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EmailUpdateInput = {
    email: Scalars['String']['input'];
    id: Scalars['ID']['input'];
    name: Scalars['String']['input'];
};

/** Returned if no OrderLines have been specified for the operation */
export type EmptyOrderLineSelectionError = ErrorResult & {
    __typename?: 'EmptyOrderLineSelectionError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

export type EntityCustomFields = {
    __typename?: 'EntityCustomFields';
    customFields: Array<CustomFieldConfig>;
    entityName: Scalars['String']['output'];
};

export type EntityDuplicatorDefinition = {
    __typename?: 'EntityDuplicatorDefinition';
    args: Array<ConfigArgDefinition>;
    code: Scalars['String']['output'];
    description: Scalars['String']['output'];
    forEntities: Array<Scalars['String']['output']>;
    requiresPermission: Array<Permission>;
};

export type Error = {
    __typename?: 'Error';
    errors?: Maybe<Scalars['JSON']['output']>;
    message: Scalars['String']['output'];
};

export enum ErrorCode {
    ADD_BULK_ITEMS_TO_SHOPPING_LIST_ERROR = 'ADD_BULK_ITEMS_TO_SHOPPING_LIST_ERROR',
    ALREADY_REFUNDED_ERROR = 'ALREADY_REFUNDED_ERROR',
    ASSOCIATE_ALL_BUYERS_WITH_SHOPPING_LIST_ERROR = 'ASSOCIATE_ALL_BUYERS_WITH_SHOPPING_LIST_ERROR',
    ASSOCIATE_BUYERS_WITH_SHOPPING_LIST_ERROR = 'ASSOCIATE_BUYERS_WITH_SHOPPING_LIST_ERROR',
    CANCEL_ACTIVE_ORDER_ERROR = 'CANCEL_ACTIVE_ORDER_ERROR',
    CANCEL_PAYMENT_ERROR = 'CANCEL_PAYMENT_ERROR',
    CHANNEL_DEFAULT_LANGUAGE_ERROR = 'CHANNEL_DEFAULT_LANGUAGE_ERROR',
    COUPON_CODE_EXPIRED_ERROR = 'COUPON_CODE_EXPIRED_ERROR',
    COUPON_CODE_INVALID_ERROR = 'COUPON_CODE_INVALID_ERROR',
    COUPON_CODE_LIMIT_ERROR = 'COUPON_CODE_LIMIT_ERROR',
    CREATE_FULFILLMENT_ERROR = 'CREATE_FULFILLMENT_ERROR',
    CREATE_SHOPPING_LIST_ERROR = 'CREATE_SHOPPING_LIST_ERROR',
    DUPLICATE_ENTITY_ERROR = 'DUPLICATE_ENTITY_ERROR',
    EMAIL_ADDRESS_CONFLICT_ERROR = 'EMAIL_ADDRESS_CONFLICT_ERROR',
    EMPTY_ORDER_LINE_SELECTION_ERROR = 'EMPTY_ORDER_LINE_SELECTION_ERROR',
    FACET_IN_USE_ERROR = 'FACET_IN_USE_ERROR',
    FULFILLMENT_STATE_TRANSITION_ERROR = 'FULFILLMENT_STATE_TRANSITION_ERROR',
    GUEST_CHECKOUT_ERROR = 'GUEST_CHECKOUT_ERROR',
    INELIGIBLE_SHIPPING_METHOD_ERROR = 'INELIGIBLE_SHIPPING_METHOD_ERROR',
    INSUFFICIENT_STOCK_ERROR = 'INSUFFICIENT_STOCK_ERROR',
    INSUFFICIENT_STOCK_ON_HAND_ERROR = 'INSUFFICIENT_STOCK_ON_HAND_ERROR',
    INVALID_CREDENTIALS_ERROR = 'INVALID_CREDENTIALS_ERROR',
    INVALID_FULFILLMENT_HANDLER_ERROR = 'INVALID_FULFILLMENT_HANDLER_ERROR',
    ITEMS_ALREADY_FULFILLED_ERROR = 'ITEMS_ALREADY_FULFILLED_ERROR',
    LANGUAGE_NOT_AVAILABLE_ERROR = 'LANGUAGE_NOT_AVAILABLE_ERROR',
    MANUAL_PAYMENT_STATE_ERROR = 'MANUAL_PAYMENT_STATE_ERROR',
    MIME_TYPE_ERROR = 'MIME_TYPE_ERROR',
    MISSING_CONDITIONS_ERROR = 'MISSING_CONDITIONS_ERROR',
    MULTIPLE_ORDER_ERROR = 'MULTIPLE_ORDER_ERROR',
    NATIVE_AUTH_STRATEGY_ERROR = 'NATIVE_AUTH_STRATEGY_ERROR',
    NEGATIVE_QUANTITY_ERROR = 'NEGATIVE_QUANTITY_ERROR',
    NOTHING_TO_REFUND_ERROR = 'NOTHING_TO_REFUND_ERROR',
    NO_ACTIVE_ORDER_ERROR = 'NO_ACTIVE_ORDER_ERROR',
    NO_CHANGES_SPECIFIED_ERROR = 'NO_CHANGES_SPECIFIED_ERROR',
    ORDER_INTERCEPTOR_ERROR = 'ORDER_INTERCEPTOR_ERROR',
    ORDER_LIMIT_ERROR = 'ORDER_LIMIT_ERROR',
    ORDER_MODIFICATION_ERROR = 'ORDER_MODIFICATION_ERROR',
    ORDER_MODIFICATION_STATE_ERROR = 'ORDER_MODIFICATION_STATE_ERROR',
    ORDER_STATE_TRANSITION_ERROR = 'ORDER_STATE_TRANSITION_ERROR',
    PAYMENT_METHOD_MISSING_ERROR = 'PAYMENT_METHOD_MISSING_ERROR',
    PAYMENT_ORDER_MISMATCH_ERROR = 'PAYMENT_ORDER_MISMATCH_ERROR',
    PAYMENT_STATE_TRANSITION_ERROR = 'PAYMENT_STATE_TRANSITION_ERROR',
    PRODUCT_OPTION_IN_USE_ERROR = 'PRODUCT_OPTION_IN_USE_ERROR',
    QUANTITY_TOO_GREAT_ERROR = 'QUANTITY_TOO_GREAT_ERROR',
    REFUND_AMOUNT_ERROR = 'REFUND_AMOUNT_ERROR',
    REFUND_ORDER_STATE_ERROR = 'REFUND_ORDER_STATE_ERROR',
    REFUND_PAYMENT_ID_MISSING_ERROR = 'REFUND_PAYMENT_ID_MISSING_ERROR',
    REFUND_STATE_TRANSITION_ERROR = 'REFUND_STATE_TRANSITION_ERROR',
    REMOVE_SHOPPING_LISTS_ERROR = 'REMOVE_SHOPPING_LISTS_ERROR',
    SETTLE_PAYMENT_ERROR = 'SETTLE_PAYMENT_ERROR',
    UNKNOWN_ERROR = 'UNKNOWN_ERROR',
    UPDATE_SHOPPING_LIST_ERROR = 'UPDATE_SHOPPING_LIST_ERROR',
}

export type ErrorResult = {
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

export type ErrorsAccountStatus = {
    __typename?: 'ErrorsAccountStatus';
    message: Scalars['String']['output'];
    type: Scalars['String']['output'];
};

export type Facet = Node & {
    __typename?: 'Facet';
    code: Scalars['String']['output'];
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<FacetCustomFields>;
    id: Scalars['ID']['output'];
    isPrivate: Scalars['Boolean']['output'];
    languageCode: LanguageCode;
    name: Scalars['String']['output'];
    translations: Array<FacetTranslation>;
    updatedAt: Scalars['DateTime']['output'];
    /** Returns a paginated, sortable, filterable list of the Facet's values. Added in v2.1.0. */
    valueList: FacetValueList;
    values: Array<FacetValue>;
};

export type FacetValueListArgs = {
    options?: InputMaybe<FacetValueListOptions>;
};

export type FacetCustomFields = {
    __typename?: 'FacetCustomFields';
    externalId?: Maybe<Scalars['String']['output']>;
};

export type FacetFilterParameter = {
    _and?: InputMaybe<Array<FacetFilterParameter>>;
    _or?: InputMaybe<Array<FacetFilterParameter>>;
    code?: InputMaybe<StringOperators>;
    createdAt?: InputMaybe<DateOperators>;
    externalId?: InputMaybe<StringOperators>;
    id?: InputMaybe<IdOperators>;
    isPrivate?: InputMaybe<BooleanOperators>;
    languageCode?: InputMaybe<StringOperators>;
    name?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type FacetInUseError = ErrorResult & {
    __typename?: 'FacetInUseError';
    errorCode: ErrorCode;
    facetCode: Scalars['String']['output'];
    message: Scalars['String']['output'];
    productCount: Scalars['Int']['output'];
    variantCount: Scalars['Int']['output'];
};

export type FacetList = PaginatedList & {
    __typename?: 'FacetList';
    items: Array<Facet>;
    totalItems: Scalars['Int']['output'];
};

export type FacetListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<FacetFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<FacetSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type FacetSortParameter = {
    code?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    externalId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type FacetTranslation = {
    __typename?: 'FacetTranslation';
    createdAt: Scalars['DateTime']['output'];
    id: Scalars['ID']['output'];
    languageCode: LanguageCode;
    name: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type FacetTranslationInput = {
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    languageCode: LanguageCode;
    name?: InputMaybe<Scalars['String']['input']>;
};

export type FacetValue = Node & {
    __typename?: 'FacetValue';
    code: Scalars['String']['output'];
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<FacetValueCustomFields>;
    facet: Facet;
    facetId: Scalars['ID']['output'];
    id: Scalars['ID']['output'];
    languageCode: LanguageCode;
    name: Scalars['String']['output'];
    translations: Array<FacetValueTranslation>;
    updatedAt: Scalars['DateTime']['output'];
};

export type FacetValueCustomFields = {
    __typename?: 'FacetValueCustomFields';
    externalId?: Maybe<Scalars['String']['output']>;
};

/**
 * Used to construct boolean expressions for filtering search results
 * by FacetValue ID. Examples:
 *
 * * ID=1 OR ID=2: `{ facetValueFilters: [{ or: [1,2] }] }`
 * * ID=1 AND ID=2: `{ facetValueFilters: [{ and: 1 }, { and: 2 }] }`
 * * ID=1 AND (ID=2 OR ID=3): `{ facetValueFilters: [{ and: 1 }, { or: [2,3] }] }`
 */
export type FacetValueFilterInput = {
    and?: InputMaybe<Scalars['ID']['input']>;
    or?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type FacetValueFilterParameter = {
    _and?: InputMaybe<Array<FacetValueFilterParameter>>;
    _or?: InputMaybe<Array<FacetValueFilterParameter>>;
    code?: InputMaybe<StringOperators>;
    createdAt?: InputMaybe<DateOperators>;
    externalId?: InputMaybe<StringOperators>;
    facetId?: InputMaybe<IdOperators>;
    id?: InputMaybe<IdOperators>;
    languageCode?: InputMaybe<StringOperators>;
    name?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type FacetValueList = PaginatedList & {
    __typename?: 'FacetValueList';
    items: Array<FacetValue>;
    totalItems: Scalars['Int']['output'];
};

export type FacetValueListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<FacetValueFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<FacetValueSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Which FacetValues are present in the products returned
 * by the search, and in what quantity.
 */
export type FacetValueResult = {
    __typename?: 'FacetValueResult';
    count: Scalars['Int']['output'];
    facetValue: FacetValue;
};

export type FacetValueSortParameter = {
    code?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    externalId?: InputMaybe<SortOrder>;
    facetId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type FacetValueTranslation = {
    __typename?: 'FacetValueTranslation';
    createdAt: Scalars['DateTime']['output'];
    id: Scalars['ID']['output'];
    languageCode: LanguageCode;
    name: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type FacetValueTranslationInput = {
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    languageCode: LanguageCode;
    name?: InputMaybe<Scalars['String']['input']>;
};

export type FloatCustomFieldConfig = CustomField & {
    __typename?: 'FloatCustomFieldConfig';
    description?: Maybe<Array<LocalizedString>>;
    internal?: Maybe<Scalars['Boolean']['output']>;
    label?: Maybe<Array<LocalizedString>>;
    list: Scalars['Boolean']['output'];
    max?: Maybe<Scalars['Float']['output']>;
    min?: Maybe<Scalars['Float']['output']>;
    name: Scalars['String']['output'];
    nullable?: Maybe<Scalars['Boolean']['output']>;
    readonly?: Maybe<Scalars['Boolean']['output']>;
    requiresPermission?: Maybe<Array<Permission>>;
    step?: Maybe<Scalars['Float']['output']>;
    type: Scalars['String']['output'];
    ui?: Maybe<Scalars['JSON']['output']>;
};

export type FloatStructFieldConfig = StructField & {
    __typename?: 'FloatStructFieldConfig';
    description?: Maybe<Array<LocalizedString>>;
    label?: Maybe<Array<LocalizedString>>;
    list: Scalars['Boolean']['output'];
    max?: Maybe<Scalars['Float']['output']>;
    min?: Maybe<Scalars['Float']['output']>;
    name: Scalars['String']['output'];
    step?: Maybe<Scalars['Float']['output']>;
    type: Scalars['String']['output'];
    ui?: Maybe<Scalars['JSON']['output']>;
};

export type FulfillOrderInput = {
    handler: ConfigurableOperationInput;
    lines: Array<OrderLineInput>;
};

export type Fulfillment = Node & {
    __typename?: 'Fulfillment';
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<Scalars['JSON']['output']>;
    id: Scalars['ID']['output'];
    lines: Array<FulfillmentLine>;
    method: Scalars['String']['output'];
    nextStates: Array<Scalars['String']['output']>;
    state: Scalars['String']['output'];
    /** @deprecated Use the `lines` field instead */
    summary: Array<FulfillmentLine>;
    trackingCode?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTime']['output'];
};

export type FulfillmentLine = {
    __typename?: 'FulfillmentLine';
    fulfillment: Fulfillment;
    fulfillmentId: Scalars['ID']['output'];
    orderLine: OrderLine;
    orderLineId: Scalars['ID']['output'];
    quantity: Scalars['Int']['output'];
};

/** Returned when there is an error in transitioning the Fulfillment state */
export type FulfillmentStateTransitionError = ErrorResult & {
    __typename?: 'FulfillmentStateTransitionError';
    errorCode: ErrorCode;
    fromState: Scalars['String']['output'];
    message: Scalars['String']['output'];
    toState: Scalars['String']['output'];
    transitionError: Scalars['String']['output'];
};

export type GatewayRecipient = {
    __typename?: 'GatewayRecipient';
    createdAt?: Maybe<Scalars['String']['output']>;
    gateway?: Maybe<Scalars['String']['output']>;
    pgid?: Maybe<Scalars['String']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['String']['output']>;
};

export enum GlobalFlag {
    FALSE = 'FALSE',
    INHERIT = 'INHERIT',
    TRUE = 'TRUE',
}

export type GlobalSettings = {
    __typename?: 'GlobalSettings';
    availableLanguages: Array<LanguageCode>;
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<GlobalSettingsCustomFields>;
    id: Scalars['ID']['output'];
    outOfStockThreshold: Scalars['Int']['output'];
    serverConfig: ServerConfig;
    trackInventory: Scalars['Boolean']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type GlobalSettingsCustomFields = {
    __typename?: 'GlobalSettingsCustomFields';
    retryCount?: Maybe<Scalars['Int']['output']>;
    retryDelay?: Maybe<Scalars['Int']['output']>;
    retryInterval?: Maybe<Scalars['Int']['output']>;
};

/** Returned when attempting to set the Customer on a guest checkout when the configured GuestCheckoutStrategy does not allow it. */
export type GuestCheckoutError = ErrorResult & {
    __typename?: 'GuestCheckoutError';
    errorCode: ErrorCode;
    errorDetail: Scalars['String']['output'];
    message: Scalars['String']['output'];
};

export type HistoryEntry = Node & {
    __typename?: 'HistoryEntry';
    administrator?: Maybe<Administrator>;
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<Scalars['JSON']['output']>;
    data: Scalars['JSON']['output'];
    id: Scalars['ID']['output'];
    isPublic: Scalars['Boolean']['output'];
    type: HistoryEntryType;
    updatedAt: Scalars['DateTime']['output'];
};

export type HistoryEntryFilterParameter = {
    _and?: InputMaybe<Array<HistoryEntryFilterParameter>>;
    _or?: InputMaybe<Array<HistoryEntryFilterParameter>>;
    createdAt?: InputMaybe<DateOperators>;
    id?: InputMaybe<IdOperators>;
    isPublic?: InputMaybe<BooleanOperators>;
    type?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type HistoryEntryList = PaginatedList & {
    __typename?: 'HistoryEntryList';
    items: Array<HistoryEntry>;
    totalItems: Scalars['Int']['output'];
};

export type HistoryEntryListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<HistoryEntryFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<HistoryEntrySortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type HistoryEntrySortParameter = {
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum HistoryEntryType {
    CUSTOMER_ADDED_TO_GROUP = 'CUSTOMER_ADDED_TO_GROUP',
    CUSTOMER_ADDRESS_CREATED = 'CUSTOMER_ADDRESS_CREATED',
    CUSTOMER_ADDRESS_DELETED = 'CUSTOMER_ADDRESS_DELETED',
    CUSTOMER_ADDRESS_UPDATED = 'CUSTOMER_ADDRESS_UPDATED',
    CUSTOMER_DETAIL_UPDATED = 'CUSTOMER_DETAIL_UPDATED',
    CUSTOMER_EMAIL_UPDATE_REQUESTED = 'CUSTOMER_EMAIL_UPDATE_REQUESTED',
    CUSTOMER_EMAIL_UPDATE_VERIFIED = 'CUSTOMER_EMAIL_UPDATE_VERIFIED',
    CUSTOMER_NOTE = 'CUSTOMER_NOTE',
    CUSTOMER_PASSWORD_RESET_REQUESTED = 'CUSTOMER_PASSWORD_RESET_REQUESTED',
    CUSTOMER_PASSWORD_RESET_VERIFIED = 'CUSTOMER_PASSWORD_RESET_VERIFIED',
    CUSTOMER_PASSWORD_UPDATED = 'CUSTOMER_PASSWORD_UPDATED',
    CUSTOMER_REGISTERED = 'CUSTOMER_REGISTERED',
    CUSTOMER_REMOVED_FROM_GROUP = 'CUSTOMER_REMOVED_FROM_GROUP',
    CUSTOMER_VERIFIED = 'CUSTOMER_VERIFIED',
    ORDER_CANCELLATION = 'ORDER_CANCELLATION',
    ORDER_COUPON_APPLIED = 'ORDER_COUPON_APPLIED',
    ORDER_COUPON_REMOVED = 'ORDER_COUPON_REMOVED',
    ORDER_CUSTOMER_UPDATED = 'ORDER_CUSTOMER_UPDATED',
    ORDER_FULFILLMENT = 'ORDER_FULFILLMENT',
    ORDER_FULFILLMENT_TRANSITION = 'ORDER_FULFILLMENT_TRANSITION',
    ORDER_MODIFIED = 'ORDER_MODIFIED',
    ORDER_NOTE = 'ORDER_NOTE',
    ORDER_PAYMENT_TRANSITION = 'ORDER_PAYMENT_TRANSITION',
    ORDER_REFUND_TRANSITION = 'ORDER_REFUND_TRANSITION',
    ORDER_STATE_TRANSITION = 'ORDER_STATE_TRANSITION',
}

/** Operators for filtering on a list of ID fields */
export type IdListOperators = {
    inList: Scalars['ID']['input'];
};

/** Operators for filtering on an ID field */
export type IdOperators = {
    eq?: InputMaybe<Scalars['String']['input']>;
    in?: InputMaybe<Array<Scalars['String']['input']>>;
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
    notEq?: InputMaybe<Scalars['String']['input']>;
    notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ImportInfo = {
    __typename?: 'ImportInfo';
    errors?: Maybe<Array<Scalars['String']['output']>>;
    imported: Scalars['Int']['output'];
    processed: Scalars['Int']['output'];
};

/** Returned when attempting to set a ShippingMethod for which the Order is not eligible */
export type IneligibleShippingMethodError = ErrorResult & {
    __typename?: 'IneligibleShippingMethodError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

/** Returned when attempting to add more items to the Order than are available */
export type InsufficientStockError = ErrorResult & {
    __typename?: 'InsufficientStockError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
    order: Order;
    quantityAvailable: Scalars['Int']['output'];
};

/**
 * Returned if attempting to create a Fulfillment when there is insufficient
 * stockOnHand of a ProductVariant to satisfy the requested quantity.
 */
export type InsufficientStockOnHandError = ErrorResult & {
    __typename?: 'InsufficientStockOnHandError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
    productVariantId: Scalars['ID']['output'];
    productVariantName: Scalars['String']['output'];
    stockOnHand: Scalars['Int']['output'];
};

export type IntCustomFieldConfig = CustomField & {
    __typename?: 'IntCustomFieldConfig';
    description?: Maybe<Array<LocalizedString>>;
    internal?: Maybe<Scalars['Boolean']['output']>;
    label?: Maybe<Array<LocalizedString>>;
    list: Scalars['Boolean']['output'];
    max?: Maybe<Scalars['Int']['output']>;
    min?: Maybe<Scalars['Int']['output']>;
    name: Scalars['String']['output'];
    nullable?: Maybe<Scalars['Boolean']['output']>;
    readonly?: Maybe<Scalars['Boolean']['output']>;
    requiresPermission?: Maybe<Array<Permission>>;
    step?: Maybe<Scalars['Int']['output']>;
    type: Scalars['String']['output'];
    ui?: Maybe<Scalars['JSON']['output']>;
};

export type IntStructFieldConfig = StructField & {
    __typename?: 'IntStructFieldConfig';
    description?: Maybe<Array<LocalizedString>>;
    label?: Maybe<Array<LocalizedString>>;
    list: Scalars['Boolean']['output'];
    max?: Maybe<Scalars['Int']['output']>;
    min?: Maybe<Scalars['Int']['output']>;
    name: Scalars['String']['output'];
    step?: Maybe<Scalars['Int']['output']>;
    type: Scalars['String']['output'];
    ui?: Maybe<Scalars['JSON']['output']>;
};

/** Returned if the user authentication credentials are not valid */
export type InvalidCredentialsError = ErrorResult & {
    __typename?: 'InvalidCredentialsError';
    authenticationError: Scalars['String']['output'];
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

/** Returned if the specified FulfillmentHandler code is not valid */
export type InvalidFulfillmentHandlerError = ErrorResult & {
    __typename?: 'InvalidFulfillmentHandlerError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

/** Returned if the specified items are already part of a Fulfillment */
export type ItemsAlreadyFulfilledError = ErrorResult & {
    __typename?: 'ItemsAlreadyFulfilledError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

export type Job = Node & {
    __typename?: 'Job';
    attempts: Scalars['Int']['output'];
    createdAt: Scalars['DateTime']['output'];
    data?: Maybe<Scalars['JSON']['output']>;
    duration: Scalars['Int']['output'];
    error?: Maybe<Scalars['JSON']['output']>;
    id: Scalars['ID']['output'];
    isSettled: Scalars['Boolean']['output'];
    progress: Scalars['Float']['output'];
    queueName: Scalars['String']['output'];
    result?: Maybe<Scalars['JSON']['output']>;
    retries: Scalars['Int']['output'];
    settledAt?: Maybe<Scalars['DateTime']['output']>;
    startedAt?: Maybe<Scalars['DateTime']['output']>;
    state: JobState;
};

export type JobBufferSize = {
    __typename?: 'JobBufferSize';
    bufferId: Scalars['String']['output'];
    size: Scalars['Int']['output'];
};

export type JobFilterParameter = {
    _and?: InputMaybe<Array<JobFilterParameter>>;
    _or?: InputMaybe<Array<JobFilterParameter>>;
    attempts?: InputMaybe<NumberOperators>;
    createdAt?: InputMaybe<DateOperators>;
    duration?: InputMaybe<NumberOperators>;
    id?: InputMaybe<IdOperators>;
    isSettled?: InputMaybe<BooleanOperators>;
    progress?: InputMaybe<NumberOperators>;
    queueName?: InputMaybe<StringOperators>;
    retries?: InputMaybe<NumberOperators>;
    settledAt?: InputMaybe<DateOperators>;
    startedAt?: InputMaybe<DateOperators>;
    state?: InputMaybe<StringOperators>;
};

export type JobList = PaginatedList & {
    __typename?: 'JobList';
    items: Array<Job>;
    totalItems: Scalars['Int']['output'];
};

export type JobListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<JobFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<JobSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type JobQueue = {
    __typename?: 'JobQueue';
    name: Scalars['String']['output'];
    running: Scalars['Boolean']['output'];
};

export type JobSortParameter = {
    attempts?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    duration?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    progress?: InputMaybe<SortOrder>;
    queueName?: InputMaybe<SortOrder>;
    retries?: InputMaybe<SortOrder>;
    settledAt?: InputMaybe<SortOrder>;
    startedAt?: InputMaybe<SortOrder>;
};

/**
 * @description
 * The state of a Job in the JobQueue
 *
 * @docsCategory common
 */
export enum JobState {
    CANCELLED = 'CANCELLED',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
    PENDING = 'PENDING',
    RETRYING = 'RETRYING',
    RUNNING = 'RUNNING',
}

/**
 * @description
 * Languages in the form of a ISO 639-1 language code with optional
 * region or script modifier (e.g. de_AT). The selection available is based
 * on the [Unicode CLDR summary list](https://unicode-org.github.io/cldr-staging/charts/37/summary/root.html)
 * and includes the major spoken languages of the world and any widely-used variants.
 *
 * @docsCategory common
 */
export enum LanguageCode {
    /** Afrikaans */
    af = 'af',
    /** Akan */
    ak = 'ak',
    /** Amharic */
    am = 'am',
    /** Arabic */
    ar = 'ar',
    /** Assamese */
    as = 'as',
    /** Azerbaijani */
    az = 'az',
    /** Belarusian */
    be = 'be',
    /** Bulgarian */
    bg = 'bg',
    /** Bambara */
    bm = 'bm',
    /** Bangla */
    bn = 'bn',
    /** Tibetan */
    bo = 'bo',
    /** Breton */
    br = 'br',
    /** Bosnian */
    bs = 'bs',
    /** Catalan */
    ca = 'ca',
    /** Chechen */
    ce = 'ce',
    /** Corsican */
    co = 'co',
    /** Czech */
    cs = 'cs',
    /** Church Slavic */
    cu = 'cu',
    /** Welsh */
    cy = 'cy',
    /** Danish */
    da = 'da',
    /** German */
    de = 'de',
    /** Austrian German */
    de_AT = 'de_AT',
    /** Swiss High German */
    de_CH = 'de_CH',
    /** Dzongkha */
    dz = 'dz',
    /** Ewe */
    ee = 'ee',
    /** Greek */
    el = 'el',
    /** English */
    en = 'en',
    /** Australian English */
    en_AU = 'en_AU',
    /** Canadian English */
    en_CA = 'en_CA',
    /** British English */
    en_GB = 'en_GB',
    /** American English */
    en_US = 'en_US',
    /** Esperanto */
    eo = 'eo',
    /** Spanish */
    es = 'es',
    /** European Spanish */
    es_ES = 'es_ES',
    /** Mexican Spanish */
    es_MX = 'es_MX',
    /** Estonian */
    et = 'et',
    /** Basque */
    eu = 'eu',
    /** Persian */
    fa = 'fa',
    /** Dari */
    fa_AF = 'fa_AF',
    /** Fulah */
    ff = 'ff',
    /** Finnish */
    fi = 'fi',
    /** Faroese */
    fo = 'fo',
    /** French */
    fr = 'fr',
    /** Canadian French */
    fr_CA = 'fr_CA',
    /** Swiss French */
    fr_CH = 'fr_CH',
    /** Western Frisian */
    fy = 'fy',
    /** Irish */
    ga = 'ga',
    /** Scottish Gaelic */
    gd = 'gd',
    /** Galician */
    gl = 'gl',
    /** Gujarati */
    gu = 'gu',
    /** Manx */
    gv = 'gv',
    /** Hausa */
    ha = 'ha',
    /** Hebrew */
    he = 'he',
    /** Hindi */
    hi = 'hi',
    /** Croatian */
    hr = 'hr',
    /** Haitian Creole */
    ht = 'ht',
    /** Hungarian */
    hu = 'hu',
    /** Armenian */
    hy = 'hy',
    /** Interlingua */
    ia = 'ia',
    /** Indonesian */
    id = 'id',
    /** Igbo */
    ig = 'ig',
    /** Sichuan Yi */
    ii = 'ii',
    /** Icelandic */
    is = 'is',
    /** Italian */
    it = 'it',
    /** Japanese */
    ja = 'ja',
    /** Javanese */
    jv = 'jv',
    /** Georgian */
    ka = 'ka',
    /** Kikuyu */
    ki = 'ki',
    /** Kazakh */
    kk = 'kk',
    /** Kalaallisut */
    kl = 'kl',
    /** Khmer */
    km = 'km',
    /** Kannada */
    kn = 'kn',
    /** Korean */
    ko = 'ko',
    /** Kashmiri */
    ks = 'ks',
    /** Kurdish */
    ku = 'ku',
    /** Cornish */
    kw = 'kw',
    /** Kyrgyz */
    ky = 'ky',
    /** Latin */
    la = 'la',
    /** Luxembourgish */
    lb = 'lb',
    /** Ganda */
    lg = 'lg',
    /** Lingala */
    ln = 'ln',
    /** Lao */
    lo = 'lo',
    /** Lithuanian */
    lt = 'lt',
    /** Luba-Katanga */
    lu = 'lu',
    /** Latvian */
    lv = 'lv',
    /** Malagasy */
    mg = 'mg',
    /** Maori */
    mi = 'mi',
    /** Macedonian */
    mk = 'mk',
    /** Malayalam */
    ml = 'ml',
    /** Mongolian */
    mn = 'mn',
    /** Marathi */
    mr = 'mr',
    /** Malay */
    ms = 'ms',
    /** Maltese */
    mt = 'mt',
    /** Burmese */
    my = 'my',
    /** Norwegian Bokmål */
    nb = 'nb',
    /** North Ndebele */
    nd = 'nd',
    /** Nepali */
    ne = 'ne',
    /** Dutch */
    nl = 'nl',
    /** Flemish */
    nl_BE = 'nl_BE',
    /** Norwegian Nynorsk */
    nn = 'nn',
    /** Nyanja */
    ny = 'ny',
    /** Oromo */
    om = 'om',
    /** Odia */
    or = 'or',
    /** Ossetic */
    os = 'os',
    /** Punjabi */
    pa = 'pa',
    /** Polish */
    pl = 'pl',
    /** Pashto */
    ps = 'ps',
    /** Portuguese */
    pt = 'pt',
    /** Brazilian Portuguese */
    pt_BR = 'pt_BR',
    /** European Portuguese */
    pt_PT = 'pt_PT',
    /** Quechua */
    qu = 'qu',
    /** Romansh */
    rm = 'rm',
    /** Rundi */
    rn = 'rn',
    /** Romanian */
    ro = 'ro',
    /** Moldavian */
    ro_MD = 'ro_MD',
    /** Russian */
    ru = 'ru',
    /** Kinyarwanda */
    rw = 'rw',
    /** Sanskrit */
    sa = 'sa',
    /** Sindhi */
    sd = 'sd',
    /** Northern Sami */
    se = 'se',
    /** Sango */
    sg = 'sg',
    /** Sinhala */
    si = 'si',
    /** Slovak */
    sk = 'sk',
    /** Slovenian */
    sl = 'sl',
    /** Samoan */
    sm = 'sm',
    /** Shona */
    sn = 'sn',
    /** Somali */
    so = 'so',
    /** Albanian */
    sq = 'sq',
    /** Serbian */
    sr = 'sr',
    /** Southern Sotho */
    st = 'st',
    /** Sundanese */
    su = 'su',
    /** Swedish */
    sv = 'sv',
    /** Swahili */
    sw = 'sw',
    /** Congo Swahili */
    sw_CD = 'sw_CD',
    /** Tamil */
    ta = 'ta',
    /** Telugu */
    te = 'te',
    /** Tajik */
    tg = 'tg',
    /** Thai */
    th = 'th',
    /** Tigrinya */
    ti = 'ti',
    /** Turkmen */
    tk = 'tk',
    /** Tongan */
    to = 'to',
    /** Turkish */
    tr = 'tr',
    /** Tatar */
    tt = 'tt',
    /** Uyghur */
    ug = 'ug',
    /** Ukrainian */
    uk = 'uk',
    /** Urdu */
    ur = 'ur',
    /** Uzbek */
    uz = 'uz',
    /** Vietnamese */
    vi = 'vi',
    /** Volapük */
    vo = 'vo',
    /** Wolof */
    wo = 'wo',
    /** Xhosa */
    xh = 'xh',
    /** Yiddish */
    yi = 'yi',
    /** Yoruba */
    yo = 'yo',
    /** Chinese */
    zh = 'zh',
    /** Simplified Chinese */
    zh_Hans = 'zh_Hans',
    /** Traditional Chinese */
    zh_Hant = 'zh_Hant',
    /** Zulu */
    zu = 'zu',
}

/** Returned if attempting to set a Channel's defaultLanguageCode to a language which is not enabled in GlobalSettings */
export type LanguageNotAvailableError = ErrorResult & {
    __typename?: 'LanguageNotAvailableError';
    errorCode: ErrorCode;
    languageCode: Scalars['String']['output'];
    message: Scalars['String']['output'];
};

export type LocaleStringCustomFieldConfig = CustomField & {
    __typename?: 'LocaleStringCustomFieldConfig';
    description?: Maybe<Array<LocalizedString>>;
    internal?: Maybe<Scalars['Boolean']['output']>;
    label?: Maybe<Array<LocalizedString>>;
    length?: Maybe<Scalars['Int']['output']>;
    list: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    nullable?: Maybe<Scalars['Boolean']['output']>;
    pattern?: Maybe<Scalars['String']['output']>;
    readonly?: Maybe<Scalars['Boolean']['output']>;
    requiresPermission?: Maybe<Array<Permission>>;
    type: Scalars['String']['output'];
    ui?: Maybe<Scalars['JSON']['output']>;
};

export type LocaleTextCustomFieldConfig = CustomField & {
    __typename?: 'LocaleTextCustomFieldConfig';
    description?: Maybe<Array<LocalizedString>>;
    internal?: Maybe<Scalars['Boolean']['output']>;
    label?: Maybe<Array<LocalizedString>>;
    list: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    nullable?: Maybe<Scalars['Boolean']['output']>;
    readonly?: Maybe<Scalars['Boolean']['output']>;
    requiresPermission?: Maybe<Array<Permission>>;
    type: Scalars['String']['output'];
    ui?: Maybe<Scalars['JSON']['output']>;
};

export type LocalizedString = {
    __typename?: 'LocalizedString';
    languageCode: LanguageCode;
    value: Scalars['String']['output'];
};

export enum LogicalOperator {
    AND = 'AND',
    OR = 'OR',
}

export type ManualPaymentInput = {
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    method: Scalars['String']['input'];
    orderId: Scalars['ID']['input'];
    transactionId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Returned when a call to addManualPaymentToOrder is made but the Order
 * is not in the required state.
 */
export type ManualPaymentStateError = ErrorResult & {
    __typename?: 'ManualPaymentStateError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

export enum MassUnit {
    g = 'g',
    kg = 'kg',
    lb = 'lb',
    oz = 'oz',
}

export enum MeasurementUnit {
    /** 1 */
    BD = 'BD',
    BD2 = 'BD2',
    BJ = 'BJ',
    BL = 'BL',
    CA = 'CA',
    CAIXA = 'CAIXA',
    CARTELA = 'CARTELA',
    CT = 'CT',
    CX = 'CX',
    DISPLAY = 'DISPLAY',
    DP = 'DP',
    DZ = 'DZ',
    DZ2 = 'DZ2',
    Emb_C = 'Emb_C',
    FARDO = 'FARDO',
    FD = 'FD',
    KG = 'KG',
    KIT = 'KIT',
    KT = 'KT',
    LITRO = 'LITRO',
    LT = 'LT',
    MT = 'MT',
    PACOTE = 'PACOTE',
    PC = 'PC',
    PT = 'PT',
    RL = 'RL',
    RM = 'RM',
    TB = 'TB',
    UN = 'UN',
    UNIDADE = 'UNIDADE',
    un = 'un',
}

export enum MetricInterval {
    Daily = 'Daily',
}

export type MetricSummary = {
    __typename?: 'MetricSummary';
    entries: Array<MetricSummaryEntry>;
    interval: MetricInterval;
    title: Scalars['String']['output'];
    type: MetricType;
};

export type MetricSummaryEntry = {
    __typename?: 'MetricSummaryEntry';
    label: Scalars['String']['output'];
    value: Scalars['Float']['output'];
};

export type MetricSummaryInput = {
    interval: MetricInterval;
    refresh?: InputMaybe<Scalars['Boolean']['input']>;
    types: Array<MetricType>;
};

export enum MetricType {
    AverageOrderValue = 'AverageOrderValue',
    OrderCount = 'OrderCount',
    OrderTotal = 'OrderTotal',
}

export type MimeTypeError = ErrorResult & {
    __typename?: 'MimeTypeError';
    errorCode: ErrorCode;
    fileName: Scalars['String']['output'];
    message: Scalars['String']['output'];
    mimeType: Scalars['String']['output'];
};

/** Returned if a PromotionCondition has neither a couponCode nor any conditions set */
export type MissingConditionsError = ErrorResult & {
    __typename?: 'MissingConditionsError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

export type ModifyOrderInput = {
    addItems?: InputMaybe<Array<AddItemInput>>;
    adjustOrderLines?: InputMaybe<Array<OrderLineInput>>;
    couponCodes?: InputMaybe<Array<Scalars['String']['input']>>;
    customFields?: InputMaybe<UpdateOrderCustomFieldsInput>;
    dryRun: Scalars['Boolean']['input'];
    note?: InputMaybe<Scalars['String']['input']>;
    options?: InputMaybe<ModifyOrderOptions>;
    orderId: Scalars['ID']['input'];
    /**
     * Deprecated in v2.2.0. Use `refunds` instead to allow multiple refunds to be
     * applied in the case that multiple payment methods have been used on the order.
     */
    refund?: InputMaybe<AdministratorRefundInput>;
    refunds?: InputMaybe<Array<AdministratorRefundInput>>;
    /** Added in v2.2 */
    shippingMethodIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    surcharges?: InputMaybe<Array<SurchargeInput>>;
    updateBillingAddress?: InputMaybe<UpdateOrderAddressInput>;
    updateShippingAddress?: InputMaybe<UpdateOrderAddressInput>;
};

export type ModifyOrderOptions = {
    freezePromotions?: InputMaybe<Scalars['Boolean']['input']>;
    recalculateShipping?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ModifyOrderResult =
    | CouponCodeExpiredError
    | CouponCodeInvalidError
    | CouponCodeLimitError
    | IneligibleShippingMethodError
    | InsufficientStockError
    | NegativeQuantityError
    | NoChangesSpecifiedError
    | Order
    | OrderLimitError
    | OrderModificationStateError
    | PaymentMethodMissingError
    | RefundPaymentIdMissingError;

export type MoveCollectionInput = {
    collectionId: Scalars['ID']['input'];
    index: Scalars['Int']['input'];
    parentId: Scalars['ID']['input'];
};

/** Returned if an operation has specified OrderLines from multiple Orders */
export type MultipleOrderError = ErrorResult & {
    __typename?: 'MultipleOrderError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

export type Mutation = {
    __typename?: 'Mutation';
    /** Add items into a some shopping lists */
    addBulkItemsToShoppingList?: Maybe<AddBulkItemsToShoppingListResult>;
    /** Add Customers to a CustomerGroup */
    addCustomersToGroup: CustomerGroup;
    addFulfillmentToOrder: AddFulfillmentToOrderResult;
    /** Adds an item to the draft Order. */
    addItemToDraftOrder: UpdateOrderItemsResult;
    /**
     * Used to manually create a new Payment against an Order.
     * This can be used by an Administrator when an Order is in the ArrangingPayment state.
     *
     * It is also used when a completed Order
     * has been modified (using `modifyOrder`) and the price has increased. The extra payment
     * can then be manually arranged by the administrator, and the details used to create a new
     * Payment.
     */
    addManualPaymentToOrder: AddManualPaymentToOrderResult;
    /** Add members to a Zone */
    addMembersToZone: Zone;
    addNoteToCustomer: Customer;
    addNoteToOrder: Order;
    /** Add an OptionGroup to a Product */
    addOptionGroupToProduct: Product;
    addSubscriptionEmail: Array<Maybe<Email>>;
    addSubscriptionPhone: Array<Maybe<Phone>>;
    /** Adjusts a draft OrderLine. If custom fields are defined on the OrderLine entity, a third argument 'customFields' of type `OrderLineCustomFieldsInput` will be available. */
    adjustDraftOrderLine: UpdateOrderItemsResult;
    /** Applies the given coupon code to the draft Order */
    applyCouponCodeToDraftOrder: ApplyCouponCodeResult;
    /** Assign assets to channel */
    assignAssetsToChannel: Array<Asset>;
    assignBannerToChannels: Array<Banner>;
    /** Assigns a branch to a channel */
    assignBranchToChannels?: Maybe<AssignBranchToChannelsResult>;
    assignChannelToPartner: Array<Partner>;
    /** Assigns Collections to the specified Channel */
    assignCollectionsToChannel: Array<Collection>;
    /** Assigns a customer to a branch */
    assignCustomerToBranch?: Maybe<AssignCustomerToBranchResult>;
    /** Assigns Facets to the specified Channel */
    assignFacetsToChannel: Array<Facet>;
    /** Assigns PaymentMethods to the specified Channel */
    assignPaymentMethodsToChannel: Array<PaymentMethod>;
    /** Assigns ProductVariants to the specified Channel */
    assignProductVariantsToChannel: Array<ProductVariant>;
    /** Assigns all ProductVariants of Product to the specified Channel */
    assignProductsToChannel: Array<Product>;
    /** Assigns Promotions to the specified Channel */
    assignPromotionsToChannel: Array<Promotion>;
    /** Assign a Role to an Administrator */
    assignRoleToAdministrator: Administrator;
    /** Assigns ShippingMethods to the specified Channel */
    assignShippingMethodsToChannel: Array<ShippingMethod>;
    /** Assigns StockLocations to the specified Channel */
    assignStockLocationsToChannel: Array<StockLocation>;
    assignWorkBrandsToChannels: Array<WorkBrand>;
    associateAllBuyersWithShoppingList?: Maybe<AssociateAllBuyersWithShoppingListResult>;
    /** associate Buyers With Shopping List */
    associateBuyersWithShoppingList?: Maybe<AssociateBuyersWithShoppingListResult>;
    /** Authenticates the user using a named authentication strategy */
    authenticate: AuthenticationResult;
    autocompleteReindex: Job;
    cancelJob: Job;
    cancelOrder: CancelOrderResult;
    cancelPayment: CancelPaymentResult;
    /** Create a new Administrator */
    createAdministrator: Administrator;
    /** Create a new Asset */
    createAssets: Array<CreateAssetResult>;
    createBanner: Banner;
    createBannerItem: BannerItem;
    /** Creates a new branch */
    createBranch: Branch;
    createCardBrand: CardBrand;
    createCardFee: CardFee;
    /** Create a new Channel */
    createChannel: CreateChannelResult;
    createChannelSocialMedia: ChannelSocialMediaResult;
    /** Create a new Collection */
    createCollection: Collection;
    /** Create a new Country */
    createCountry: Country;
    /** Create a new Customer. If a password is provided, a new User will also be created an linked to the Customer. */
    createCustomer: CreateCustomerResult;
    /** Create a new Address and associate it with the Customer specified by customerId */
    createCustomerAddress: Address;
    /** Create a new CustomerGroup */
    createCustomerGroup: CustomerGroup;
    /** Creates a draft Order */
    createDraftOrder: Order;
    /** Create a new Facet */
    createFacet: Facet;
    /** Create one or more FacetValues */
    createFacetValues: Array<FacetValue>;
    createPackage: Package;
    createPartner: CreatePartnerResult;
    /** Create existing PaymentMethod */
    createPaymentMethod: PaymentMethod;
    /** Create a new Product */
    createProduct: Product;
    /** Create a new ProductOption within a ProductOptionGroup */
    createProductOption: ProductOption;
    /** Create a new ProductOptionGroup */
    createProductOptionGroup: ProductOptionGroup;
    /** Create a set of ProductVariants based on the OptionGroups assigned to the given Product */
    createProductVariants: Array<Maybe<ProductVariant>>;
    createPromotion: CreatePromotionResult;
    /** Create a new Province */
    createProvince: Province;
    createRecipient?: Maybe<CreateRecipientResponse>;
    createRefundRequest: RefundRequest;
    /** Create a new Role */
    createRole: Role;
    /** Create a new Seller */
    createSeller: Seller;
    createSellerCustomerPortfolio: SellerCustomerPortfolio;
    createSellerToken?: Maybe<CreateSellerTokenResult>;
    /** Create a new ShippingMethod */
    createShippingMethod: ShippingMethod;
    /** Create a new shopping list */
    createShoppingList: CreateShoppingListResult;
    createStockLocation: StockLocation;
    createSurveyQuestion: SurveyQuestion;
    createSynonymGroup: CreateSynonymGroupResult;
    /** Create a new Tag */
    createTag: Tag;
    /** Create a new TaxCategory */
    createTaxCategory: TaxCategory;
    /** Create a new TaxRate */
    createTaxRate: TaxRate;
    createWorkBrand: WorkBrand;
    /** Create a new Zone */
    createZone: Zone;
    /** Delete an Administrator */
    deleteAdministrator: DeletionResponse;
    /** Delete multiple Administrators */
    deleteAdministrators: Array<DeletionResponse>;
    deleteAllSubscriptionEmails: Scalars['Boolean']['output'];
    deleteAllSubscriptionPhones: Scalars['Boolean']['output'];
    /** Delete an Asset */
    deleteAsset: DeletionResponse;
    /** Delete multiple Assets */
    deleteAssets: DeletionResponse;
    deleteBanner: DeletionResponse;
    deleteBannerItem: DeletionResponse;
    deleteBannerItems: DeletionResponse;
    deleteBanners: DeletionResponse;
    deleteCardBrand: DeletionResponse;
    deleteCardFee: DeletionResponse;
    /** Delete a Channel */
    deleteChannel: DeletionResponse;
    deleteChannelSocialMedia: Scalars['Boolean']['output'];
    /** Delete multiple Channels */
    deleteChannels: Array<DeletionResponse>;
    /** Delete a Collection and all of its descendants */
    deleteCollection: DeletionResponse;
    /** Delete multiple Collections and all of their descendants */
    deleteCollections: Array<DeletionResponse>;
    /** Delete multiple Countries */
    deleteCountries: Array<DeletionResponse>;
    /** Delete a Country */
    deleteCountry: DeletionResponse;
    /** Delete a Customer */
    deleteCustomer: DeletionResponse;
    /** Update an existing Address */
    deleteCustomerAddress: Success;
    /** Delete a CustomerGroup */
    deleteCustomerGroup: DeletionResponse;
    /** Delete multiple CustomerGroups */
    deleteCustomerGroups: Array<DeletionResponse>;
    deleteCustomerNote: DeletionResponse;
    /** Deletes Customers */
    deleteCustomers: Array<DeletionResponse>;
    /** Deletes a draft Order */
    deleteDraftOrder: DeletionResponse;
    /** Delete an existing Facet */
    deleteFacet: DeletionResponse;
    /** Delete one or more FacetValues */
    deleteFacetValues: Array<DeletionResponse>;
    /** Delete multiple existing Facets */
    deleteFacets: Array<DeletionResponse>;
    deleteOrderNote: DeletionResponse;
    deletePartner: Scalars['Boolean']['output'];
    /** Delete a PaymentMethod */
    deletePaymentMethod: DeletionResponse;
    /** Delete multiple PaymentMethods */
    deletePaymentMethods: Array<DeletionResponse>;
    deletePricesForVariant: DeletePricesForVariantResult;
    /** Delete a Product */
    deleteProduct: DeletionResponse;
    /** Delete a ProductOption */
    deleteProductOption: DeletionResponse;
    /** Delete a ProductVariant */
    deleteProductVariant: DeletionResponse;
    /** Delete multiple ProductVariants */
    deleteProductVariants: Array<DeletionResponse>;
    /** Delete multiple Products */
    deleteProducts: Array<DeletionResponse>;
    deletePromotion: DeletionResponse;
    deletePromotions: Array<DeletionResponse>;
    /** Delete a Province */
    deleteProvince: DeletionResponse;
    deleteRefundRequest: Scalars['Boolean']['output'];
    /** Delete an existing Role */
    deleteRole: DeletionResponse;
    /** Delete multiple Roles */
    deleteRoles: Array<DeletionResponse>;
    /** Delete a Seller */
    deleteSeller: DeletionResponse;
    deleteSellerCustomerPortfolio: Scalars['Boolean']['output'];
    /** Delete multiple Sellers */
    deleteSellers: Array<DeletionResponse>;
    /** Delete a ShippingMethod */
    deleteShippingMethod: DeletionResponse;
    /** Delete multiple ShippingMethods */
    deleteShippingMethods: Array<DeletionResponse>;
    deleteStockLocation: DeletionResponse;
    deleteStockLocations: Array<DeletionResponse>;
    deleteSubscriptionEmail: Array<Maybe<Email>>;
    deleteSubscriptionPhone: Array<Maybe<Phone>>;
    deleteSurveyQuestion: SurveyQuestion;
    deleteSynonymGroups: Scalars['Boolean']['output'];
    /** Delete an existing Tag */
    deleteTag: DeletionResponse;
    /** Deletes multiple TaxCategories */
    deleteTaxCategories: Array<DeletionResponse>;
    /** Deletes a TaxCategory */
    deleteTaxCategory: DeletionResponse;
    /** Delete a TaxRate */
    deleteTaxRate: DeletionResponse;
    /** Delete multiple TaxRates */
    deleteTaxRates: Array<DeletionResponse>;
    deleteWorkBrand: Scalars['Boolean']['output'];
    /** Delete a Zone */
    deleteZone: DeletionResponse;
    /** Delete a Zone */
    deleteZones: Array<DeletionResponse>;
    /**
     * Duplicate an existing entity using a specific EntityDuplicator.
     * Since v2.2.0.
     */
    duplicateEntity: DuplicateEntityResult;
    exportCustomersWithErrors?: Maybe<Scalars['String']['output']>;
    flushBufferedJobs: Success;
    importProducts?: Maybe<ImportInfo>;
    /**
     * Authenticates the user using the native authentication strategy. This mutation is an alias for authenticate({ native: { ... }})
     *
     * The `rememberMe` option applies when using cookie-based sessions, and if `true` it will set the maxAge of the session cookie
     * to 1 year.
     */
    login: NativeAuthenticationResult;
    logout: Success;
    /**
     * Allows an Order to be modified after it has been completed by the Customer. The Order must first
     * be in the `Modifying` state.
     */
    modifyOrder: ModifyOrderResult;
    /** Move a Collection to a different parent or index */
    moveCollection: Collection;
    refundOrder: RefundOrderResult;
    reindex: Job;
    /** Remove a branch from a channel */
    removeBranchFromChannels?: Maybe<RemoveBranchFromChannelsResult>;
    removeChannelFromBanner: Array<Banner>;
    removeChannelFromPartner: Array<Partner>;
    removeChannelFromWorkBrands: Array<WorkBrand>;
    /** Removes Collections from the specified Channel */
    removeCollectionsFromChannel: Array<Collection>;
    /** Removes the given coupon code from the draft Order */
    removeCouponCodeFromDraftOrder?: Maybe<Order>;
    /** Removes a customer from a branch */
    removeCustomerFromBranch?: Maybe<RemoveCustomerFromBranchResult>;
    /** Remove Customers from a CustomerGroup */
    removeCustomersFromGroup: CustomerGroup;
    /** Remove an OrderLine from the draft Order */
    removeDraftOrderLine: RemoveOrderItemsResult;
    /** Removes Facets from the specified Channel */
    removeFacetsFromChannel: Array<RemoveFacetFromChannelResult>;
    /** Remove members from a Zone */
    removeMembersFromZone: Zone;
    /**
     * Remove an OptionGroup from a Product. If the OptionGroup is in use by any ProductVariants
     * the mutation will return a ProductOptionInUseError, and the OptionGroup will not be removed.
     * Setting the `force` argument to `true` will override this and remove the OptionGroup anyway,
     * as well as removing any of the group's options from the Product's ProductVariants.
     */
    removeOptionGroupFromProduct: RemoveOptionGroupFromProductResult;
    /** Removes PaymentMethods from the specified Channel */
    removePaymentMethodsFromChannel: Array<PaymentMethod>;
    /** Removes ProductVariants from the specified Channel */
    removeProductVariantsFromChannel: Array<ProductVariant>;
    /** Removes all ProductVariants of Product from the specified Channel */
    removeProductsFromChannel: Array<Product>;
    /** Removes Promotions from the specified Channel */
    removePromotionsFromChannel: Array<Promotion>;
    /** Remove all settled jobs in the given queues older than the given date. Returns the number of jobs deleted. */
    removeSettledJobs: Scalars['Int']['output'];
    /** Removes ShippingMethods from the specified Channel */
    removeShippingMethodsFromChannel: Array<ShippingMethod>;
    /** Removing a shopping lists by Id */
    removeShoppingLists?: Maybe<RemoveShoppingListsResult>;
    /** Removes StockLocations from the specified Channel */
    removeStockLocationsFromChannel: Array<StockLocation>;
    runPendingSearchIndexUpdates: Success;
    setChannelLogo?: Maybe<Asset>;
    setCustomerForDraftOrder: SetCustomerForDraftOrderResult;
    /** Sets the billing address for a draft Order */
    setDraftOrderBillingAddress: Order;
    /** Allows any custom fields to be set for the active order */
    setDraftOrderCustomFields: Order;
    /** Sets the shipping address for a draft Order */
    setDraftOrderShippingAddress: Order;
    /** Sets the shipping method by id, which can be obtained with the `eligibleShippingMethodsForDraftOrder` query */
    setDraftOrderShippingMethod: SetOrderShippingMethodResult;
    setOrderCustomFields?: Maybe<Order>;
    /** Allows a different Customer to be assigned to an Order. Added in v2.2.0. */
    setOrderCustomer?: Maybe<Order>;
    /** Set all webhooks for the current channel. This will overwrite any existing webhooks. */
    setWebhooks: Array<Webhook>;
    settlePayment: SettlePaymentResult;
    settleRefund: SettleRefundResult;
    submitMultipleSurveyResponses: Array<SurveyResponse>;
    submitSurveyResponse: SurveyResponse;
    syncCustomer: Scalars['String']['output'];
    syncPricesForVariant: SyncPricesForVariantResult;
    syncProductsBySku: Scalars['String']['output'];
    transitionFulfillmentToState: TransitionFulfillmentToStateResult;
    transitionOrderToState?: Maybe<TransitionOrderToStateResult>;
    transitionPaymentToState: TransitionPaymentToStateResult;
    /** Unsets the billing address for a draft Order */
    unsetDraftOrderBillingAddress: Order;
    /** Unsets the shipping address for a draft Order */
    unsetDraftOrderShippingAddress: Order;
    /** Update the active (currently logged-in) Administrator */
    updateActiveAdministrator: Administrator;
    /** Update an existing Administrator */
    updateAdministrator: Administrator;
    /** Update an existing Asset */
    updateAsset: Asset;
    updateBanner: Banner;
    updateBannerItem: BannerItem;
    updateCardBrand: CardBrand;
    updateCardFee: CardFee;
    /** Update an existing Channel */
    updateChannel: UpdateChannelResult;
    updateChannelSocialMedia: UpdateChannelSocialMediaResult;
    /** Update an existing Collection */
    updateCollection: Collection;
    /** Update an existing Country */
    updateCountry: Country;
    /** Update an existing Customer */
    updateCustomer: UpdateCustomerResult;
    /** Update an existing Address */
    updateCustomerAddress: Address;
    /** Update an existing CustomerGroup */
    updateCustomerGroup: CustomerGroup;
    updateCustomerNote: HistoryEntry;
    /** Update an existing Facet */
    updateFacet: Facet;
    /** Update one or more FacetValues */
    updateFacetValues: Array<FacetValue>;
    updateGlobalSettings: UpdateGlobalSettingsResult;
    updateOrderNote: HistoryEntry;
    updatePackage: Package;
    updatePartner: UpdatePartnerResult;
    /** Update an existing PaymentMethod */
    updatePaymentMethod: PaymentMethod;
    /** Update an existing Product */
    updateProduct: Product;
    /** Create a new ProductOption within a ProductOptionGroup */
    updateProductOption: ProductOption;
    /** Update an existing ProductOptionGroup */
    updateProductOptionGroup: ProductOptionGroup;
    /** Update an existing ProductVariant */
    updateProductVariant: ProductVariant;
    /** Update existing ProductVariants */
    updateProductVariants: Array<Maybe<ProductVariant>>;
    /** Update multiple existing Products */
    updateProducts: Array<Product>;
    updatePromotion: UpdatePromotionResult;
    /** Update an existing Province */
    updateProvince: Province;
    updateRefundRequest: Scalars['Boolean']['output'];
    /** Update an existing Role */
    updateRole: Role;
    /** Update an existing Seller */
    updateSeller: Seller;
    updateSellerCustomerPortfolio: SellerCustomerPortfolio;
    /** Update an existing ShippingMethod */
    updateShippingMethod: ShippingMethod;
    /** Update a shopping list */
    updateShoppingList: UpdateShoppingListResult;
    updateStockLocation: StockLocation;
    updateSubscriptionEmail: Array<Maybe<Email>>;
    updateSubscriptionPhone: Array<Maybe<Phone>>;
    updateSurveyQuestion: SurveyQuestion;
    updateSynonymGroup: UpdateSynonymGroupResult;
    /** Update an existing Tag */
    updateTag: Tag;
    /** Update an existing TaxCategory */
    updateTaxCategory: TaxCategory;
    /** Update an existing TaxRate */
    updateTaxRate: TaxRate;
    updateWorkBrand: WorkBrand;
    /** Update an existing Zone */
    updateZone: Zone;
};

export type MutationAddBulkItemsToShoppingListArgs = {
    input: AddBulkItemsToShoppingListInput;
};

export type MutationAddCustomersToGroupArgs = {
    customerGroupId: Scalars['ID']['input'];
    customerIds: Array<Scalars['ID']['input']>;
};

export type MutationAddFulfillmentToOrderArgs = {
    input: FulfillOrderInput;
};

export type MutationAddItemToDraftOrderArgs = {
    input: AddItemToDraftOrderInput;
    orderId: Scalars['ID']['input'];
};

export type MutationAddManualPaymentToOrderArgs = {
    input: ManualPaymentInput;
};

export type MutationAddMembersToZoneArgs = {
    memberIds: Array<Scalars['ID']['input']>;
    zoneId: Scalars['ID']['input'];
};

export type MutationAddNoteToCustomerArgs = {
    input: AddNoteToCustomerInput;
};

export type MutationAddNoteToOrderArgs = {
    input: AddNoteToOrderInput;
};

export type MutationAddOptionGroupToProductArgs = {
    optionGroupId: Scalars['ID']['input'];
    productId: Scalars['ID']['input'];
};

export type MutationAddSubscriptionEmailArgs = {
    input: Array<EmailAddInput>;
};

export type MutationAddSubscriptionPhoneArgs = {
    input: Array<PhoneAddInput>;
};

export type MutationAdjustDraftOrderLineArgs = {
    input: AdjustDraftOrderLineInput;
    orderId: Scalars['ID']['input'];
};

export type MutationApplyCouponCodeToDraftOrderArgs = {
    couponCode: Scalars['String']['input'];
    orderId: Scalars['ID']['input'];
};

export type MutationAssignAssetsToChannelArgs = {
    input: AssignAssetsToChannelInput;
};

export type MutationAssignBannerToChannelsArgs = {
    input: AssignBannerToChannelsInput;
};

export type MutationAssignBranchToChannelsArgs = {
    branchId: Scalars['ID']['input'];
    channelIds: Array<Scalars['ID']['input']>;
};

export type MutationAssignChannelToPartnerArgs = {
    channelIds: Array<Scalars['ID']['input']>;
    partnerIds: Array<Scalars['ID']['input']>;
};

export type MutationAssignCollectionsToChannelArgs = {
    input: AssignCollectionsToChannelInput;
};

export type MutationAssignCustomerToBranchArgs = {
    branchIds: Array<Scalars['ID']['input']>;
    customerId: Scalars['ID']['input'];
};

export type MutationAssignFacetsToChannelArgs = {
    input: AssignFacetsToChannelInput;
};

export type MutationAssignPaymentMethodsToChannelArgs = {
    input: AssignPaymentMethodsToChannelInput;
};

export type MutationAssignProductVariantsToChannelArgs = {
    input: AssignProductVariantsToChannelInput;
};

export type MutationAssignProductsToChannelArgs = {
    input: AssignProductsToChannelInput;
};

export type MutationAssignPromotionsToChannelArgs = {
    input: AssignPromotionsToChannelInput;
};

export type MutationAssignRoleToAdministratorArgs = {
    administratorId: Scalars['ID']['input'];
    roleId: Scalars['ID']['input'];
};

export type MutationAssignShippingMethodsToChannelArgs = {
    input: AssignShippingMethodsToChannelInput;
};

export type MutationAssignStockLocationsToChannelArgs = {
    input: AssignStockLocationsToChannelInput;
};

export type MutationAssignWorkBrandsToChannelsArgs = {
    input: AssignWorkBrandsToChannelsInput;
};

export type MutationAssociateAllBuyersWithShoppingListArgs = {
    input: AssociateAllBuyersWithShoppingListInput;
};

export type MutationAssociateBuyersWithShoppingListArgs = {
    input: AssociateBuyersWithShoppingListInput;
};

export type MutationAuthenticateArgs = {
    input: AuthenticationInput;
    rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCancelJobArgs = {
    jobId: Scalars['ID']['input'];
};

export type MutationCancelOrderArgs = {
    input: CancelOrderInput;
};

export type MutationCancelPaymentArgs = {
    id: Scalars['ID']['input'];
};

export type MutationCreateAdministratorArgs = {
    input: CreateAdministratorInput;
};

export type MutationCreateAssetsArgs = {
    input: Array<CreateAssetInput>;
};

export type MutationCreateBannerArgs = {
    input: CreateBannerInput;
};

export type MutationCreateBannerItemArgs = {
    input: CreateBannerItemInput;
};

export type MutationCreateBranchArgs = {
    input: CreateBranchInput;
};

export type MutationCreateCardBrandArgs = {
    input: CreateCardBrandInput;
};

export type MutationCreateCardFeeArgs = {
    input: CreateCardFeeInput;
};

export type MutationCreateChannelArgs = {
    input: CreateChannelInput;
};

export type MutationCreateChannelSocialMediaArgs = {
    input: CreateChannelSocialMediaInput;
};

export type MutationCreateCollectionArgs = {
    input: CreateCollectionInput;
};

export type MutationCreateCountryArgs = {
    input: CreateCountryInput;
};

export type MutationCreateCustomerArgs = {
    input: CreateCustomerInput;
    password?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateCustomerAddressArgs = {
    customerId: Scalars['ID']['input'];
    input: CreateAddressInput;
};

export type MutationCreateCustomerGroupArgs = {
    input: CreateCustomerGroupInput;
};

export type MutationCreateFacetArgs = {
    input: CreateFacetInput;
};

export type MutationCreateFacetValuesArgs = {
    input: Array<CreateFacetValueInput>;
};

export type MutationCreatePackageArgs = {
    input: CreatePackageInput;
};

export type MutationCreatePartnerArgs = {
    input: PartnerInput;
};

export type MutationCreatePaymentMethodArgs = {
    input: CreatePaymentMethodInput;
};

export type MutationCreateProductArgs = {
    input: CreateProductInput;
};

export type MutationCreateProductOptionArgs = {
    input: CreateProductOptionInput;
};

export type MutationCreateProductOptionGroupArgs = {
    input: CreateProductOptionGroupInput;
};

export type MutationCreateProductVariantsArgs = {
    input: Array<CreateProductVariantInput>;
};

export type MutationCreatePromotionArgs = {
    input: CreatePromotionInput;
};

export type MutationCreateProvinceArgs = {
    input: CreateProvinceInput;
};

export type MutationCreateRecipientArgs = {
    input: CreateRecipientInput;
};

export type MutationCreateRefundRequestArgs = {
    input: CreateRefundRequestInput;
};

export type MutationCreateRoleArgs = {
    input: CreateRoleInput;
};

export type MutationCreateSellerArgs = {
    input: CreateSellerInput;
};

export type MutationCreateSellerCustomerPortfolioArgs = {
    input: SellerCustomerPortfolioInput;
};

export type MutationCreateSellerTokenArgs = {
    input: RegisterSellerTokenInput;
};

export type MutationCreateShippingMethodArgs = {
    input: CreateShippingMethodInput;
};

export type MutationCreateShoppingListArgs = {
    input: CreateShoppingListInput;
};

export type MutationCreateStockLocationArgs = {
    input: CreateStockLocationInput;
};

export type MutationCreateSurveyQuestionArgs = {
    options?: InputMaybe<Array<Scalars['String']['input']>>;
    title: Scalars['String']['input'];
    type: Scalars['String']['input'];
};

export type MutationCreateSynonymGroupArgs = {
    input: CreateSynonymGroupInput;
};

export type MutationCreateTagArgs = {
    input: CreateTagInput;
};

export type MutationCreateTaxCategoryArgs = {
    input: CreateTaxCategoryInput;
};

export type MutationCreateTaxRateArgs = {
    input: CreateTaxRateInput;
};

export type MutationCreateWorkBrandArgs = {
    input?: InputMaybe<CreateWorkBrandInput>;
};

export type MutationCreateZoneArgs = {
    input: CreateZoneInput;
};

export type MutationDeleteAdministratorArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteAdministratorsArgs = {
    ids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteAssetArgs = {
    input: DeleteAssetInput;
};

export type MutationDeleteAssetsArgs = {
    input: DeleteAssetsInput;
};

export type MutationDeleteBannerArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteBannerItemArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteBannerItemsArgs = {
    ids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteBannersArgs = {
    ids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteCardBrandArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteCardFeeArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteChannelArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteChannelSocialMediaArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteChannelsArgs = {
    ids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteCollectionArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteCollectionsArgs = {
    ids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteCountriesArgs = {
    ids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteCountryArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteCustomerArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteCustomerAddressArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteCustomerGroupArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteCustomerGroupsArgs = {
    ids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteCustomerNoteArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteCustomersArgs = {
    ids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteDraftOrderArgs = {
    orderId: Scalars['ID']['input'];
};

export type MutationDeleteFacetArgs = {
    force?: InputMaybe<Scalars['Boolean']['input']>;
    id: Scalars['ID']['input'];
};

export type MutationDeleteFacetValuesArgs = {
    force?: InputMaybe<Scalars['Boolean']['input']>;
    ids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteFacetsArgs = {
    force?: InputMaybe<Scalars['Boolean']['input']>;
    ids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteOrderNoteArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeletePartnerArgs = {
    ids: Array<Scalars['ID']['input']>;
};

export type MutationDeletePaymentMethodArgs = {
    force?: InputMaybe<Scalars['Boolean']['input']>;
    id: Scalars['ID']['input'];
};

export type MutationDeletePaymentMethodsArgs = {
    force?: InputMaybe<Scalars['Boolean']['input']>;
    ids: Array<Scalars['ID']['input']>;
};

export type MutationDeletePricesForVariantArgs = {
    channelCode: Scalars['String']['input'];
    externalVariantId: Scalars['String']['input'];
};

export type MutationDeleteProductArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteProductOptionArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteProductVariantArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteProductVariantsArgs = {
    ids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteProductsArgs = {
    ids: Array<Scalars['ID']['input']>;
};

export type MutationDeletePromotionArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeletePromotionsArgs = {
    ids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteProvinceArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteRefundRequestArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteRoleArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteRolesArgs = {
    ids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteSellerArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteSellerCustomerPortfolioArgs = {
    ids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteSellersArgs = {
    ids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteShippingMethodArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteShippingMethodsArgs = {
    ids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteStockLocationArgs = {
    input: DeleteStockLocationInput;
};

export type MutationDeleteStockLocationsArgs = {
    input: Array<DeleteStockLocationInput>;
};

export type MutationDeleteSubscriptionEmailArgs = {
    id: Array<Scalars['ID']['input']>;
};

export type MutationDeleteSubscriptionPhoneArgs = {
    id: Array<Scalars['ID']['input']>;
};

export type MutationDeleteSurveyQuestionArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteSynonymGroupsArgs = {
    ids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteTagArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteTaxCategoriesArgs = {
    ids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteTaxCategoryArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteTaxRateArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteTaxRatesArgs = {
    ids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteWorkBrandArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteZoneArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteZonesArgs = {
    ids: Array<Scalars['ID']['input']>;
};

export type MutationDuplicateEntityArgs = {
    input: DuplicateEntityInput;
};

export type MutationFlushBufferedJobsArgs = {
    bufferIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MutationImportProductsArgs = {
    csvFile: Scalars['Upload']['input'];
};

export type MutationLoginArgs = {
    password: Scalars['String']['input'];
    rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
    username: Scalars['String']['input'];
};

export type MutationModifyOrderArgs = {
    input: ModifyOrderInput;
};

export type MutationMoveCollectionArgs = {
    input: MoveCollectionInput;
};

export type MutationRefundOrderArgs = {
    input: RefundOrderInput;
};

export type MutationRemoveBranchFromChannelsArgs = {
    branchId: Scalars['ID']['input'];
    channelIds: Array<Scalars['ID']['input']>;
};

export type MutationRemoveChannelFromBannerArgs = {
    input: RemoveChannelFromBannerInput;
};

export type MutationRemoveChannelFromPartnerArgs = {
    channelIds: Array<Scalars['ID']['input']>;
    partnerIds: Array<Scalars['ID']['input']>;
};

export type MutationRemoveChannelFromWorkBrandsArgs = {
    input: RemoveChannelFromWorkBrandsInput;
};

export type MutationRemoveCollectionsFromChannelArgs = {
    input: RemoveCollectionsFromChannelInput;
};

export type MutationRemoveCouponCodeFromDraftOrderArgs = {
    couponCode: Scalars['String']['input'];
    orderId: Scalars['ID']['input'];
};

export type MutationRemoveCustomerFromBranchArgs = {
    branchIds: Array<Scalars['ID']['input']>;
    customerId: Scalars['ID']['input'];
};

export type MutationRemoveCustomersFromGroupArgs = {
    customerGroupId: Scalars['ID']['input'];
    customerIds: Array<Scalars['ID']['input']>;
};

export type MutationRemoveDraftOrderLineArgs = {
    orderId: Scalars['ID']['input'];
    orderLineId: Scalars['ID']['input'];
};

export type MutationRemoveFacetsFromChannelArgs = {
    input: RemoveFacetsFromChannelInput;
};

export type MutationRemoveMembersFromZoneArgs = {
    memberIds: Array<Scalars['ID']['input']>;
    zoneId: Scalars['ID']['input'];
};

export type MutationRemoveOptionGroupFromProductArgs = {
    force?: InputMaybe<Scalars['Boolean']['input']>;
    optionGroupId: Scalars['ID']['input'];
    productId: Scalars['ID']['input'];
};

export type MutationRemovePaymentMethodsFromChannelArgs = {
    input: RemovePaymentMethodsFromChannelInput;
};

export type MutationRemoveProductVariantsFromChannelArgs = {
    input: RemoveProductVariantsFromChannelInput;
};

export type MutationRemoveProductsFromChannelArgs = {
    input: RemoveProductsFromChannelInput;
};

export type MutationRemovePromotionsFromChannelArgs = {
    input: RemovePromotionsFromChannelInput;
};

export type MutationRemoveSettledJobsArgs = {
    olderThan?: InputMaybe<Scalars['DateTime']['input']>;
    queueNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MutationRemoveShippingMethodsFromChannelArgs = {
    input: RemoveShippingMethodsFromChannelInput;
};

export type MutationRemoveShoppingListsArgs = {
    input: RemoveShoppingListsInput;
};

export type MutationRemoveStockLocationsFromChannelArgs = {
    input: RemoveStockLocationsFromChannelInput;
};

export type MutationSetChannelLogoArgs = {
    file: Scalars['Upload']['input'];
};

export type MutationSetCustomerForDraftOrderArgs = {
    customerId?: InputMaybe<Scalars['ID']['input']>;
    input?: InputMaybe<CreateCustomerInput>;
    orderId: Scalars['ID']['input'];
};

export type MutationSetDraftOrderBillingAddressArgs = {
    input: CreateAddressInput;
    orderId: Scalars['ID']['input'];
};

export type MutationSetDraftOrderCustomFieldsArgs = {
    input: UpdateOrderInput;
    orderId: Scalars['ID']['input'];
};

export type MutationSetDraftOrderShippingAddressArgs = {
    input: CreateAddressInput;
    orderId: Scalars['ID']['input'];
};

export type MutationSetDraftOrderShippingMethodArgs = {
    orderId: Scalars['ID']['input'];
    shippingMethodId: Scalars['ID']['input'];
};

export type MutationSetOrderCustomFieldsArgs = {
    input: UpdateOrderInput;
};

export type MutationSetOrderCustomerArgs = {
    input: SetOrderCustomerInput;
};

export type MutationSetWebhooksArgs = {
    webhooks: Array<WebhookInput>;
};

export type MutationSettlePaymentArgs = {
    id: Scalars['ID']['input'];
};

export type MutationSettleRefundArgs = {
    input: SettleRefundInput;
};

export type MutationSubmitMultipleSurveyResponsesArgs = {
    input: SubmitMultipleSurveyResponsesInput;
};

export type MutationSubmitSurveyResponseArgs = {
    answer: Scalars['JSON']['input'];
    customerId: Scalars['ID']['input'];
    orderId: Scalars['ID']['input'];
    questionId: Scalars['ID']['input'];
};

export type MutationSyncCustomerArgs = {
    customerId: Scalars['ID']['input'];
};

export type MutationSyncPricesForVariantArgs = {
    input: VariantPriceSync;
};

export type MutationSyncProductsBySkuArgs = {
    productId: Scalars['ID']['input'];
};

export type MutationTransitionFulfillmentToStateArgs = {
    id: Scalars['ID']['input'];
    state: Scalars['String']['input'];
};

export type MutationTransitionOrderToStateArgs = {
    id: Scalars['ID']['input'];
    state: Scalars['String']['input'];
};

export type MutationTransitionPaymentToStateArgs = {
    id: Scalars['ID']['input'];
    state: Scalars['String']['input'];
};

export type MutationUnsetDraftOrderBillingAddressArgs = {
    orderId: Scalars['ID']['input'];
};

export type MutationUnsetDraftOrderShippingAddressArgs = {
    orderId: Scalars['ID']['input'];
};

export type MutationUpdateActiveAdministratorArgs = {
    input: UpdateActiveAdministratorInput;
};

export type MutationUpdateAdministratorArgs = {
    input: UpdateAdministratorInput;
};

export type MutationUpdateAssetArgs = {
    input: UpdateAssetInput;
};

export type MutationUpdateBannerArgs = {
    input: UpdateBannerInput;
};

export type MutationUpdateBannerItemArgs = {
    input: UpdateBannerItemInput;
};

export type MutationUpdateCardBrandArgs = {
    input: UpdateCardBrandInput;
};

export type MutationUpdateCardFeeArgs = {
    input: UpdateCardFeeInput;
};

export type MutationUpdateChannelArgs = {
    input: UpdateChannelInput;
};

export type MutationUpdateChannelSocialMediaArgs = {
    input: UpdateChannelSocialMediaInput;
};

export type MutationUpdateCollectionArgs = {
    input: UpdateCollectionInput;
};

export type MutationUpdateCountryArgs = {
    input: UpdateCountryInput;
};

export type MutationUpdateCustomerArgs = {
    input: UpdateCustomerInput;
};

export type MutationUpdateCustomerAddressArgs = {
    input: UpdateAddressInput;
};

export type MutationUpdateCustomerGroupArgs = {
    input: UpdateCustomerGroupInput;
};

export type MutationUpdateCustomerNoteArgs = {
    input: UpdateCustomerNoteInput;
};

export type MutationUpdateFacetArgs = {
    input: UpdateFacetInput;
};

export type MutationUpdateFacetValuesArgs = {
    input: Array<UpdateFacetValueInput>;
};

export type MutationUpdateGlobalSettingsArgs = {
    input: UpdateGlobalSettingsInput;
};

export type MutationUpdateOrderNoteArgs = {
    input: UpdateOrderNoteInput;
};

export type MutationUpdatePackageArgs = {
    input: UpdatePackageInput;
};

export type MutationUpdatePartnerArgs = {
    input: PartnerUpdateInput;
};

export type MutationUpdatePaymentMethodArgs = {
    input: UpdatePaymentMethodInput;
};

export type MutationUpdateProductArgs = {
    input: UpdateProductInput;
};

export type MutationUpdateProductOptionArgs = {
    input: UpdateProductOptionInput;
};

export type MutationUpdateProductOptionGroupArgs = {
    input: UpdateProductOptionGroupInput;
};

export type MutationUpdateProductVariantArgs = {
    input: UpdateProductVariantInput;
};

export type MutationUpdateProductVariantsArgs = {
    input: Array<UpdateProductVariantInput>;
};

export type MutationUpdateProductsArgs = {
    input: Array<UpdateProductInput>;
};

export type MutationUpdatePromotionArgs = {
    input: UpdatePromotionInput;
};

export type MutationUpdateProvinceArgs = {
    input: UpdateProvinceInput;
};

export type MutationUpdateRefundRequestArgs = {
    id: Scalars['ID']['input'];
    input: UpdateRefundRequestInput;
};

export type MutationUpdateRoleArgs = {
    input: UpdateRoleInput;
};

export type MutationUpdateSellerArgs = {
    input: UpdateSellerInput;
};

export type MutationUpdateSellerCustomerPortfolioArgs = {
    input: SellerCustomerPortfolioUpdateInput;
};

export type MutationUpdateShippingMethodArgs = {
    input: UpdateShippingMethodInput;
};

export type MutationUpdateShoppingListArgs = {
    input: UpdateShoppingListInput;
};

export type MutationUpdateStockLocationArgs = {
    input: UpdateStockLocationInput;
};

export type MutationUpdateSubscriptionEmailArgs = {
    input: Array<EmailUpdateInput>;
};

export type MutationUpdateSubscriptionPhoneArgs = {
    input: Array<PhoneUpdateInput>;
};

export type MutationUpdateSurveyQuestionArgs = {
    id: Scalars['ID']['input'];
    input: UpdateSurveyQuestionInput;
};

export type MutationUpdateSynonymGroupArgs = {
    input: UpdateSynonymGroupInput;
};

export type MutationUpdateTagArgs = {
    input: UpdateTagInput;
};

export type MutationUpdateTaxCategoryArgs = {
    input: UpdateTaxCategoryInput;
};

export type MutationUpdateTaxRateArgs = {
    input: UpdateTaxRateInput;
};

export type MutationUpdateWorkBrandArgs = {
    input?: InputMaybe<UpdateWorkBrandInput>;
};

export type MutationUpdateZoneArgs = {
    input: UpdateZoneInput;
};

export type NativeAuthInput = {
    password: Scalars['String']['input'];
    username: Scalars['String']['input'];
};

/** Returned when attempting an operation that relies on the NativeAuthStrategy, if that strategy is not configured. */
export type NativeAuthStrategyError = ErrorResult & {
    __typename?: 'NativeAuthStrategyError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

export type NativeAuthenticationResult =
    | CurrentUser
    | InvalidCredentialsError
    | NativeAuthStrategyError;

/** Returned when attempting to set a negative OrderLine quantity. */
export type NegativeQuantityError = ErrorResult & {
    __typename?: 'NegativeQuantityError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

/**
 * Returned when invoking a mutation which depends on there being an active Order on the
 * current session.
 */
export type NoActiveOrderError = ErrorResult & {
    __typename?: 'NoActiveOrderError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

/** Returned when a call to modifyOrder fails to specify any changes */
export type NoChangesSpecifiedError = ErrorResult & {
    __typename?: 'NoChangesSpecifiedError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

export type NoSellerAssignedError = {
    __typename?: 'NoSellerAssignedError';
    errorCode: Scalars['String']['output'];
    message: Scalars['String']['output'];
};

export type Node = {
    id: Scalars['ID']['output'];
};

export type NormalizeAccountStatus = {
    __typename?: 'NormalizeAccountStatus';
    errors: Array<Maybe<ErrorsAccountStatus>>;
    isAccountOkay: Scalars['Boolean']['output'];
    normalizeAccountStatusByChannel: Array<NormalizeAccountStatusByChannel>;
};

export type NormalizeAccountStatusByChannel = {
    __typename?: 'NormalizeAccountStatusByChannel';
    channelCode: Scalars['String']['output'];
    channelId: Scalars['ID']['output'];
    hasPaymentCondition: Scalars['Boolean']['output'];
    hasProductVisibility: Scalars['Boolean']['output'];
    isAccountOkay: Scalars['Boolean']['output'];
    isBlocked: Scalars['Boolean']['output'];
};

export type NormalizeProductStatus = {
    __typename?: 'NormalizeProductStatus';
    details: ProductStatusDetails;
    errors: Array<ProductError>;
    isProductOkay: Scalars['Boolean']['output'];
};

/** Returned if an attempting to refund an Order but neither items nor shipping refund was specified */
export type NothingToRefundError = ErrorResult & {
    __typename?: 'NothingToRefundError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

/** Operators for filtering on a list of Number fields */
export type NumberListOperators = {
    inList: Scalars['Float']['input'];
};

/** Operators for filtering on a Int or Float field */
export type NumberOperators = {
    between?: InputMaybe<NumberRange>;
    eq?: InputMaybe<Scalars['Float']['input']>;
    gt?: InputMaybe<Scalars['Float']['input']>;
    gte?: InputMaybe<Scalars['Float']['input']>;
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
    lt?: InputMaybe<Scalars['Float']['input']>;
    lte?: InputMaybe<Scalars['Float']['input']>;
};

export type NumberRange = {
    end: Scalars['Float']['input'];
    start: Scalars['Float']['input'];
};

export type Order = Node & {
    __typename?: 'Order';
    /** An order is active as long as the payment process has not been completed */
    active: Scalars['Boolean']['output'];
    aggregateOrder?: Maybe<Order>;
    aggregateOrderId?: Maybe<Scalars['ID']['output']>;
    billingAddress?: Maybe<OrderAddress>;
    channels: Array<Channel>;
    /** A unique code for the Order */
    code: Scalars['String']['output'];
    /** An array of all coupon codes applied to the Order */
    couponCodes: Array<Scalars['String']['output']>;
    createdAt: Scalars['DateTime']['output'];
    currencyCode: CurrencyCode;
    customFields?: Maybe<OrderCustomFields>;
    customer?: Maybe<Customer>;
    discounts: Array<Discount>;
    fulfillments?: Maybe<Array<Fulfillment>>;
    history: HistoryEntryList;
    id: Scalars['ID']['output'];
    lines: Array<OrderLine>;
    modifications: Array<OrderModification>;
    nextStates: Array<Scalars['String']['output']>;
    /**
     * The date & time that the Order was placed, i.e. the Customer
     * completed the checkout and the Order is no longer "active"
     */
    orderPlacedAt?: Maybe<Scalars['DateTime']['output']>;
    payments?: Maybe<Array<Payment>>;
    /** Promotions applied to the order. Only gets populated after the payment process has completed. */
    promotions: Array<Promotion>;
    sellerOrders?: Maybe<Array<Order>>;
    shipping: Scalars['Money']['output'];
    shippingAddress?: Maybe<OrderAddress>;
    shippingLines: Array<ShippingLine>;
    shippingWithTax: Scalars['Money']['output'];
    state: Scalars['String']['output'];
    /**
     * The subTotal is the total of all OrderLines in the Order. This figure also includes any Order-level
     * discounts which have been prorated (proportionally distributed) amongst the items of each OrderLine.
     * To get a total of all OrderLines which does not account for prorated discounts, use the
     * sum of `OrderLine.discountedLinePrice` values.
     */
    subTotal: Scalars['Money']['output'];
    /** Same as subTotal, but inclusive of tax */
    subTotalWithTax: Scalars['Money']['output'];
    /**
     * Surcharges are arbitrary modifications to the Order total which are neither
     * ProductVariants nor discounts resulting from applied Promotions. For example,
     * one-off discounts based on customer interaction, or surcharges based on payment
     * methods.
     */
    surcharges: Array<Surcharge>;
    /** A summary of the taxes being applied to this Order */
    taxSummary: Array<OrderTaxSummary>;
    /** Equal to subTotal plus shipping */
    total: Scalars['Money']['output'];
    totalQuantity: Scalars['Int']['output'];
    /** The final payable amount. Equal to subTotalWithTax plus shippingWithTax */
    totalWithTax: Scalars['Money']['output'];
    type: OrderType;
    updatedAt: Scalars['DateTime']['output'];
};

export type OrderHistoryArgs = {
    options?: InputMaybe<HistoryEntryListOptions>;
};

export type OrderAddress = {
    __typename?: 'OrderAddress';
    city?: Maybe<Scalars['String']['output']>;
    company?: Maybe<Scalars['String']['output']>;
    country?: Maybe<Scalars['String']['output']>;
    countryCode?: Maybe<Scalars['String']['output']>;
    customFields?: Maybe<AddressCustomFields>;
    fullName?: Maybe<Scalars['String']['output']>;
    phoneNumber?: Maybe<Scalars['String']['output']>;
    postalCode?: Maybe<Scalars['String']['output']>;
    province?: Maybe<Scalars['String']['output']>;
    streetLine1?: Maybe<Scalars['String']['output']>;
    streetLine2?: Maybe<Scalars['String']['output']>;
};

export type OrderCustomFields = {
    __typename?: 'OrderCustomFields';
    externalId?: Maybe<Scalars['String']['output']>;
    installments?: Maybe<Scalars['Int']['output']>;
    orderToken?: Maybe<Scalars['String']['output']>;
    origin?: Maybe<Scalars['String']['output']>;
    pagarmeBoletoUrl?: Maybe<Scalars['String']['output']>;
    pagarmeMetadata?: Maybe<Scalars['String']['output']>;
    pagarmeOrderId?: Maybe<Scalars['String']['output']>;
    pagarmePaymentType?: Maybe<Scalars['String']['output']>;
    pagarmeQrcode?: Maybe<Scalars['String']['output']>;
    paymentConditionType?: Maybe<Scalars['String']['output']>;
    previousOrder?: Maybe<Order>;
    seller?: Maybe<Administrator>;
    serviceOrder?: Maybe<Scalars['String']['output']>;
    serviceOrderObservation?: Maybe<Scalars['String']['output']>;
    splitProcessCompleted?: Maybe<Scalars['Boolean']['output']>;
    splitProcessStatus?: Maybe<Scalars['String']['output']>;
    splitRetryCount?: Maybe<Scalars['Int']['output']>;
};

export type OrderFilterParameter = {
    _and?: InputMaybe<Array<OrderFilterParameter>>;
    _or?: InputMaybe<Array<OrderFilterParameter>>;
    active?: InputMaybe<BooleanOperators>;
    aggregateOrderId?: InputMaybe<IdOperators>;
    code?: InputMaybe<StringOperators>;
    createdAt?: InputMaybe<DateOperators>;
    currencyCode?: InputMaybe<StringOperators>;
    customerLastName?: InputMaybe<StringOperators>;
    externalId?: InputMaybe<StringOperators>;
    id?: InputMaybe<IdOperators>;
    installments?: InputMaybe<NumberOperators>;
    orderPlacedAt?: InputMaybe<DateOperators>;
    orderToken?: InputMaybe<StringOperators>;
    origin?: InputMaybe<StringOperators>;
    pagarmeBoletoUrl?: InputMaybe<StringOperators>;
    pagarmeMetadata?: InputMaybe<StringOperators>;
    pagarmeOrderId?: InputMaybe<StringOperators>;
    pagarmePaymentType?: InputMaybe<StringOperators>;
    pagarmeQrcode?: InputMaybe<StringOperators>;
    paymentConditionType?: InputMaybe<StringOperators>;
    serviceOrder?: InputMaybe<StringOperators>;
    serviceOrderObservation?: InputMaybe<StringOperators>;
    shipping?: InputMaybe<NumberOperators>;
    shippingWithTax?: InputMaybe<NumberOperators>;
    splitProcessCompleted?: InputMaybe<BooleanOperators>;
    splitProcessStatus?: InputMaybe<StringOperators>;
    splitRetryCount?: InputMaybe<NumberOperators>;
    state?: InputMaybe<StringOperators>;
    subTotal?: InputMaybe<NumberOperators>;
    subTotalWithTax?: InputMaybe<NumberOperators>;
    total?: InputMaybe<NumberOperators>;
    totalQuantity?: InputMaybe<NumberOperators>;
    totalWithTax?: InputMaybe<NumberOperators>;
    transactionId?: InputMaybe<StringOperators>;
    type?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

/** Returned when an order operation is rejected by an OrderInterceptor method. */
export type OrderInterceptorError = ErrorResult & {
    __typename?: 'OrderInterceptorError';
    errorCode: ErrorCode;
    interceptorError: Scalars['String']['output'];
    message: Scalars['String']['output'];
};

/** Returned when the maximum order size limit has been reached. */
export type OrderLimitError = ErrorResult & {
    __typename?: 'OrderLimitError';
    errorCode: ErrorCode;
    maxItems: Scalars['Int']['output'];
    message: Scalars['String']['output'];
};

export type OrderLine = Node & {
    __typename?: 'OrderLine';
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<OrderLineCustomFields>;
    /** The price of the line including discounts, excluding tax */
    discountedLinePrice: Scalars['Money']['output'];
    /** The price of the line including discounts and tax */
    discountedLinePriceWithTax: Scalars['Money']['output'];
    /**
     * The price of a single unit including discounts, excluding tax.
     *
     * If Order-level discounts have been applied, this will not be the
     * actual taxable unit price (see `proratedUnitPrice`), but is generally the
     * correct price to display to customers to avoid confusion
     * about the internal handling of distributed Order-level discounts.
     */
    discountedUnitPrice: Scalars['Money']['output'];
    /** The price of a single unit including discounts and tax */
    discountedUnitPriceWithTax: Scalars['Money']['output'];
    discounts: Array<Discount>;
    featuredAsset?: Maybe<Asset>;
    fulfillmentLines?: Maybe<Array<FulfillmentLine>>;
    id: Scalars['ID']['output'];
    /** The total price of the line excluding tax and discounts. */
    linePrice: Scalars['Money']['output'];
    /** The total price of the line including tax but excluding discounts. */
    linePriceWithTax: Scalars['Money']['output'];
    /** The total tax on this line */
    lineTax: Scalars['Money']['output'];
    order: Order;
    /** The quantity at the time the Order was placed */
    orderPlacedQuantity: Scalars['Int']['output'];
    productVariant: ProductVariant;
    /**
     * The actual line price, taking into account both item discounts _and_ prorated (proportionally-distributed)
     * Order-level discounts. This value is the true economic value of the OrderLine, and is used in tax
     * and refund calculations.
     */
    proratedLinePrice: Scalars['Money']['output'];
    /** The proratedLinePrice including tax */
    proratedLinePriceWithTax: Scalars['Money']['output'];
    /**
     * The actual unit price, taking into account both item discounts _and_ prorated (proportionally-distributed)
     * Order-level discounts. This value is the true economic value of the OrderItem, and is used in tax
     * and refund calculations.
     */
    proratedUnitPrice: Scalars['Money']['output'];
    /** The proratedUnitPrice including tax */
    proratedUnitPriceWithTax: Scalars['Money']['output'];
    /** The quantity of items purchased */
    quantity: Scalars['Int']['output'];
    taxLines: Array<TaxLine>;
    taxRate: Scalars['Float']['output'];
    /** The price of a single unit, excluding tax and discounts */
    unitPrice: Scalars['Money']['output'];
    /** Non-zero if the unitPrice has changed since it was initially added to Order */
    unitPriceChangeSinceAdded: Scalars['Money']['output'];
    /** The price of a single unit, including tax but excluding discounts */
    unitPriceWithTax: Scalars['Money']['output'];
    /** Non-zero if the unitPriceWithTax has changed since it was initially added to Order */
    unitPriceWithTaxChangeSinceAdded: Scalars['Money']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type OrderLineCustomFields = {
    __typename?: 'OrderLineCustomFields';
    bonus?: Maybe<Scalars['Boolean']['output']>;
    channel?: Maybe<Channel>;
    channelId?: Maybe<Scalars['Int']['output']>;
    channelName?: Maybe<Scalars['String']['output']>;
    color?: Maybe<Scalars['String']['output']>;
    logo?: Maybe<Scalars['String']['output']>;
};

export type OrderLineCustomFieldsInput = {
    bonus?: InputMaybe<Scalars['Boolean']['input']>;
    channelId?: InputMaybe<Scalars['Int']['input']>;
    channelName?: InputMaybe<Scalars['String']['input']>;
    color?: InputMaybe<Scalars['String']['input']>;
    logo?: InputMaybe<Scalars['String']['input']>;
};

export type OrderLineInput = {
    customFields?: InputMaybe<OrderLineCustomFieldsInput>;
    orderLineId: Scalars['ID']['input'];
    quantity: Scalars['Int']['input'];
};

export type OrderList = PaginatedList & {
    __typename?: 'OrderList';
    items: Array<Order>;
    totalItems: Scalars['Int']['output'];
};

export type OrderListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<OrderFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<OrderSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderModification = Node & {
    __typename?: 'OrderModification';
    createdAt: Scalars['DateTime']['output'];
    id: Scalars['ID']['output'];
    isSettled: Scalars['Boolean']['output'];
    lines: Array<OrderModificationLine>;
    note: Scalars['String']['output'];
    payment?: Maybe<Payment>;
    priceChange: Scalars['Money']['output'];
    refund?: Maybe<Refund>;
    surcharges?: Maybe<Array<Surcharge>>;
    updatedAt: Scalars['DateTime']['output'];
};

/** Returned when attempting to modify the contents of an Order that is not in the `AddingItems` state. */
export type OrderModificationError = ErrorResult & {
    __typename?: 'OrderModificationError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

export type OrderModificationLine = {
    __typename?: 'OrderModificationLine';
    modification: OrderModification;
    modificationId: Scalars['ID']['output'];
    orderLine: OrderLine;
    orderLineId: Scalars['ID']['output'];
    quantity: Scalars['Int']['output'];
};

/** Returned when attempting to modify the contents of an Order that is not in the `Modifying` state. */
export type OrderModificationStateError = ErrorResult & {
    __typename?: 'OrderModificationStateError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

export enum OrderPaymentConditionType {
    normal = 'normal',
    special = 'special',
}

export type OrderProcessState = {
    __typename?: 'OrderProcessState';
    name: Scalars['String']['output'];
    to: Array<Scalars['String']['output']>;
};

export type OrderSortParameter = {
    aggregateOrderId?: InputMaybe<SortOrder>;
    code?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    customerLastName?: InputMaybe<SortOrder>;
    externalId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    installments?: InputMaybe<SortOrder>;
    orderPlacedAt?: InputMaybe<SortOrder>;
    orderToken?: InputMaybe<SortOrder>;
    origin?: InputMaybe<SortOrder>;
    pagarmeBoletoUrl?: InputMaybe<SortOrder>;
    pagarmeMetadata?: InputMaybe<SortOrder>;
    pagarmeOrderId?: InputMaybe<SortOrder>;
    pagarmePaymentType?: InputMaybe<SortOrder>;
    pagarmeQrcode?: InputMaybe<SortOrder>;
    paymentConditionType?: InputMaybe<SortOrder>;
    previousOrder?: InputMaybe<SortOrder>;
    seller?: InputMaybe<SortOrder>;
    serviceOrder?: InputMaybe<SortOrder>;
    serviceOrderObservation?: InputMaybe<SortOrder>;
    shipping?: InputMaybe<SortOrder>;
    shippingWithTax?: InputMaybe<SortOrder>;
    splitProcessCompleted?: InputMaybe<SortOrder>;
    splitProcessStatus?: InputMaybe<SortOrder>;
    splitRetryCount?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    subTotal?: InputMaybe<SortOrder>;
    subTotalWithTax?: InputMaybe<SortOrder>;
    total?: InputMaybe<SortOrder>;
    totalQuantity?: InputMaybe<SortOrder>;
    totalWithTax?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

/** Returned if there is an error in transitioning the Order state */
export type OrderStateTransitionError = ErrorResult & {
    __typename?: 'OrderStateTransitionError';
    errorCode: ErrorCode;
    fromState: Scalars['String']['output'];
    message: Scalars['String']['output'];
    toState: Scalars['String']['output'];
    transitionError: Scalars['String']['output'];
};

/**
 * A summary of the taxes being applied to this order, grouped
 * by taxRate.
 */
export type OrderTaxSummary = {
    __typename?: 'OrderTaxSummary';
    /** A description of this tax */
    description: Scalars['String']['output'];
    /** The total net price of OrderLines to which this taxRate applies */
    taxBase: Scalars['Money']['output'];
    /** The taxRate as a percentage */
    taxRate: Scalars['Float']['output'];
    /** The total tax being applied to the Order at this taxRate */
    taxTotal: Scalars['Money']['output'];
};

export enum OrderType {
    Aggregate = 'Aggregate',
    Regular = 'Regular',
    Seller = 'Seller',
}

export type Package = Node & {
    __typename?: 'Package';
    distanceUnit: DistanceUnit;
    enabled: Scalars['Boolean']['output'];
    height: Scalars['Float']['output'];
    id: Scalars['ID']['output'];
    length: Scalars['Float']['output'];
    massUnit: MassUnit;
    name: Scalars['String']['output'];
    weight: Scalars['Float']['output'];
    width: Scalars['Float']['output'];
};

export type PackageFilterParameter = {
    _and?: InputMaybe<Array<PackageFilterParameter>>;
    _or?: InputMaybe<Array<PackageFilterParameter>>;
    distanceUnit?: InputMaybe<StringOperators>;
    enabled?: InputMaybe<BooleanOperators>;
    height?: InputMaybe<NumberOperators>;
    id?: InputMaybe<IdOperators>;
    length?: InputMaybe<NumberOperators>;
    massUnit?: InputMaybe<StringOperators>;
    name?: InputMaybe<StringOperators>;
    weight?: InputMaybe<NumberOperators>;
    width?: InputMaybe<NumberOperators>;
};

export type PackageList = PaginatedList & {
    __typename?: 'PackageList';
    items: Array<Package>;
    totalItems: Scalars['Int']['output'];
};

export type PackageListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<PackageFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<PackageSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type PackageSortParameter = {
    height?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    length?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    weight?: InputMaybe<SortOrder>;
    width?: InputMaybe<SortOrder>;
};

export type PaginatedList = {
    items: Array<Node>;
    totalItems: Scalars['Int']['output'];
};

export type Partner = Node & {
    __typename?: 'Partner';
    channels: Array<Channel>;
    city: Scalars['String']['output'];
    cnpj: Scalars['String']['output'];
    createdAt: Scalars['DateTime']['output'];
    description?: Maybe<Scalars['String']['output']>;
    enabled: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    link?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    neighborhood?: Maybe<Scalars['String']['output']>;
    phoneNumber?: Maybe<Scalars['String']['output']>;
    photo?: Maybe<Asset>;
    postalCode?: Maybe<Scalars['String']['output']>;
    province: Scalars['String']['output'];
    showPhoto: Scalars['Boolean']['output'];
    streetLine1?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTime']['output'];
};

export type PartnerAlreadyExistsError = {
    __typename?: 'PartnerAlreadyExistsError';
    errorCode: Scalars['String']['output'];
    message: Scalars['String']['output'];
};

export type PartnerDetails = {
    __typename?: 'PartnerDetails';
    id?: Maybe<Scalars['ID']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    photo?: Maybe<PartnerPhoto>;
};

export type PartnerFilterParameter = {
    _and?: InputMaybe<Array<PartnerFilterParameter>>;
    _or?: InputMaybe<Array<PartnerFilterParameter>>;
    city?: InputMaybe<StringOperators>;
    cnpj?: InputMaybe<StringOperators>;
    createdAt?: InputMaybe<DateOperators>;
    description?: InputMaybe<StringOperators>;
    enabled?: InputMaybe<BooleanOperators>;
    id?: InputMaybe<IdOperators>;
    link?: InputMaybe<StringOperators>;
    name?: InputMaybe<StringOperators>;
    neighborhood?: InputMaybe<StringOperators>;
    phoneNumber?: InputMaybe<StringOperators>;
    postalCode?: InputMaybe<StringOperators>;
    province?: InputMaybe<StringOperators>;
    showPhoto?: InputMaybe<BooleanOperators>;
    streetLine1?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type PartnerInput = {
    channelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    city: Scalars['String']['input'];
    cnpj: Scalars['String']['input'];
    description?: InputMaybe<Scalars['String']['input']>;
    enabled: Scalars['Boolean']['input'];
    link?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    neighborhood?: InputMaybe<Scalars['String']['input']>;
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
    photoId?: InputMaybe<Scalars['ID']['input']>;
    postalCode?: InputMaybe<Scalars['String']['input']>;
    province: Scalars['String']['input'];
    showPhoto: Scalars['Boolean']['input'];
    streetLine1?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerList = PaginatedList & {
    __typename?: 'PartnerList';
    items: Array<Partner>;
    totalItems: Scalars['Int']['output'];
};

export type PartnerListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<PartnerFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<PartnerSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type PartnerNameAlreadyExistsError = {
    __typename?: 'PartnerNameAlreadyExistsError';
    errorCode: Scalars['String']['output'];
    message: Scalars['String']['output'];
};

export type PartnerNotFoundError = {
    __typename?: 'PartnerNotFoundError';
    errorCode: Scalars['String']['output'];
    message: Scalars['String']['output'];
};

export type PartnerPhoto = {
    __typename?: 'PartnerPhoto';
    height?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    preview?: Maybe<Scalars['String']['output']>;
    width?: Maybe<Scalars['Int']['output']>;
};

export type PartnerSortParameter = {
    city?: InputMaybe<SortOrder>;
    cnpj?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    link?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    neighborhood?: InputMaybe<SortOrder>;
    phoneNumber?: InputMaybe<SortOrder>;
    postalCode?: InputMaybe<SortOrder>;
    province?: InputMaybe<SortOrder>;
    streetLine1?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PartnerUpdateInput = {
    channelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    city: Scalars['String']['input'];
    cnpj?: InputMaybe<Scalars['String']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    enabled: Scalars['Boolean']['input'];
    id: Scalars['ID']['input'];
    link?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    neighborhood?: InputMaybe<Scalars['String']['input']>;
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
    photoId?: InputMaybe<Scalars['ID']['input']>;
    postalCode?: InputMaybe<Scalars['String']['input']>;
    province: Scalars['String']['input'];
    showPhoto: Scalars['Boolean']['input'];
    streetLine1?: InputMaybe<Scalars['String']['input']>;
};

export type Payment = Node & {
    __typename?: 'Payment';
    amount: Scalars['Money']['output'];
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<Scalars['JSON']['output']>;
    errorMessage?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    metadata?: Maybe<Scalars['JSON']['output']>;
    method: Scalars['String']['output'];
    nextStates: Array<Scalars['String']['output']>;
    refunds: Array<Refund>;
    state: Scalars['String']['output'];
    transactionId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTime']['output'];
};

export type PaymentCondition = Node & {
    __typename?: 'PaymentCondition';
    channel?: Maybe<Channel>;
    createdAt: Scalars['DateTime']['output'];
    enabled: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    isFavorite: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    owner?: Maybe<Customer>;
    paymentToken: PaymentToken;
    sourceType: PaymentConditionSourceType;
    type: PaymentTokenTypes;
    updatedAt: Scalars['DateTime']['output'];
};

export type PaymentConditionByChannel = Node & {
    __typename?: 'PaymentConditionByChannel';
    createdAt: Scalars['DateTime']['output'];
    enabled: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    isFavorite: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    paymentToken?: Maybe<PaymentToken>;
    sourceType: PaymentConditionSourceType;
    type: PaymentTokenTypes;
    updatedAt: Scalars['DateTime']['output'];
};

export type PaymentConditionList = PaginatedList & {
    __typename?: 'PaymentConditionList';
    items: Array<PaymentCondition>;
    totalItems: Scalars['Int']['output'];
};

export type PaymentMethod = Node & {
    __typename?: 'PaymentMethod';
    checker?: Maybe<ConfigurableOperation>;
    code: Scalars['String']['output'];
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<Scalars['JSON']['output']>;
    description: Scalars['String']['output'];
    enabled: Scalars['Boolean']['output'];
    handler: ConfigurableOperation;
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    translations: Array<PaymentMethodTranslation>;
    updatedAt: Scalars['DateTime']['output'];
};

export type PaymentMethodFilterParameter = {
    _and?: InputMaybe<Array<PaymentMethodFilterParameter>>;
    _or?: InputMaybe<Array<PaymentMethodFilterParameter>>;
    code?: InputMaybe<StringOperators>;
    createdAt?: InputMaybe<DateOperators>;
    description?: InputMaybe<StringOperators>;
    enabled?: InputMaybe<BooleanOperators>;
    id?: InputMaybe<IdOperators>;
    name?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type PaymentMethodList = PaginatedList & {
    __typename?: 'PaymentMethodList';
    items: Array<PaymentMethod>;
    totalItems: Scalars['Int']['output'];
};

export type PaymentMethodListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<PaymentMethodFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<PaymentMethodSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Returned when a call to modifyOrder fails to include a paymentMethod even
 * though the price has increased as a result of the changes.
 */
export type PaymentMethodMissingError = ErrorResult & {
    __typename?: 'PaymentMethodMissingError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

export type PaymentMethodQuote = {
    __typename?: 'PaymentMethodQuote';
    code: Scalars['String']['output'];
    customFields?: Maybe<Scalars['JSON']['output']>;
    description: Scalars['String']['output'];
    eligibilityMessage?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    isEligible: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
};

export type PaymentMethodSortParameter = {
    code?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentMethodTranslation = {
    __typename?: 'PaymentMethodTranslation';
    createdAt: Scalars['DateTime']['output'];
    description: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    languageCode: LanguageCode;
    name: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type PaymentMethodTranslationInput = {
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    languageCode: LanguageCode;
    name?: InputMaybe<Scalars['String']['input']>;
};

/** Returned if an attempting to refund a Payment against OrderLines from a different Order */
export type PaymentOrderMismatchError = ErrorResult & {
    __typename?: 'PaymentOrderMismatchError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

/** Returned when there is an error in transitioning the Payment state */
export type PaymentStateTransitionError = ErrorResult & {
    __typename?: 'PaymentStateTransitionError';
    errorCode: ErrorCode;
    fromState: Scalars['String']['output'];
    message: Scalars['String']['output'];
    toState: Scalars['String']['output'];
    transitionError: Scalars['String']['output'];
};

export type PaymentToken = Node & {
    __typename?: 'PaymentToken';
    bankSlipPaymentCondition?: Maybe<BankSlipPaymentCondition>;
    card?: Maybe<Card>;
    createdAt: Scalars['DateTime']['output'];
    expiresAt: Scalars['DateTime']['output'];
    holderDocument?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    isFavorite: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    paymentCompany: Scalars['String']['output'];
    tokenId?: Maybe<Scalars['String']['output']>;
    type: PaymentTokenTypes;
    updatedAt: Scalars['DateTime']['output'];
};

/**
 * @description
 * Permissions for administrators and customers. Used to control access to
 * GraphQL resolvers via the {@link Allow} decorator.
 *
 * ## Understanding Permission.Owner
 *
 * `Permission.Owner` is a special permission which is used in some Vendure resolvers to indicate that that resolver should only
 * be accessible to the "owner" of that resource.
 *
 * For example, the Shop API `activeCustomer` query resolver should only return the Customer object for the "owner" of that Customer, i.e.
 * based on the activeUserId of the current session. As a result, the resolver code looks like this:
 *
 * @example
 * ```TypeScript
 * \@Query()
 * \@Allow(Permission.Owner)
 * async activeCustomer(\@Ctx() ctx: RequestContext): Promise<Customer | undefined> {
 *   const userId = ctx.activeUserId;
 *   if (userId) {
 *     return this.customerService.findOneByUserId(ctx, userId);
 *   }
 * }
 * ```
 *
 * Here we can see that the "ownership" must be enforced by custom logic inside the resolver. Since "ownership" cannot be defined generally
 * nor statically encoded at build-time, any resolvers using `Permission.Owner` **must** include logic to enforce that only the owner
 * of the resource has access. If not, then it is the equivalent of using `Permission.Public`.
 *
 *
 * @docsCategory common
 */
export enum Permission {
    /** Authenticated means simply that the user is logged in */
    Authenticated = 'Authenticated',
    /** Grants permission to create Administrator */
    CreateAdministrator = 'CreateAdministrator',
    /** Grants permission to create Asset */
    CreateAsset = 'CreateAsset',
    /** Grants permission to create Banner */
    CreateBanner = 'CreateBanner',
    /** Grants permission to create BannerItem */
    CreateBannerItem = 'CreateBannerItem',
    /** Grants permission to create CardBrand */
    CreateCardBrand = 'CreateCardBrand',
    /** Grants permission to create CardFee */
    CreateCardFee = 'CreateCardFee',
    /** Grants permission to create Products, Facets, Assets, Collections */
    CreateCatalog = 'CreateCatalog',
    /** Grants permission to create Channel */
    CreateChannel = 'CreateChannel',
    /** Grants permission to create Collection */
    CreateCollection = 'CreateCollection',
    /** Grants permission to create Country */
    CreateCountry = 'CreateCountry',
    /** Grants permission to create Customer */
    CreateCustomer = 'CreateCustomer',
    /** Grants permission to create CustomerGroup */
    CreateCustomerGroup = 'CreateCustomerGroup',
    /** Grants permission to create Facet */
    CreateFacet = 'CreateFacet',
    /** Grants permission to create Order */
    CreateOrder = 'CreateOrder',
    /** Grants permission to create PaymentMethod */
    CreatePaymentMethod = 'CreatePaymentMethod',
    /** Grants permission to create Product */
    CreateProduct = 'CreateProduct',
    /** Grants permission to create Promotion */
    CreatePromotion = 'CreatePromotion',
    /** Grants permission to create Recipient */
    CreateRecipient = 'CreateRecipient',
    /** Grants permission to create Seller */
    CreateSeller = 'CreateSeller',
    /** Grants permission to create Sellers */
    CreateSellers = 'CreateSellers',
    /** Grants permission to create PaymentMethods, ShippingMethods, TaxCategories, TaxRates, Zones, Countries, System & GlobalSettings */
    CreateSettings = 'CreateSettings',
    /** Grants permission to create ShippingMethod */
    CreateShippingMethod = 'CreateShippingMethod',
    /** Grants permission to create ShoppingList */
    CreateShoppingList = 'CreateShoppingList',
    /** Grants permission to create SocialMedia */
    CreateSocialMedia = 'CreateSocialMedia',
    /** Grants permission to create StockLocation */
    CreateStockLocation = 'CreateStockLocation',
    /** Grants permission to create System */
    CreateSystem = 'CreateSystem',
    /** Grants permission to create Tag */
    CreateTag = 'CreateTag',
    /** Grants permission to create TaxCategory */
    CreateTaxCategory = 'CreateTaxCategory',
    /** Grants permission to create TaxRate */
    CreateTaxRate = 'CreateTaxRate',
    /** Grants permission to create Zone */
    CreateZone = 'CreateZone',
    /** Grants permission to delete Administrator */
    DeleteAdministrator = 'DeleteAdministrator',
    /** Grants permission to delete Asset */
    DeleteAsset = 'DeleteAsset',
    /** Grants permission to delete Banner */
    DeleteBanner = 'DeleteBanner',
    /** Grants permission to delete BannerItem */
    DeleteBannerItem = 'DeleteBannerItem',
    /** Grants permission to delete CardBrand */
    DeleteCardBrand = 'DeleteCardBrand',
    /** Grants permission to delete CardFee */
    DeleteCardFee = 'DeleteCardFee',
    /** Grants permission to delete Products, Facets, Assets, Collections */
    DeleteCatalog = 'DeleteCatalog',
    /** Grants permission to delete Channel */
    DeleteChannel = 'DeleteChannel',
    /** Grants permission to delete Collection */
    DeleteCollection = 'DeleteCollection',
    /** Grants permission to delete Country */
    DeleteCountry = 'DeleteCountry',
    /** Grants permission to delete Customer */
    DeleteCustomer = 'DeleteCustomer',
    /** Grants permission to delete CustomerGroup */
    DeleteCustomerGroup = 'DeleteCustomerGroup',
    /** Grants permission to delete Facet */
    DeleteFacet = 'DeleteFacet',
    /** Grants permission to delete Order */
    DeleteOrder = 'DeleteOrder',
    /** Grants permission to delete PaymentMethod */
    DeletePaymentMethod = 'DeletePaymentMethod',
    /** Grants permission to delete Product */
    DeleteProduct = 'DeleteProduct',
    /** Grants permission to delete Promotion */
    DeletePromotion = 'DeletePromotion',
    /** Grants permission to delete Recipient */
    DeleteRecipient = 'DeleteRecipient',
    /** Grants permission to delete Seller */
    DeleteSeller = 'DeleteSeller',
    /** Grants permission to delete Sellers */
    DeleteSellers = 'DeleteSellers',
    /** Grants permission to delete PaymentMethods, ShippingMethods, TaxCategories, TaxRates, Zones, Countries, System & GlobalSettings */
    DeleteSettings = 'DeleteSettings',
    /** Grants permission to delete ShippingMethod */
    DeleteShippingMethod = 'DeleteShippingMethod',
    /** Grants permission to delete ShoppingList */
    DeleteShoppingList = 'DeleteShoppingList',
    /** Grants permission to delete SocialMedia */
    DeleteSocialMedia = 'DeleteSocialMedia',
    /** Grants permission to delete StockLocation */
    DeleteStockLocation = 'DeleteStockLocation',
    /** Grants permission to delete System */
    DeleteSystem = 'DeleteSystem',
    /** Grants permission to delete Tag */
    DeleteTag = 'DeleteTag',
    /** Grants permission to delete TaxCategory */
    DeleteTaxCategory = 'DeleteTaxCategory',
    /** Grants permission to delete TaxRate */
    DeleteTaxRate = 'DeleteTaxRate',
    /** Grants permission to delete Zone */
    DeleteZone = 'DeleteZone',
    /** Owner means the user owns this entity, e.g. a Customer's own Order */
    Owner = 'Owner',
    /** Public means any unauthenticated user may perform the operation */
    Public = 'Public',
    /** Grants permission to read Administrator */
    ReadAdministrator = 'ReadAdministrator',
    /** Grants permission to read Asset */
    ReadAsset = 'ReadAsset',
    /** Grants permission to read Banner */
    ReadBanner = 'ReadBanner',
    /** Grants permission to read BannerItem */
    ReadBannerItem = 'ReadBannerItem',
    /** Grants permission to read CardBrand */
    ReadCardBrand = 'ReadCardBrand',
    /** Grants permission to read CardFee */
    ReadCardFee = 'ReadCardFee',
    /** Grants permission to read Products, Facets, Assets, Collections */
    ReadCatalog = 'ReadCatalog',
    /** Grants permission to read Channel */
    ReadChannel = 'ReadChannel',
    /** Grants permission to read Collection */
    ReadCollection = 'ReadCollection',
    /** Grants permission to read Country */
    ReadCountry = 'ReadCountry',
    /** Grants permission to read Customer */
    ReadCustomer = 'ReadCustomer',
    /** Grants permission to read CustomerGroup */
    ReadCustomerGroup = 'ReadCustomerGroup',
    /** Grants permission to read Facet */
    ReadFacet = 'ReadFacet',
    /** Grants permission to read Order */
    ReadOrder = 'ReadOrder',
    /** Grants permission to read PaymentMethod */
    ReadPaymentMethod = 'ReadPaymentMethod',
    /** Grants permission to read Product */
    ReadProduct = 'ReadProduct',
    /** Grants permission to read Promotion */
    ReadPromotion = 'ReadPromotion',
    /** Grants permission to read Recipient */
    ReadRecipient = 'ReadRecipient',
    /** Grants permission to read Seller */
    ReadSeller = 'ReadSeller',
    /** Grants permission to read Sellers */
    ReadSellers = 'ReadSellers',
    /** Grants permission to read PaymentMethods, ShippingMethods, TaxCategories, TaxRates, Zones, Countries, System & GlobalSettings */
    ReadSettings = 'ReadSettings',
    /** Grants permission to read ShippingMethod */
    ReadShippingMethod = 'ReadShippingMethod',
    /** Grants permission to read ShoppingList */
    ReadShoppingList = 'ReadShoppingList',
    /** Grants permission to read SocialMedia */
    ReadSocialMedia = 'ReadSocialMedia',
    /** Grants permission to read StockLocation */
    ReadStockLocation = 'ReadStockLocation',
    /** Grants permission to read System */
    ReadSystem = 'ReadSystem',
    /** Grants permission to read Tag */
    ReadTag = 'ReadTag',
    /** Grants permission to read TaxCategory */
    ReadTaxCategory = 'ReadTaxCategory',
    /** Grants permission to read TaxRate */
    ReadTaxRate = 'ReadTaxRate',
    /** Grants permission to read Zone */
    ReadZone = 'ReadZone',
    /** Allows setting a webhook URL */
    SetWebhook = 'SetWebhook',
    /** SuperAdmin has unrestricted access to all operations */
    SuperAdmin = 'SuperAdmin',
    /** Allows syncing customers via Admin API */
    SyncCustomers = 'SyncCustomers',
    /** Allows syncing orders via Admin API */
    SyncOrders = 'SyncOrders',
    /** Allows syncing payment condition via Admin API */
    SyncPaymentCondition = 'SyncPaymentCondition',
    /** Allows syncing price via Admin API */
    SyncPrice = 'SyncPrice',
    /** Allows syncing stock levels via Admin API */
    SyncProducts = 'SyncProducts',
    /** Allows syncing promotion via Admin API */
    SyncPromotion = 'SyncPromotion',
    /** Allows syncing stock via Admin API */
    SyncStock = 'SyncStock',
    /** Grants permission to update Administrator */
    UpdateAdministrator = 'UpdateAdministrator',
    /** Grants permission to update Asset */
    UpdateAsset = 'UpdateAsset',
    /** Grants permission to update Banner */
    UpdateBanner = 'UpdateBanner',
    /** Grants permission to update BannerItem */
    UpdateBannerItem = 'UpdateBannerItem',
    /** Grants permission to update CardBrand */
    UpdateCardBrand = 'UpdateCardBrand',
    /** Grants permission to update CardFee */
    UpdateCardFee = 'UpdateCardFee',
    /** Grants permission to update Products, Facets, Assets, Collections */
    UpdateCatalog = 'UpdateCatalog',
    /** Grants permission to update Channel */
    UpdateChannel = 'UpdateChannel',
    /** Grants permission to update Collection */
    UpdateCollection = 'UpdateCollection',
    /** Grants permission to update Country */
    UpdateCountry = 'UpdateCountry',
    /** Grants permission to update Customer */
    UpdateCustomer = 'UpdateCustomer',
    /** Grants permission to update CustomerGroup */
    UpdateCustomerGroup = 'UpdateCustomerGroup',
    /** Grants permission to update Facet */
    UpdateFacet = 'UpdateFacet',
    /** Grants permission to update GlobalSettings */
    UpdateGlobalSettings = 'UpdateGlobalSettings',
    /** Grants permission to update Order */
    UpdateOrder = 'UpdateOrder',
    /** Grants permission to update PaymentMethod */
    UpdatePaymentMethod = 'UpdatePaymentMethod',
    /** Grants permission to update Product */
    UpdateProduct = 'UpdateProduct',
    /** Grants permission to update Promotion */
    UpdatePromotion = 'UpdatePromotion',
    /** Grants permission to update Recipient */
    UpdateRecipient = 'UpdateRecipient',
    /** Grants permission to update Seller */
    UpdateSeller = 'UpdateSeller',
    /** Grants permission to update Sellers */
    UpdateSellers = 'UpdateSellers',
    /** Grants permission to update PaymentMethods, ShippingMethods, TaxCategories, TaxRates, Zones, Countries, System & GlobalSettings */
    UpdateSettings = 'UpdateSettings',
    /** Grants permission to update ShippingMethod */
    UpdateShippingMethod = 'UpdateShippingMethod',
    /** Grants permission to update ShoppingList */
    UpdateShoppingList = 'UpdateShoppingList',
    /** Grants permission to update SocialMedia */
    UpdateSocialMedia = 'UpdateSocialMedia',
    /** Grants permission to update StockLocation */
    UpdateStockLocation = 'UpdateStockLocation',
    /** Grants permission to update System */
    UpdateSystem = 'UpdateSystem',
    /** Grants permission to update Tag */
    UpdateTag = 'UpdateTag',
    /** Grants permission to update TaxCategory */
    UpdateTaxCategory = 'UpdateTaxCategory',
    /** Grants permission to update TaxRate */
    UpdateTaxRate = 'UpdateTaxRate',
    /** Grants permission to update Zone */
    UpdateZone = 'UpdateZone',
    /** Allows check customer via Admin API */
    checkCustomerApproved = 'checkCustomerApproved',
}

export type PermissionDefinition = {
    __typename?: 'PermissionDefinition';
    assignable: Scalars['Boolean']['output'];
    description: Scalars['String']['output'];
    name: Scalars['String']['output'];
};

export type Phone = Node & {
    __typename?: 'Phone';
    createdAt: Scalars['DateTime']['output'];
    id: Scalars['ID']['output'];
    phone: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type PhoneAddInput = {
    phone: Scalars['String']['input'];
};

export type PhoneFilterParameter = {
    _and?: InputMaybe<Array<PhoneFilterParameter>>;
    _or?: InputMaybe<Array<PhoneFilterParameter>>;
    createdAt?: InputMaybe<DateOperators>;
    id?: InputMaybe<IdOperators>;
    phone?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type PhoneList = PaginatedList & {
    __typename?: 'PhoneList';
    items: Array<Phone>;
    totalItems: Scalars['Int']['output'];
};

export type PhoneListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<PhoneFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<PhoneSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type PhoneSortParameter = {
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    phone?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PhoneUpdateInput = {
    id: Scalars['ID']['input'];
    phone: Scalars['String']['input'];
};

export type PreviewCollectionVariantsInput = {
    filters: Array<ConfigurableOperationInput>;
    inheritFilters: Scalars['Boolean']['input'];
    parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type PriceInput = {
    price: Scalars['Int']['input'];
    priceTableId: Scalars['String']['input'];
};

/** The price range where the result has more than one price */
export type PriceRange = {
    __typename?: 'PriceRange';
    max: Scalars['Money']['output'];
    min: Scalars['Money']['output'];
};

export type PriceRangeBucket = {
    __typename?: 'PriceRangeBucket';
    count: Scalars['Int']['output'];
    to: Scalars['Int']['output'];
};

export type PriceRangeInput = {
    max: Scalars['Int']['input'];
    min: Scalars['Int']['input'];
};

export type PriceSyncError = {
    __typename?: 'PriceSyncError';
    errorCode: Scalars['String']['output'];
    message: Scalars['String']['output'];
};

export type Product = Node & {
    __typename?: 'Product';
    assets: Array<Asset>;
    breadcrumbs: Array<ProductBreadcrumb>;
    channels: Array<Channel>;
    collections: Array<Collection>;
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<ProductCustomFields>;
    description: Scalars['String']['output'];
    enabled: Scalars['Boolean']['output'];
    facetValues: Array<FacetValue>;
    featuredAsset?: Maybe<Asset>;
    id: Scalars['ID']['output'];
    languageCode: LanguageCode;
    name: Scalars['String']['output'];
    optionGroups: Array<ProductOptionGroup>;
    primaryCollection?: Maybe<Collection>;
    slug: Scalars['String']['output'];
    translations: Array<ProductTranslation>;
    updatedAt: Scalars['DateTime']['output'];
    /** Returns a paginated, sortable, filterable list of ProductVariants */
    variantList: ProductVariantList;
    /** Returns all ProductVariants */
    variants: Array<ProductVariant>;
};

export type ProductVariantListArgs = {
    options?: InputMaybe<ProductVariantListOptions>;
};

export type ProductBreadcrumb = {
    __typename?: 'ProductBreadcrumb';
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    slug: Scalars['String']['output'];
};

export type ProductCustomFields = {
    __typename?: 'ProductCustomFields';
    externalId?: Maybe<Scalars['String']['output']>;
    facebookImage?: Maybe<Asset>;
    primaryCollection?: Maybe<Scalars['String']['output']>;
    relatedProducts?: Maybe<Array<Product>>;
    seoDescription?: Maybe<Scalars['String']['output']>;
    seoTitle?: Maybe<Scalars['String']['output']>;
    twitterImage?: Maybe<Asset>;
};

export type ProductError = {
    __typename?: 'ProductError';
    message: Scalars['String']['output'];
    type: Scalars['String']['output'];
};

export type ProductFilterParameter = {
    _and?: InputMaybe<Array<ProductFilterParameter>>;
    _or?: InputMaybe<Array<ProductFilterParameter>>;
    createdAt?: InputMaybe<DateOperators>;
    description?: InputMaybe<StringOperators>;
    enabled?: InputMaybe<BooleanOperators>;
    externalId?: InputMaybe<StringOperators>;
    facetValueId?: InputMaybe<IdOperators>;
    id?: InputMaybe<IdOperators>;
    languageCode?: InputMaybe<StringOperators>;
    name?: InputMaybe<StringOperators>;
    primaryCollection?: InputMaybe<StringOperators>;
    seoDescription?: InputMaybe<StringOperators>;
    seoTitle?: InputMaybe<StringOperators>;
    sku?: InputMaybe<StringOperators>;
    slug?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type ProductList = PaginatedList & {
    __typename?: 'ProductList';
    items: Array<Product>;
    totalItems: Scalars['Int']['output'];
};

export type ProductListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<ProductFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<ProductSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductOption = Node & {
    __typename?: 'ProductOption';
    code: Scalars['String']['output'];
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<Scalars['JSON']['output']>;
    group: ProductOptionGroup;
    groupId: Scalars['ID']['output'];
    id: Scalars['ID']['output'];
    languageCode: LanguageCode;
    name: Scalars['String']['output'];
    translations: Array<ProductOptionTranslation>;
    updatedAt: Scalars['DateTime']['output'];
};

export type ProductOptionGroup = Node & {
    __typename?: 'ProductOptionGroup';
    code: Scalars['String']['output'];
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<Scalars['JSON']['output']>;
    id: Scalars['ID']['output'];
    languageCode: LanguageCode;
    name: Scalars['String']['output'];
    options: Array<ProductOption>;
    translations: Array<ProductOptionGroupTranslation>;
    updatedAt: Scalars['DateTime']['output'];
};

export type ProductOptionGroupTranslation = {
    __typename?: 'ProductOptionGroupTranslation';
    createdAt: Scalars['DateTime']['output'];
    id: Scalars['ID']['output'];
    languageCode: LanguageCode;
    name: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type ProductOptionGroupTranslationInput = {
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    languageCode: LanguageCode;
    name?: InputMaybe<Scalars['String']['input']>;
};

export type ProductOptionInUseError = ErrorResult & {
    __typename?: 'ProductOptionInUseError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
    optionGroupCode: Scalars['String']['output'];
    productVariantCount: Scalars['Int']['output'];
};

export type ProductOptionTranslation = {
    __typename?: 'ProductOptionTranslation';
    createdAt: Scalars['DateTime']['output'];
    id: Scalars['ID']['output'];
    languageCode: LanguageCode;
    name: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type ProductOptionTranslationInput = {
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    languageCode: LanguageCode;
    name?: InputMaybe<Scalars['String']['input']>;
};

export type ProductSortParameter = {
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    externalId?: InputMaybe<SortOrder>;
    facebookImage?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    primaryCollection?: InputMaybe<SortOrder>;
    seoDescription?: InputMaybe<SortOrder>;
    seoTitle?: InputMaybe<SortOrder>;
    slug?: InputMaybe<SortOrder>;
    twitterImage?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ProductStatusDetails = {
    __typename?: 'ProductStatusDetails';
    hasMeasurementUnit: Scalars['Boolean']['output'];
    hasPrice: Scalars['Boolean']['output'];
    hasStock: Scalars['Boolean']['output'];
    isActive: Scalars['Boolean']['output'];
};

export type ProductTranslation = {
    __typename?: 'ProductTranslation';
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<ProductTranslationCustomFields>;
    description: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    languageCode: LanguageCode;
    name: Scalars['String']['output'];
    slug: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type ProductTranslationCustomFields = {
    __typename?: 'ProductTranslationCustomFields';
    seoDescription?: Maybe<Scalars['String']['output']>;
    seoTitle?: Maybe<Scalars['String']['output']>;
};

export type ProductTranslationInput = {
    customFields?: InputMaybe<ProductTranslationInputCustomFields>;
    description?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    languageCode: LanguageCode;
    name?: InputMaybe<Scalars['String']['input']>;
    slug?: InputMaybe<Scalars['String']['input']>;
};

export type ProductTranslationInputCustomFields = {
    seoDescription?: InputMaybe<Scalars['String']['input']>;
    seoTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ProductVariant = Node & {
    __typename?: 'ProductVariant';
    assets: Array<Asset>;
    booster?: Maybe<Scalars['Boolean']['output']>;
    channels: Array<Channel>;
    createdAt: Scalars['DateTime']['output'];
    currencyCode: CurrencyCode;
    customFields?: Maybe<ProductVariantCustomFields>;
    divider?: Maybe<Scalars['Int']['output']>;
    enabled: Scalars['Boolean']['output'];
    facetValues: Array<FacetValue>;
    featuredAsset?: Maybe<Asset>;
    id: Scalars['ID']['output'];
    languageCode: LanguageCode;
    multiplier?: Maybe<Scalars['Int']['output']>;
    name: Scalars['String']['output'];
    options: Array<ProductOption>;
    outOfStockThreshold: Scalars['Int']['output'];
    price: Scalars['Money']['output'];
    priceWithTax: Scalars['Money']['output'];
    prices: Array<ProductVariantPrice>;
    product: Product;
    productId: Scalars['ID']['output'];
    sku: Scalars['String']['output'];
    /** @deprecated use stockLevels */
    stockAllocated: Scalars['Int']['output'];
    stockLevel: Scalars['String']['output'];
    stockLevels: Array<StockLevel>;
    stockMovements: StockMovementList;
    /** @deprecated use stockLevels */
    stockOnHand: Scalars['Int']['output'];
    taxCategory: TaxCategory;
    taxRateApplied: TaxRate;
    trackInventory: GlobalFlag;
    translations: Array<ProductVariantTranslation>;
    updatedAt: Scalars['DateTime']['output'];
    useGlobalOutOfStockThreshold: Scalars['Boolean']['output'];
};

export type ProductVariantStockMovementsArgs = {
    options?: InputMaybe<StockMovementListOptions>;
};

export type ProductVariantCustomFields = {
    __typename?: 'ProductVariantCustomFields';
    additionalDeliveryTime?: Maybe<Scalars['Int']['output']>;
    boxQuantity?: Maybe<Scalars['Int']['output']>;
    codeEan?: Maybe<Scalars['String']['output']>;
    distanceUnit?: Maybe<Scalars['String']['output']>;
    externalId?: Maybe<Scalars['String']['output']>;
    height?: Maybe<Scalars['Float']['output']>;
    isFifo?: Maybe<Scalars['Boolean']['output']>;
    length?: Maybe<Scalars['Float']['output']>;
    massUnit?: Maybe<Scalars['String']['output']>;
    measurementUnit?: Maybe<Scalars['String']['output']>;
    minimumQuantity?: Maybe<Scalars['Int']['output']>;
    multiple?: Maybe<Scalars['Int']['output']>;
    orderPaymentConditionType?: Maybe<Scalars['String']['output']>;
    weight?: Maybe<Scalars['Float']['output']>;
    width?: Maybe<Scalars['Float']['output']>;
};

export type ProductVariantFilterParameter = {
    _and?: InputMaybe<Array<ProductVariantFilterParameter>>;
    _or?: InputMaybe<Array<ProductVariantFilterParameter>>;
    additionalDeliveryTime?: InputMaybe<NumberOperators>;
    booster?: InputMaybe<BooleanOperators>;
    boxQuantity?: InputMaybe<NumberOperators>;
    codeEan?: InputMaybe<StringOperators>;
    createdAt?: InputMaybe<DateOperators>;
    currencyCode?: InputMaybe<StringOperators>;
    distanceUnit?: InputMaybe<StringOperators>;
    divider?: InputMaybe<NumberOperators>;
    enabled?: InputMaybe<BooleanOperators>;
    externalId?: InputMaybe<StringOperators>;
    facetValueId?: InputMaybe<IdOperators>;
    height?: InputMaybe<NumberOperators>;
    id?: InputMaybe<IdOperators>;
    isFifo?: InputMaybe<BooleanOperators>;
    languageCode?: InputMaybe<StringOperators>;
    length?: InputMaybe<NumberOperators>;
    massUnit?: InputMaybe<StringOperators>;
    measurementUnit?: InputMaybe<StringOperators>;
    minimumQuantity?: InputMaybe<NumberOperators>;
    multiple?: InputMaybe<NumberOperators>;
    multiplier?: InputMaybe<NumberOperators>;
    name?: InputMaybe<StringOperators>;
    orderPaymentConditionType?: InputMaybe<StringOperators>;
    outOfStockThreshold?: InputMaybe<NumberOperators>;
    price?: InputMaybe<NumberOperators>;
    priceWithTax?: InputMaybe<NumberOperators>;
    productId?: InputMaybe<IdOperators>;
    sku?: InputMaybe<StringOperators>;
    stockAllocated?: InputMaybe<NumberOperators>;
    stockLevel?: InputMaybe<StringOperators>;
    stockOnHand?: InputMaybe<NumberOperators>;
    trackInventory?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
    useGlobalOutOfStockThreshold?: InputMaybe<BooleanOperators>;
    weight?: InputMaybe<NumberOperators>;
    width?: InputMaybe<NumberOperators>;
};

export type ProductVariantList = PaginatedList & {
    __typename?: 'ProductVariantList';
    items: Array<ProductVariant>;
    totalItems: Scalars['Int']['output'];
};

export type ProductVariantListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<ProductVariantFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<ProductVariantSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductVariantPrice = {
    __typename?: 'ProductVariantPrice';
    currencyCode: CurrencyCode;
    customFields?: Maybe<Scalars['JSON']['output']>;
    price: Scalars['Money']['output'];
};

export type ProductVariantPriceTable = {
    __typename?: 'ProductVariantPriceTable';
    channelId: Scalars['ID']['output'];
    createdAt: Scalars['DateTime']['output'];
    currencyCode: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    price: Scalars['Int']['output'];
    priceTableId: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
    variantId: Scalars['ID']['output'];
};

export type ProductVariantShoppingList = Node & {
    __typename?: 'ProductVariantShoppingList';
    id: Scalars['ID']['output'];
    productVariant?: Maybe<ProductVariant>;
    quantity: Scalars['Int']['output'];
};

export type ProductVariantShoppingListFilterParameter = {
    productVariantName?: InputMaybe<StringOperators>;
};

export type ProductVariantShoppingListList = PaginatedList & {
    __typename?: 'ProductVariantShoppingListList';
    items: Array<ProductVariantShoppingList>;
    totalItems: Scalars['Int']['output'];
};

export type ProductVariantShoppingListListOptions = {
    filter?: InputMaybe<ProductVariantShoppingListFilterParameter>;
    sort?: InputMaybe<ProductVariantShoppingListSortParameter>;
};

export type ProductVariantShoppingListSortParameter = {
    productVariantName?: InputMaybe<SortOrder>;
};

export type ProductVariantSortParameter = {
    additionalDeliveryTime?: InputMaybe<SortOrder>;
    boxQuantity?: InputMaybe<SortOrder>;
    codeEan?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    distanceUnit?: InputMaybe<SortOrder>;
    divider?: InputMaybe<SortOrder>;
    externalId?: InputMaybe<SortOrder>;
    height?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isFifo?: InputMaybe<SortOrder>;
    length?: InputMaybe<SortOrder>;
    massUnit?: InputMaybe<SortOrder>;
    measurementUnit?: InputMaybe<SortOrder>;
    minimumQuantity?: InputMaybe<SortOrder>;
    multiple?: InputMaybe<SortOrder>;
    multiplier?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orderPaymentConditionType?: InputMaybe<SortOrder>;
    outOfStockThreshold?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    priceWithTax?: InputMaybe<SortOrder>;
    productId?: InputMaybe<SortOrder>;
    sku?: InputMaybe<SortOrder>;
    stockAllocated?: InputMaybe<SortOrder>;
    stockLevel?: InputMaybe<SortOrder>;
    stockOnHand?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    weight?: InputMaybe<SortOrder>;
    width?: InputMaybe<SortOrder>;
};

export type ProductVariantTranslation = {
    __typename?: 'ProductVariantTranslation';
    createdAt: Scalars['DateTime']['output'];
    id: Scalars['ID']['output'];
    languageCode: LanguageCode;
    name: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type ProductVariantTranslationInput = {
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    languageCode: LanguageCode;
    name?: InputMaybe<Scalars['String']['input']>;
};

export type Promotion = Node & {
    __typename?: 'Promotion';
    actions: Array<ConfigurableOperation>;
    conditions: Array<ConfigurableOperation>;
    couponCode?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<PromotionCustomFields>;
    description: Scalars['String']['output'];
    enabled: Scalars['Boolean']['output'];
    endsAt?: Maybe<Scalars['DateTime']['output']>;
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    perCustomerUsageLimit?: Maybe<Scalars['Int']['output']>;
    startsAt?: Maybe<Scalars['DateTime']['output']>;
    translations: Array<PromotionTranslation>;
    updatedAt: Scalars['DateTime']['output'];
    usageLimit?: Maybe<Scalars['Int']['output']>;
};

export type PromotionCustomFields = {
    __typename?: 'PromotionCustomFields';
    asset?: Maybe<Asset>;
    externalId?: Maybe<Scalars['String']['output']>;
    mobile?: Maybe<Asset>;
    progressiveDiscountType?: Maybe<Scalars['String']['output']>;
};

export type PromotionFilterParameter = {
    _and?: InputMaybe<Array<PromotionFilterParameter>>;
    _or?: InputMaybe<Array<PromotionFilterParameter>>;
    couponCode?: InputMaybe<StringOperators>;
    createdAt?: InputMaybe<DateOperators>;
    description?: InputMaybe<StringOperators>;
    enabled?: InputMaybe<BooleanOperators>;
    endsAt?: InputMaybe<DateOperators>;
    externalId?: InputMaybe<StringOperators>;
    id?: InputMaybe<IdOperators>;
    name?: InputMaybe<StringOperators>;
    perCustomerUsageLimit?: InputMaybe<NumberOperators>;
    progressiveDiscountType?: InputMaybe<StringOperators>;
    startsAt?: InputMaybe<DateOperators>;
    updatedAt?: InputMaybe<DateOperators>;
    usageLimit?: InputMaybe<NumberOperators>;
};

export type PromotionList = PaginatedList & {
    __typename?: 'PromotionList';
    items: Array<Promotion>;
    totalItems: Scalars['Int']['output'];
};

export type PromotionListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<PromotionFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<PromotionSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type PromotionSortParameter = {
    asset?: InputMaybe<SortOrder>;
    couponCode?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    endsAt?: InputMaybe<SortOrder>;
    externalId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    mobile?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    perCustomerUsageLimit?: InputMaybe<SortOrder>;
    progressiveDiscountType?: InputMaybe<SortOrder>;
    startsAt?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    usageLimit?: InputMaybe<SortOrder>;
};

export type PromotionTranslation = {
    __typename?: 'PromotionTranslation';
    createdAt: Scalars['DateTime']['output'];
    description: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    languageCode: LanguageCode;
    name: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type PromotionTranslationInput = {
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    languageCode: LanguageCode;
    name?: InputMaybe<Scalars['String']['input']>;
};

export type Province = Node &
    Region & {
        __typename?: 'Province';
        code: Scalars['String']['output'];
        createdAt: Scalars['DateTime']['output'];
        customFields?: Maybe<Scalars['JSON']['output']>;
        enabled: Scalars['Boolean']['output'];
        id: Scalars['ID']['output'];
        languageCode: LanguageCode;
        name: Scalars['String']['output'];
        parent?: Maybe<Region>;
        parentId?: Maybe<Scalars['ID']['output']>;
        translations: Array<RegionTranslation>;
        type: Scalars['String']['output'];
        updatedAt: Scalars['DateTime']['output'];
    };

export type ProvinceFilterParameter = {
    _and?: InputMaybe<Array<ProvinceFilterParameter>>;
    _or?: InputMaybe<Array<ProvinceFilterParameter>>;
    code?: InputMaybe<StringOperators>;
    createdAt?: InputMaybe<DateOperators>;
    enabled?: InputMaybe<BooleanOperators>;
    id?: InputMaybe<IdOperators>;
    languageCode?: InputMaybe<StringOperators>;
    name?: InputMaybe<StringOperators>;
    parentId?: InputMaybe<IdOperators>;
    type?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type ProvinceList = PaginatedList & {
    __typename?: 'ProvinceList';
    items: Array<Province>;
    totalItems: Scalars['Int']['output'];
};

export type ProvinceListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<ProvinceFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<ProvinceSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type ProvinceSortParameter = {
    code?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    parentId?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ProvinceTranslationInput = {
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    languageCode: LanguageCode;
    name?: InputMaybe<Scalars['String']['input']>;
};

/** Returned if the specified quantity of an OrderLine is greater than the number of items in that line */
export type QuantityTooGreatError = ErrorResult & {
    __typename?: 'QuantityTooGreatError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

export type Query = {
    __typename?: 'Query';
    SubscriptionEmail?: Maybe<Email>;
    SubscriptionEmails: EmailList;
    SubscriptionPhone?: Maybe<Phone>;
    SubscriptionPhones: PhoneList;
    activeAdministrator?: Maybe<Administrator>;
    activeChannel: Channel;
    administrator?: Maybe<Administrator>;
    administrators: AdministratorList;
    advancedMetricSummaries: Array<AdvancedMetricSummary>;
    /** Get a single Asset by id */
    asset?: Maybe<Asset>;
    /** Get a list of Assets */
    assets: AssetList;
    /** Get all available Vendure events that can be used to trigger webhooks */
    availableWebhookEvents: Array<Scalars['String']['output']>;
    /**
     * "
     * Get all available webhook request transformers
     */
    availableWebhookRequestTransformers: Array<WebhookRequestTransformer>;
    banner?: Maybe<Banner>;
    bannerItem?: Maybe<BannerItem>;
    bannerItems: BannerItemList;
    bannerItemsFromBanner: BannerItemList;
    banners: BannerList;
    /** Find all branches */
    branches: BranchList;
    cardBrand?: Maybe<CardBrand>;
    cardBrands: CardBrandList;
    cardFee?: Maybe<CardFee>;
    cardFees: CardFeeList;
    cardFeesByBrand: CardFeeList;
    channel?: Maybe<Channel>;
    channels: ChannelList;
    checkCustomerProductVisibility: Array<CustomerProductVisibilityResult>;
    /** Get a Collection either by id or slug. If neither id nor slug is specified, an error will result. */
    collection?: Maybe<Collection>;
    collectionFilters: Array<ConfigurableOperationDefinition>;
    collections: CollectionList;
    countries: CountryList;
    country?: Maybe<Country>;
    customer?: Maybe<Customer>;
    customerGroup?: Maybe<CustomerGroup>;
    customerGroups: CustomerGroupList;
    customers: CustomerList;
    /** Returns a list of eligible shipping methods for the draft Order */
    eligibleShippingMethodsForDraftOrder: Array<ShippingMethodQuote>;
    /** Returns all configured EntityDuplicators. */
    entityDuplicators: Array<EntityDuplicatorDefinition>;
    exportProductsWithErrors?: Maybe<Scalars['String']['output']>;
    facet?: Maybe<Facet>;
    facetValues: FacetValueList;
    facets: FacetList;
    findOneWorkBrand?: Maybe<WorkBrand>;
    fulfillmentHandlers: Array<ConfigurableOperationDefinition>;
    getAllRefundRequest: Array<RefundRequest>;
    getChannelSocialMedia?: Maybe<ChannelSocialMediaList>;
    getCustomerByDocument?: Maybe<Customer>;
    getPartnerById: Partner;
    getPartnerChannels: ChannelList;
    getPricesForVariant: Array<ProductVariantPriceTable>;
    /** Fetch products added in a ShoppingList by id */
    getProductsInShoppingList: ShoppingListToProductList;
    getRefundRequest: RefundRequest;
    getSearchResultProductStat: SearchResultProductStatList;
    getSearchTermStats: SearchTermStatList;
    getSellerCustomerPortfolioById?: Maybe<SellerCustomerPortfolio>;
    /** Fetch a single ShoppingList by id */
    getShoppingList?: Maybe<ShoppingList>;
    /** Fetch a list of ShoppingList */
    getShoppingLists: ShoppingListList;
    globalSettings: GlobalSettings;
    job?: Maybe<Job>;
    jobBufferSize: Array<JobBufferSize>;
    jobQueues: Array<JobQueue>;
    jobs: JobList;
    jobsById: Array<Job>;
    me?: Maybe<CurrentUser>;
    /** Get metrics for the given interval and metric types. */
    metricSummary: Array<MetricSummary>;
    normalizeProductStatus?: Maybe<NormalizeProductStatus>;
    order?: Maybe<Order>;
    orders: OrderList;
    package: Package;
    packages: PackageList;
    partners: PartnerList;
    paymentMethod?: Maybe<PaymentMethod>;
    paymentMethodEligibilityCheckers: Array<ConfigurableOperationDefinition>;
    paymentMethodHandlers: Array<ConfigurableOperationDefinition>;
    paymentMethods: PaymentMethodList;
    pendingSearchIndexUpdates: Scalars['Int']['output'];
    /** Used for real-time previews of the contents of a Collection */
    previewCollectionVariants: ProductVariantList;
    /** Get a Product either by id or slug. If neither id nor slug is specified, an error will result. */
    product?: Maybe<Product>;
    productOptionGroup?: Maybe<ProductOptionGroup>;
    productOptionGroups: Array<ProductOptionGroup>;
    /** Get a ProductVariant by id */
    productVariant?: Maybe<ProductVariant>;
    /** List ProductVariants either all or for the specific product. */
    productVariants: ProductVariantList;
    productVariantsWithLowStock: Array<ProductVariant>;
    /** List Products */
    products: ProductList;
    promotion?: Maybe<Promotion>;
    promotionActions: Array<ConfigurableOperationDefinition>;
    promotionConditions: Array<ConfigurableOperationDefinition>;
    promotions: PromotionList;
    province?: Maybe<Province>;
    provinces: ProvinceList;
    role?: Maybe<Role>;
    roles: RoleList;
    search: SearchResponse;
    /** Consult the postal code information. */
    searchByCep: SearchByCepResponse;
    seller?: Maybe<Seller>;
    sellerCustomerPortfolios: Array<SellerCustomerPortfolio>;
    sellers: SellerList;
    shippingCalculators: Array<ConfigurableOperationDefinition>;
    shippingEligibilityCheckers: Array<ConfigurableOperationDefinition>;
    shippingMethod?: Maybe<ShippingMethod>;
    shippingMethods: ShippingMethodList;
    stockLocation?: Maybe<StockLocation>;
    stockLocations: StockLocationList;
    surveyQuestion: SurveyQuestion;
    surveyQuestions: SurveyQuestionList;
    surveyResponses: SurveyResponseList;
    synonymGroup?: Maybe<SynonymGroup>;
    synonymGroups: SynonymGroupList;
    tag: Tag;
    tags: TagList;
    taxCategories: TaxCategoryList;
    taxCategory?: Maybe<TaxCategory>;
    taxRate?: Maybe<TaxRate>;
    taxRates: TaxRateList;
    testEligibleShippingMethods: Array<ShippingMethodQuote>;
    testShippingMethod: TestShippingMethodResult;
    /** Get all webhooks for the current channel */
    webhooks: Array<Webhook>;
    workBrands?: Maybe<WorkBrandList>;
    zone?: Maybe<Zone>;
    zones: ZoneList;
};

export type QuerySubscriptionEmailArgs = {
    id: Scalars['ID']['input'];
};

export type QuerySubscriptionEmailsArgs = {
    options?: InputMaybe<EmailListOptions>;
};

export type QuerySubscriptionPhoneArgs = {
    id: Scalars['ID']['input'];
};

export type QuerySubscriptionPhonesArgs = {
    options?: InputMaybe<PhoneListOptions>;
};

export type QueryAdministratorArgs = {
    id: Scalars['ID']['input'];
};

export type QueryAdministratorsArgs = {
    options?: InputMaybe<AdministratorListOptions>;
};

export type QueryAdvancedMetricSummariesArgs = {
    input?: InputMaybe<AdvancedMetricSummaryInput>;
};

export type QueryAssetArgs = {
    id: Scalars['ID']['input'];
};

export type QueryAssetsArgs = {
    options?: InputMaybe<AssetListOptions>;
};

export type QueryBannerArgs = {
    id: Scalars['ID']['input'];
};

export type QueryBannerItemArgs = {
    id: Scalars['ID']['input'];
};

export type QueryBannerItemsArgs = {
    id?: InputMaybe<Scalars['ID']['input']>;
    options?: InputMaybe<BannerItemListOptions>;
};

export type QueryBannerItemsFromBannerArgs = {
    banner: Scalars['ID']['input'];
    options?: InputMaybe<BannerItemListOptions>;
};

export type QueryBannersArgs = {
    options?: InputMaybe<BannerListOptions>;
};

export type QueryBranchesArgs = {
    options?: InputMaybe<BranchListOptions>;
};

export type QueryCardBrandArgs = {
    id: Scalars['ID']['input'];
};

export type QueryCardBrandsArgs = {
    options?: InputMaybe<CardBrandListOptions>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCardFeeArgs = {
    id: Scalars['ID']['input'];
};

export type QueryCardFeesArgs = {
    options?: InputMaybe<CardFeeListOptions>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCardFeesByBrandArgs = {
    brandId: Scalars['ID']['input'];
    options?: InputMaybe<CardFeeListOptions>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryChannelArgs = {
    id: Scalars['ID']['input'];
};

export type QueryChannelsArgs = {
    options?: InputMaybe<ChannelListOptions>;
};

export type QueryCheckCustomerProductVisibilityArgs = {
    channelIds: Array<Scalars['ID']['input']>;
    customerIds: Array<Scalars['ID']['input']>;
    productVariantIds: Array<Scalars['ID']['input']>;
};

export type QueryCollectionArgs = {
    id?: InputMaybe<Scalars['ID']['input']>;
    slug?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCollectionsArgs = {
    options?: InputMaybe<CollectionListOptions>;
};

export type QueryCountriesArgs = {
    options?: InputMaybe<CountryListOptions>;
};

export type QueryCountryArgs = {
    id: Scalars['ID']['input'];
};

export type QueryCustomerArgs = {
    id: Scalars['ID']['input'];
};

export type QueryCustomerGroupArgs = {
    id: Scalars['ID']['input'];
};

export type QueryCustomerGroupsArgs = {
    options?: InputMaybe<CustomerGroupListOptions>;
};

export type QueryCustomersArgs = {
    options?: InputMaybe<CustomerListOptions>;
};

export type QueryEligibleShippingMethodsForDraftOrderArgs = {
    orderId: Scalars['ID']['input'];
};

export type QueryFacetArgs = {
    id: Scalars['ID']['input'];
};

export type QueryFacetValuesArgs = {
    options?: InputMaybe<FacetValueListOptions>;
};

export type QueryFacetsArgs = {
    options?: InputMaybe<FacetListOptions>;
};

export type QueryFindOneWorkBrandArgs = {
    id: Scalars['ID']['input'];
};

export type QueryGetAllRefundRequestArgs = {
    customerId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetChannelSocialMediaArgs = {
    filter?: InputMaybe<SocialMediaFilterInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetCustomerByDocumentArgs = {
    document: Scalars['String']['input'];
};

export type QueryGetPartnerByIdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryGetPartnerChannelsArgs = {
    options?: InputMaybe<ChannelListOptions>;
    partnerId: Scalars['ID']['input'];
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetPricesForVariantArgs = {
    channelCode: Scalars['String']['input'];
    externalVariantId: Scalars['String']['input'];
};

export type QueryGetProductsInShoppingListArgs = {
    options?: InputMaybe<ShoppingListToProductListOptions>;
    shoppingListId: Scalars['ID']['input'];
};

export type QueryGetRefundRequestArgs = {
    id: Scalars['ID']['input'];
};

export type QueryGetSearchResultProductStatArgs = {
    options?: InputMaybe<SearchResultProductStatListOptions>;
};

export type QueryGetSearchTermStatsArgs = {
    options?: InputMaybe<SearchTermStatListOptions>;
};

export type QueryGetSellerCustomerPortfolioByIdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryGetShoppingListArgs = {
    id: Scalars['ID']['input'];
};

export type QueryGetShoppingListsArgs = {
    options?: InputMaybe<ShoppingListListOptions>;
};

export type QueryJobArgs = {
    jobId: Scalars['ID']['input'];
};

export type QueryJobBufferSizeArgs = {
    bufferIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryJobsArgs = {
    options?: InputMaybe<JobListOptions>;
};

export type QueryJobsByIdArgs = {
    jobIds: Array<Scalars['ID']['input']>;
};

export type QueryMetricSummaryArgs = {
    input?: InputMaybe<MetricSummaryInput>;
};

export type QueryNormalizeProductStatusArgs = {
    productId: Scalars['ID']['input'];
};

export type QueryOrderArgs = {
    id: Scalars['ID']['input'];
};

export type QueryOrdersArgs = {
    options?: InputMaybe<OrderListOptions>;
};

export type QueryPackageArgs = {
    id: Scalars['ID']['input'];
};

export type QueryPackagesArgs = {
    options?: InputMaybe<PackageListOptions>;
};

export type QueryPartnersArgs = {
    name?: InputMaybe<Scalars['String']['input']>;
    options?: InputMaybe<PartnerListOptions>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPaymentMethodArgs = {
    id: Scalars['ID']['input'];
};

export type QueryPaymentMethodsArgs = {
    options?: InputMaybe<PaymentMethodListOptions>;
};

export type QueryPreviewCollectionVariantsArgs = {
    input: PreviewCollectionVariantsInput;
    options?: InputMaybe<ProductVariantListOptions>;
};

export type QueryProductArgs = {
    id?: InputMaybe<Scalars['ID']['input']>;
    slug?: InputMaybe<Scalars['String']['input']>;
};

export type QueryProductOptionGroupArgs = {
    id: Scalars['ID']['input'];
};

export type QueryProductOptionGroupsArgs = {
    filterTerm?: InputMaybe<Scalars['String']['input']>;
};

export type QueryProductVariantArgs = {
    id: Scalars['ID']['input'];
};

export type QueryProductVariantsArgs = {
    options?: InputMaybe<ProductVariantListOptions>;
    productId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryProductsArgs = {
    options?: InputMaybe<ProductListOptions>;
};

export type QueryPromotionArgs = {
    id: Scalars['ID']['input'];
};

export type QueryPromotionsArgs = {
    options?: InputMaybe<PromotionListOptions>;
};

export type QueryProvinceArgs = {
    id: Scalars['ID']['input'];
};

export type QueryProvincesArgs = {
    options?: InputMaybe<ProvinceListOptions>;
};

export type QueryRoleArgs = {
    id: Scalars['ID']['input'];
};

export type QueryRolesArgs = {
    options?: InputMaybe<RoleListOptions>;
};

export type QuerySearchArgs = {
    input: SearchInput;
};

export type QuerySearchByCepArgs = {
    input: SearchByCepInput;
};

export type QuerySellerArgs = {
    id: Scalars['ID']['input'];
};

export type QuerySellerCustomerPortfoliosArgs = {
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerySellersArgs = {
    options?: InputMaybe<SellerListOptions>;
};

export type QueryShippingMethodArgs = {
    id: Scalars['ID']['input'];
};

export type QueryShippingMethodsArgs = {
    options?: InputMaybe<ShippingMethodListOptions>;
};

export type QueryStockLocationArgs = {
    id: Scalars['ID']['input'];
};

export type QueryStockLocationsArgs = {
    options?: InputMaybe<StockLocationListOptions>;
};

export type QuerySurveyQuestionArgs = {
    id: Scalars['ID']['input'];
};

export type QuerySynonymGroupArgs = {
    id: Scalars['ID']['input'];
};

export type QuerySynonymGroupsArgs = {
    options?: InputMaybe<SynonymGroupListOptions>;
};

export type QueryTagArgs = {
    id: Scalars['ID']['input'];
};

export type QueryTagsArgs = {
    options?: InputMaybe<TagListOptions>;
};

export type QueryTaxCategoriesArgs = {
    options?: InputMaybe<TaxCategoryListOptions>;
};

export type QueryTaxCategoryArgs = {
    id: Scalars['ID']['input'];
};

export type QueryTaxRateArgs = {
    id: Scalars['ID']['input'];
};

export type QueryTaxRatesArgs = {
    options?: InputMaybe<TaxRateListOptions>;
};

export type QueryTestEligibleShippingMethodsArgs = {
    input: TestEligibleShippingMethodsInput;
};

export type QueryTestShippingMethodArgs = {
    input: TestShippingMethodInput;
};

export type QueryWorkBrandsArgs = {
    input?: InputMaybe<WorkBrandListOptions>;
};

export type QueryZoneArgs = {
    id: Scalars['ID']['input'];
};

export type QueryZonesArgs = {
    options?: InputMaybe<ZoneListOptions>;
};

export type Recipient = {
    __typename?: 'Recipient';
    automatic_anticipation_settings?: Maybe<AutomaticAnticipationSettings>;
    code?: Maybe<Scalars['String']['output']>;
    created_at?: Maybe<Scalars['String']['output']>;
    default_bank_account?: Maybe<BankAccount>;
    description?: Maybe<Scalars['String']['output']>;
    document?: Maybe<Scalars['String']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    gateway_recipients?: Maybe<Array<Maybe<GatewayRecipient>>>;
    id?: Maybe<Scalars['String']['output']>;
    metadata?: Maybe<Scalars['JSON']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    transfer_settings?: Maybe<TransferSettings>;
    type?: Maybe<Scalars['String']['output']>;
    updated_at?: Maybe<Scalars['String']['output']>;
};

export type Refund = Node & {
    __typename?: 'Refund';
    adjustment: Scalars['Money']['output'];
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<Scalars['JSON']['output']>;
    id: Scalars['ID']['output'];
    items: Scalars['Money']['output'];
    lines: Array<RefundLine>;
    metadata?: Maybe<Scalars['JSON']['output']>;
    method?: Maybe<Scalars['String']['output']>;
    paymentId: Scalars['ID']['output'];
    reason?: Maybe<Scalars['String']['output']>;
    shipping: Scalars['Money']['output'];
    state: Scalars['String']['output'];
    total: Scalars['Money']['output'];
    transactionId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTime']['output'];
};

/** Returned if `amount` is greater than the maximum un-refunded amount of the Payment */
export type RefundAmountError = ErrorResult & {
    __typename?: 'RefundAmountError';
    errorCode: ErrorCode;
    maximumRefundable: Scalars['Int']['output'];
    message: Scalars['String']['output'];
};

export type RefundLine = {
    __typename?: 'RefundLine';
    orderLine: OrderLine;
    orderLineId: Scalars['ID']['output'];
    quantity: Scalars['Int']['output'];
    refund: Refund;
    refundId: Scalars['ID']['output'];
};

export type RefundOrderInput = {
    /**
     * The amount to be refunded to this particular payment. This was introduced in v2.2.0 as the preferred way to specify the refund amount.
     * Can be as much as the total amount of the payment minus the sum of all previous refunds.
     */
    amount?: InputMaybe<Scalars['Money']['input']>;
    paymentId: Scalars['ID']['input'];
    reason?: InputMaybe<Scalars['String']['input']>;
};

export type RefundOrderResult =
    | AlreadyRefundedError
    | MultipleOrderError
    | NothingToRefundError
    | OrderStateTransitionError
    | PaymentOrderMismatchError
    | QuantityTooGreatError
    | Refund
    | RefundAmountError
    | RefundOrderStateError
    | RefundStateTransitionError;

/** Returned if an attempting to refund an Order which is not in the expected state */
export type RefundOrderStateError = ErrorResult & {
    __typename?: 'RefundOrderStateError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
    orderState: Scalars['String']['output'];
};

/**
 * Returned when a call to modifyOrder fails to include a refundPaymentId even
 * though the price has decreased as a result of the changes.
 */
export type RefundPaymentIdMissingError = ErrorResult & {
    __typename?: 'RefundPaymentIdMissingError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

export type RefundRequest = {
    __typename?: 'RefundRequest';
    assets?: Maybe<Array<Maybe<Asset>>>;
    channel?: Maybe<Channel>;
    channelId?: Maybe<Scalars['ID']['output']>;
    createdAt?: Maybe<Scalars['String']['output']>;
    customer?: Maybe<Customer>;
    customerId?: Maybe<Scalars['ID']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    order?: Maybe<Order>;
    orderId?: Maybe<Scalars['ID']['output']>;
    payment?: Maybe<Payment>;
    paymentId?: Maybe<Scalars['ID']['output']>;
    reason?: Maybe<Scalars['String']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['String']['output']>;
};

/** Returned when there is an error in transitioning the Refund state */
export type RefundStateTransitionError = ErrorResult & {
    __typename?: 'RefundStateTransitionError';
    errorCode: ErrorCode;
    fromState: Scalars['String']['output'];
    message: Scalars['String']['output'];
    toState: Scalars['String']['output'];
    transitionError: Scalars['String']['output'];
};

export type Region = {
    code: Scalars['String']['output'];
    createdAt: Scalars['DateTime']['output'];
    enabled: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    languageCode: LanguageCode;
    name: Scalars['String']['output'];
    parent?: Maybe<Region>;
    parentId?: Maybe<Scalars['ID']['output']>;
    translations: Array<RegionTranslation>;
    type: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type RegionTranslation = {
    __typename?: 'RegionTranslation';
    createdAt: Scalars['DateTime']['output'];
    id: Scalars['ID']['output'];
    languageCode: LanguageCode;
    name: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type RegisterSellerTokenInput = {
    customer_id: Scalars['String']['input'];
};

export type RelationCustomFieldConfig = CustomField & {
    __typename?: 'RelationCustomFieldConfig';
    description?: Maybe<Array<LocalizedString>>;
    entity: Scalars['String']['output'];
    internal?: Maybe<Scalars['Boolean']['output']>;
    label?: Maybe<Array<LocalizedString>>;
    list: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    nullable?: Maybe<Scalars['Boolean']['output']>;
    readonly?: Maybe<Scalars['Boolean']['output']>;
    requiresPermission?: Maybe<Array<Permission>>;
    scalarFields: Array<Scalars['String']['output']>;
    type: Scalars['String']['output'];
    ui?: Maybe<Scalars['JSON']['output']>;
};

export type Release = Node &
    StockMovement & {
        __typename?: 'Release';
        createdAt: Scalars['DateTime']['output'];
        customFields?: Maybe<Scalars['JSON']['output']>;
        id: Scalars['ID']['output'];
        productVariant: ProductVariant;
        quantity: Scalars['Int']['output'];
        type: StockMovementType;
        updatedAt: Scalars['DateTime']['output'];
    };

export type RemoveBranchFromChannelsResult = BranchDoesExistError | Success;

export type RemoveChannelFromBannerInput = {
    bannerIds: Array<Scalars['ID']['input']>;
    channelIds: Array<Scalars['ID']['input']>;
};

export type RemoveChannelFromWorkBrandsInput = {
    channelIds: Array<Scalars['ID']['input']>;
    workBrandsIds: Array<Scalars['ID']['input']>;
};

export type RemoveCollectionsFromChannelInput = {
    channelId: Scalars['ID']['input'];
    collectionIds: Array<Scalars['ID']['input']>;
};

export type RemoveCustomerFromBranchInput = {
    channelIds: Array<Scalars['ID']['input']>;
    customerId: Scalars['ID']['input'];
};

export type RemoveCustomerFromBranchResult = BranchDoesExistError | Success;

export type RemoveFacetFromChannelResult = Facet | FacetInUseError;

export type RemoveFacetsFromChannelInput = {
    channelId: Scalars['ID']['input'];
    facetIds: Array<Scalars['ID']['input']>;
    force?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RemoveOptionGroupFromProductResult =
    | Product
    | ProductOptionInUseError;

export type RemoveOrderItemsResult =
    | Order
    | OrderInterceptorError
    | OrderModificationError;

export type RemovePaymentMethodsFromChannelInput = {
    channelId: Scalars['ID']['input'];
    paymentMethodIds: Array<Scalars['ID']['input']>;
};

export type RemoveProductVariantsFromChannelInput = {
    channelId: Scalars['ID']['input'];
    productVariantIds: Array<Scalars['ID']['input']>;
};

export type RemoveProductsFromChannelInput = {
    channelId: Scalars['ID']['input'];
    productIds: Array<Scalars['ID']['input']>;
};

export type RemovePromotionsFromChannelInput = {
    channelId: Scalars['ID']['input'];
    promotionIds: Array<Scalars['ID']['input']>;
};

export type RemoveShippingMethodsFromChannelInput = {
    channelId: Scalars['ID']['input'];
    shippingMethodIds: Array<Scalars['ID']['input']>;
};

export type RemoveShoppingListsError = ErrorResult & {
    __typename?: 'RemoveShoppingListsError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

export type RemoveShoppingListsInput = {
    ids: Array<Scalars['ID']['input']>;
};

export type RemoveShoppingListsResult =
    | RemoveShoppingListsError
    | RemoveShoppingListsSuccess;

export type RemoveShoppingListsSuccess = {
    __typename?: 'RemoveShoppingListsSuccess';
    success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveStockLocationsFromChannelInput = {
    channelId: Scalars['ID']['input'];
    stockLocationIds: Array<Scalars['ID']['input']>;
};

export type Return = Node &
    StockMovement & {
        __typename?: 'Return';
        createdAt: Scalars['DateTime']['output'];
        customFields?: Maybe<Scalars['JSON']['output']>;
        id: Scalars['ID']['output'];
        productVariant: ProductVariant;
        quantity: Scalars['Int']['output'];
        type: StockMovementType;
        updatedAt: Scalars['DateTime']['output'];
    };

export type Role = Node & {
    __typename?: 'Role';
    channels: Array<Channel>;
    code: Scalars['String']['output'];
    createdAt: Scalars['DateTime']['output'];
    description: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    permissions: Array<Permission>;
    updatedAt: Scalars['DateTime']['output'];
};

export type RoleFilterParameter = {
    _and?: InputMaybe<Array<RoleFilterParameter>>;
    _or?: InputMaybe<Array<RoleFilterParameter>>;
    code?: InputMaybe<StringOperators>;
    createdAt?: InputMaybe<DateOperators>;
    description?: InputMaybe<StringOperators>;
    id?: InputMaybe<IdOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type RoleList = PaginatedList & {
    __typename?: 'RoleList';
    items: Array<Role>;
    totalItems: Scalars['Int']['output'];
};

export type RoleListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<RoleFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<RoleSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type RoleSortParameter = {
    code?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type Sale = Node &
    StockMovement & {
        __typename?: 'Sale';
        createdAt: Scalars['DateTime']['output'];
        customFields?: Maybe<Scalars['JSON']['output']>;
        id: Scalars['ID']['output'];
        productVariant: ProductVariant;
        quantity: Scalars['Int']['output'];
        type: StockMovementType;
        updatedAt: Scalars['DateTime']['output'];
    };

export type SearchByCepInput = {
    cep: Scalars['String']['input'];
};

export type SearchByCepResponse = {
    __typename?: 'SearchByCepResponse';
    Locality?: Maybe<Scalars['String']['output']>;
    Neighborhood?: Maybe<Scalars['String']['output']>;
    State?: Maybe<Scalars['String']['output']>;
    Street?: Maybe<Scalars['String']['output']>;
    ZipCode?: Maybe<Scalars['String']['output']>;
};

export type SearchChannel = {
    __typename?: 'SearchChannel';
    channelColor?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    channelId?: Maybe<Scalars['String']['output']>;
    channelLogo?: Maybe<ChannelLogo>;
    channelName?: Maybe<Scalars['String']['output']>;
};

export type SearchInput = {
    GTINs?: InputMaybe<Array<Scalars['String']['input']>>;
    SKUs?: InputMaybe<Array<Scalars['String']['input']>>;
    collectionId?: InputMaybe<Scalars['ID']['input']>;
    collectionSlug?: InputMaybe<Scalars['String']['input']>;
    collectionSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
    facetValueFilters?: InputMaybe<Array<FacetValueFilterInput>>;
    groupByProduct?: InputMaybe<Scalars['Boolean']['input']>;
    inStock?: InputMaybe<Scalars['Boolean']['input']>;
    priceRange?: InputMaybe<PriceRangeInput>;
    priceRangeWithTax?: InputMaybe<PriceRangeInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    sort?: InputMaybe<SearchResultSortParameter>;
    take?: InputMaybe<Scalars['Int']['input']>;
    term?: InputMaybe<Scalars['String']['input']>;
};

export type SearchReindexResponse = {
    __typename?: 'SearchReindexResponse';
    success: Scalars['Boolean']['output'];
};

export type SearchResponse = {
    __typename?: 'SearchResponse';
    collections: Array<CollectionResult>;
    facetValues: Array<FacetValueResult>;
    items: Array<SearchResult>;
    prices: SearchResponsePriceData;
    totalItems: Scalars['Int']['output'];
};

export type SearchResponsePriceData = {
    __typename?: 'SearchResponsePriceData';
    buckets: Array<PriceRangeBucket>;
    bucketsWithTax: Array<PriceRangeBucket>;
    range: PriceRange;
    rangeWithTax: PriceRange;
};

export type SearchResult = {
    __typename?: 'SearchResult';
    boxQuantity?: Maybe<Scalars['Int']['output']>;
    channel?: Maybe<SearchChannel>;
    /** An array of ids of the Channels in which this result appears */
    channelIds: Array<Scalars['ID']['output']>;
    /** An array of ids of the Collections in which this result appears */
    collectionIds: Array<Scalars['ID']['output']>;
    currencyCode: CurrencyCode;
    description: Scalars['String']['output'];
    enabled: Scalars['Boolean']['output'];
    facetIds: Array<Scalars['ID']['output']>;
    facetValueIds: Array<Scalars['ID']['output']>;
    gtin?: Maybe<Scalars['String']['output']>;
    inStock?: Maybe<Scalars['Boolean']['output']>;
    measurementUnit?: Maybe<MeasurementUnit>;
    minimumQuantity?: Maybe<Scalars['String']['output']>;
    multiple?: Maybe<Scalars['String']['output']>;
    orderPaymentConditionType?: Maybe<OrderPaymentConditionType>;
    partner?: Maybe<PartnerDetails>;
    price: SearchResultPrice;
    priceWithTax: SearchResultPrice;
    productAsset?: Maybe<SearchResultAsset>;
    productId: Scalars['ID']['output'];
    productName: Scalars['String']['output'];
    productVariantAsset?: Maybe<SearchResultAsset>;
    productVariantId: Scalars['ID']['output'];
    productVariantName: Scalars['String']['output'];
    promotionDiscount?: Maybe<VariantPromotionFormatToSearch>;
    /** A relevance score for the result. Differs between database implementations */
    score: Scalars['Float']['output'];
    sku: Scalars['String']['output'];
    slug: Scalars['String']['output'];
    variants?: Maybe<Array<Maybe<SearchVariantsResult>>>;
};

export type SearchResultAsset = {
    __typename?: 'SearchResultAsset';
    focalPoint?: Maybe<Coordinate>;
    id: Scalars['ID']['output'];
    preview: Scalars['String']['output'];
};

/** The price of a search result product, either as a range or as a single price */
export type SearchResultPrice = PriceRange | SinglePrice;

export type SearchResultProductStat = Node & {
    __typename?: 'SearchResultProductStat';
    count: Scalars['Int']['output'];
    createdAt: Scalars['DateTime']['output'];
    id: Scalars['ID']['output'];
    product?: Maybe<Product>;
    productId: Scalars['ID']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type SearchResultProductStatFilterParameter = {
    _and?: InputMaybe<Array<SearchResultProductStatFilterParameter>>;
    _or?: InputMaybe<Array<SearchResultProductStatFilterParameter>>;
    count?: InputMaybe<NumberOperators>;
    createdAt?: InputMaybe<DateOperators>;
    id?: InputMaybe<IdOperators>;
    productId?: InputMaybe<NumberOperators>;
    productName?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type SearchResultProductStatList = PaginatedList & {
    __typename?: 'SearchResultProductStatList';
    items: Array<SearchResultProductStat>;
    totalItems: Scalars['Int']['output'];
};

export type SearchResultProductStatListOptions = {
    filter?: InputMaybe<SearchResultProductStatFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    sort?: InputMaybe<SearchResultProductStatSortParameter>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchResultProductStatNotFoundError = {
    __typename?: 'SearchResultProductStatNotFoundError';
    errorCode: Scalars['String']['output'];
    message: Scalars['String']['output'];
};

export type SearchResultProductStatSortParameter = {
    count?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    productId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type SearchResultSortParameter = {
    name?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
};

export type SearchTermStat = Node & {
    __typename?: 'SearchTermStat';
    count: Scalars['Int']['output'];
    createdAt: Scalars['DateTime']['output'];
    id: Scalars['ID']['output'];
    lastResultCount: Scalars['Int']['output'];
    term: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type SearchTermStatFilterParameter = {
    _and?: InputMaybe<Array<SearchTermStatFilterParameter>>;
    _or?: InputMaybe<Array<SearchTermStatFilterParameter>>;
    count?: InputMaybe<NumberOperators>;
    createdAt?: InputMaybe<DateOperators>;
    id?: InputMaybe<IdOperators>;
    lastResultCount?: InputMaybe<NumberOperators>;
    term?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type SearchTermStatList = PaginatedList & {
    __typename?: 'SearchTermStatList';
    items: Array<SearchTermStat>;
    totalItems: Scalars['Int']['output'];
};

export type SearchTermStatListOptions = {
    filter?: InputMaybe<SearchTermStatFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    sort?: InputMaybe<SearchTermStatSortParameter>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchTermStatNotFoundError = {
    __typename?: 'SearchTermStatNotFoundError';
    errorCode: Scalars['String']['output'];
    message: Scalars['String']['output'];
};

export type SearchTermStatSortParameter = {
    count?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastResultCount?: InputMaybe<SortOrder>;
    term?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type SearchVariantsCustomFields = {
    __typename?: 'SearchVariantsCustomFields';
    boxQuantity?: Maybe<Scalars['Int']['output']>;
    measurementUnit?: Maybe<MeasurementUnit>;
    minimumQuantity?: Maybe<Scalars['String']['output']>;
    multiple?: Maybe<Scalars['String']['output']>;
    orderPaymentConditionType?: Maybe<OrderPaymentConditionType>;
};

export type SearchVariantsResult = {
    __typename?: 'SearchVariantsResult';
    channelId?: Maybe<Scalars['String']['output']>;
    customFields?: Maybe<SearchVariantsCustomFields>;
    featuredAsset?: Maybe<SearchResultAsset>;
    gtin?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    inStock?: Maybe<Scalars['Boolean']['output']>;
    partner?: Maybe<PartnerDetails>;
    price?: Maybe<Scalars['Int']['output']>;
    promotionDiscount?: Maybe<VariantPromotionFormatToSearch>;
    sku?: Maybe<Scalars['String']['output']>;
};

export type Seller = Node & {
    __typename?: 'Seller';
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<SellerCustomFields>;
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type SellerCustomFields = {
    __typename?: 'SellerCustomFields';
    externalId?: Maybe<Scalars['String']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
};

export type SellerCustomerPortfolio = {
    __typename?: 'SellerCustomerPortfolio';
    channel: Channel;
    createdAt: Scalars['DateTime']['output'];
    customer: Customer;
    id: Scalars['ID']['output'];
    representativeId: Scalars['Int']['output'];
    seller: Administrator;
    updatedAt: Scalars['DateTime']['output'];
};

export type SellerCustomerPortfolioInput = {
    channelId: Scalars['ID']['input'];
    customerId: Scalars['ID']['input'];
    representativeId: Scalars['Int']['input'];
    sellerId: Scalars['ID']['input'];
};

export type SellerCustomerPortfolioUpdateInput = {
    channelId?: InputMaybe<Scalars['ID']['input']>;
    customerId?: InputMaybe<Scalars['ID']['input']>;
    id: Scalars['ID']['input'];
    representativeId?: InputMaybe<Scalars['Int']['input']>;
    sellerId?: InputMaybe<Scalars['ID']['input']>;
};

export type SellerFilterParameter = {
    _and?: InputMaybe<Array<SellerFilterParameter>>;
    _or?: InputMaybe<Array<SellerFilterParameter>>;
    createdAt?: InputMaybe<DateOperators>;
    externalId?: InputMaybe<StringOperators>;
    id?: InputMaybe<IdOperators>;
    name?: InputMaybe<StringOperators>;
    phone?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type SellerList = PaginatedList & {
    __typename?: 'SellerList';
    items: Array<Seller>;
    totalItems: Scalars['Int']['output'];
};

export type SellerListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<SellerFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<SellerSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type SellerSortParameter = {
    createdAt?: InputMaybe<SortOrder>;
    externalId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    phone?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ServerConfig = {
    __typename?: 'ServerConfig';
    /**
     * This field is deprecated in v2.2 in favor of the entityCustomFields field,
     * which allows custom fields to be defined on user-supplies entities.
     */
    customFieldConfig: CustomFields;
    entityCustomFields: Array<EntityCustomFields>;
    moneyStrategyPrecision: Scalars['Int']['output'];
    orderProcess: Array<OrderProcessState>;
    permissions: Array<PermissionDefinition>;
    permittedAssetTypes: Array<Scalars['String']['output']>;
};

export type SetCustomerForDraftOrderResult = EmailAddressConflictError | Order;

export type SetOrderCustomerInput = {
    customerId: Scalars['ID']['input'];
    note?: InputMaybe<Scalars['String']['input']>;
    orderId: Scalars['ID']['input'];
};

export type SetOrderShippingMethodResult =
    | IneligibleShippingMethodError
    | NoActiveOrderError
    | Order
    | OrderModificationError;

/** Returned if the Payment settlement fails */
export type SettlePaymentError = ErrorResult & {
    __typename?: 'SettlePaymentError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
    paymentErrorMessage: Scalars['String']['output'];
};

export type SettlePaymentResult =
    | OrderStateTransitionError
    | Payment
    | PaymentStateTransitionError
    | SettlePaymentError;

export type SettleRefundInput = {
    id: Scalars['ID']['input'];
    transactionId: Scalars['String']['input'];
};

export type SettleRefundResult = Refund | RefundStateTransitionError;

export type ShippingLine = {
    __typename?: 'ShippingLine';
    customFields?: Maybe<Scalars['JSON']['output']>;
    discountedPrice: Scalars['Money']['output'];
    discountedPriceWithTax: Scalars['Money']['output'];
    discounts: Array<Discount>;
    id: Scalars['ID']['output'];
    price: Scalars['Money']['output'];
    priceWithTax: Scalars['Money']['output'];
    shippingMethod: ShippingMethod;
};

export type ShippingMethod = Node & {
    __typename?: 'ShippingMethod';
    calculator: ConfigurableOperation;
    checker: ConfigurableOperation;
    code: Scalars['String']['output'];
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<Scalars['JSON']['output']>;
    description: Scalars['String']['output'];
    fulfillmentHandlerCode: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    languageCode: LanguageCode;
    name: Scalars['String']['output'];
    translations: Array<ShippingMethodTranslation>;
    updatedAt: Scalars['DateTime']['output'];
};

export type ShippingMethodFilterParameter = {
    _and?: InputMaybe<Array<ShippingMethodFilterParameter>>;
    _or?: InputMaybe<Array<ShippingMethodFilterParameter>>;
    code?: InputMaybe<StringOperators>;
    createdAt?: InputMaybe<DateOperators>;
    description?: InputMaybe<StringOperators>;
    fulfillmentHandlerCode?: InputMaybe<StringOperators>;
    id?: InputMaybe<IdOperators>;
    languageCode?: InputMaybe<StringOperators>;
    name?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type ShippingMethodList = PaginatedList & {
    __typename?: 'ShippingMethodList';
    items: Array<ShippingMethod>;
    totalItems: Scalars['Int']['output'];
};

export type ShippingMethodListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<ShippingMethodFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<ShippingMethodSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type ShippingMethodQuote = {
    __typename?: 'ShippingMethodQuote';
    code: Scalars['String']['output'];
    customFields?: Maybe<Scalars['JSON']['output']>;
    description: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    /** Any optional metadata returned by the ShippingCalculator in the ShippingCalculationResult */
    metadata?: Maybe<Scalars['JSON']['output']>;
    name: Scalars['String']['output'];
    price: Scalars['Money']['output'];
    priceWithTax: Scalars['Money']['output'];
};

export type ShippingMethodSortParameter = {
    code?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    fulfillmentHandlerCode?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ShippingMethodTranslation = {
    __typename?: 'ShippingMethodTranslation';
    createdAt: Scalars['DateTime']['output'];
    description: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    languageCode: LanguageCode;
    name: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type ShippingMethodTranslationInput = {
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    languageCode: LanguageCode;
    name?: InputMaybe<Scalars['String']['input']>;
};

export type ShoppingList = Node & {
    __typename?: 'ShoppingList';
    buyers: Array<User>;
    createdAt: Scalars['DateTime']['output'];
    createdBy: User;
    description?: Maybe<Scalars['String']['output']>;
    enabled: Scalars['Boolean']['output'];
    endDate?: Maybe<Scalars['DateTime']['output']>;
    id: Scalars['ID']['output'];
    image?: Maybe<Asset>;
    isPrivate: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    originType: ShoppingListOriginTypes;
    productVariants: Array<ProductVariantShoppingList>;
    slug: Scalars['String']['output'];
    startDate?: Maybe<Scalars['DateTime']['output']>;
    token: Scalars['String']['output'];
    totalPrice?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['DateTime']['output'];
};

export type ShoppingListFilterParameter = {
    _and?: InputMaybe<Array<ShoppingListFilterParameter>>;
    _or?: InputMaybe<Array<ShoppingListFilterParameter>>;
    createdAt?: InputMaybe<DateOperators>;
    description?: InputMaybe<StringOperators>;
    enabled?: InputMaybe<BooleanOperators>;
    endDate?: InputMaybe<DateOperators>;
    id?: InputMaybe<IdOperators>;
    isPrivate?: InputMaybe<BooleanOperators>;
    name?: InputMaybe<StringOperators>;
    originType?: InputMaybe<StringOperators>;
    slug?: InputMaybe<StringOperators>;
    startDate?: InputMaybe<DateOperators>;
    token?: InputMaybe<StringOperators>;
    totalPrice?: InputMaybe<NumberOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type ShoppingListList = PaginatedList & {
    __typename?: 'ShoppingListList';
    items: Array<ShoppingList>;
    totalItems: Scalars['Int']['output'];
};

export type ShoppingListListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<ShoppingListFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<ShoppingListSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export enum ShoppingListOriginTypes {
    from_customer = 'from_customer',
    from_seller = 'from_seller',
    from_system = 'from_system',
}

export type ShoppingListProductVariantInput = {
    id: Scalars['ID']['input'];
    quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type ShoppingListSortParameter = {
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    endDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    slug?: InputMaybe<SortOrder>;
    startDate?: InputMaybe<SortOrder>;
    token?: InputMaybe<SortOrder>;
    totalPrice?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ShoppingListToProduct = Node & {
    __typename?: 'ShoppingListToProduct';
    createdAt: Scalars['DateTime']['output'];
    id: Scalars['ID']['output'];
    productVariant?: Maybe<ProductVariant>;
    quantity: Scalars['Int']['output'];
    shoppingList?: Maybe<ShoppingList>;
    updatedAt: Scalars['DateTime']['output'];
};

export type ShoppingListToProductFilterParameter = {
    _and?: InputMaybe<Array<ShoppingListToProductFilterParameter>>;
    _or?: InputMaybe<Array<ShoppingListToProductFilterParameter>>;
    createdAt?: InputMaybe<DateOperators>;
    id?: InputMaybe<IdOperators>;
    quantity?: InputMaybe<NumberOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type ShoppingListToProductList = PaginatedList & {
    __typename?: 'ShoppingListToProductList';
    items: Array<ShoppingListToProduct>;
    totalItems: Scalars['Int']['output'];
};

export type ShoppingListToProductListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<ShoppingListToProductFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<ShoppingListToProductSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type ShoppingListToProductSortParameter = {
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    quantity?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

/** The price value where the result has a single price */
export type SinglePrice = {
    __typename?: 'SinglePrice';
    value: Scalars['Money']['output'];
};

export type SocialMediaAlreadyRegisteredError = {
    __typename?: 'SocialMediaAlreadyRegisteredError';
    errorCode: Scalars['String']['output'];
    message: Scalars['String']['output'];
};

export type SocialMediaFilterInput = {
    link?: InputMaybe<Scalars['String']['input']>;
    nome?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
};

export enum SocialMediaName {
    BEHANCE = 'BEHANCE',
    DISCORD = 'DISCORD',
    DRIBBBLE = 'DRIBBBLE',
    FACEBOOK = 'FACEBOOK',
    GOODREADS = 'GOODREADS',
    GOOGLE_PLUS = 'GOOGLE_PLUS',
    INSTAGRAM = 'INSTAGRAM',
    LINE = 'LINE',
    LINKEDIN = 'LINKEDIN',
    MEDIUM = 'MEDIUM',
    MEETUP = 'MEETUP',
    MIXCLOUD = 'MIXCLOUD',
    PERISCOPE = 'PERISCOPE',
    PINTEREST = 'PINTEREST',
    QUORA = 'QUORA',
    REDDIT = 'REDDIT',
    RENREN = 'RENREN',
    SINA_WEIBO = 'SINA_WEIBO',
    SKYPE = 'SKYPE',
    SLIDESHARE = 'SLIDESHARE',
    SNAPCHAT = 'SNAPCHAT',
    SOUNDCLOUD = 'SOUNDCLOUD',
    TELEGRAM = 'TELEGRAM',
    TIKTOK = 'TIKTOK',
    TWITCH = 'TWITCH',
    TWITTER = 'TWITTER',
    VIMEO = 'VIMEO',
    VKONTAKTE = 'VKONTAKTE',
    WECHAT = 'WECHAT',
    WHATSAPP = 'WHATSAPP',
    XING = 'XING',
    YOUTUBE = 'YOUTUBE',
}

export type SocialMediaNotFoundError = {
    __typename?: 'SocialMediaNotFoundError';
    errorCode: Scalars['String']['output'];
    message: Scalars['String']['output'];
};

export enum SortOrder {
    ASC = 'ASC',
    DESC = 'DESC',
}

export type SpecialPromotionIndex = Node & {
    __typename?: 'SpecialPromotionIndex';
    activationGroupBooster: Scalars['Boolean']['output'];
    activationGroupId: Scalars['Int']['output'];
    activationGroupMinQuantity: Scalars['Int']['output'];
    activationGroupName?: Maybe<Scalars['String']['output']>;
    categoryDiscount: Scalars['Int']['output'];
    categoryId: Scalars['Int']['output'];
    categoryMinQuantity: Scalars['Int']['output'];
    categoryName?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTime']['output'];
    deletedAt?: Maybe<Scalars['DateTime']['output']>;
    enabled: Scalars['Boolean']['output'];
    endsAt?: Maybe<Scalars['DateTime']['output']>;
    id: Scalars['ID']['output'];
    maxActivationValue?: Maybe<Scalars['Float']['output']>;
    minActivationValue?: Maybe<Scalars['Float']['output']>;
    name: Scalars['String']['output'];
    promotion: Promotion;
    promotionId: Scalars['ID']['output'];
    startsAt?: Maybe<Scalars['DateTime']['output']>;
    updatedAt: Scalars['DateTime']['output'];
    variantsIds: Array<Scalars['String']['output']>;
};

export type SpecialPromotionIndexFilterParameter = {
    activationGroupId?: InputMaybe<IdOperators>;
    categoryId?: InputMaybe<IdOperators>;
    id?: InputMaybe<IdOperators>;
    promotionId?: InputMaybe<IdOperators>;
};

export type SpecialPromotionIndexList = PaginatedList & {
    __typename?: 'SpecialPromotionIndexList';
    items: Array<SpecialPromotionIndex>;
    totalItems: Scalars['Int']['output'];
};

export type SpecialPromotionIndexListOptions = {
    filter?: InputMaybe<SpecialPromotionIndexFilterParameter>;
    skip?: InputMaybe<Scalars['Float']['input']>;
    sort?: InputMaybe<SpecialPromotionIndexSortParameter>;
    take?: InputMaybe<Scalars['Float']['input']>;
};

export type SpecialPromotionIndexSortParameter = {
    activationGroupId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
};

export type StockAdjustment = Node &
    StockMovement & {
        __typename?: 'StockAdjustment';
        createdAt: Scalars['DateTime']['output'];
        customFields?: Maybe<Scalars['JSON']['output']>;
        id: Scalars['ID']['output'];
        productVariant: ProductVariant;
        quantity: Scalars['Int']['output'];
        type: StockMovementType;
        updatedAt: Scalars['DateTime']['output'];
    };

export type StockLevel = Node & {
    __typename?: 'StockLevel';
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<Scalars['JSON']['output']>;
    id: Scalars['ID']['output'];
    stockAllocated: Scalars['Int']['output'];
    stockLocation: StockLocation;
    stockLocationId: Scalars['ID']['output'];
    stockOnHand: Scalars['Int']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type StockLevelInput = {
    stockLocationId: Scalars['ID']['input'];
    stockOnHand: Scalars['Int']['input'];
};

export type StockLocation = Node & {
    __typename?: 'StockLocation';
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<StockLocationCustomFields>;
    description: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type StockLocationCustomFields = {
    __typename?: 'StockLocationCustomFields';
    externalId?: Maybe<Scalars['String']['output']>;
};

export type StockLocationFilterParameter = {
    _and?: InputMaybe<Array<StockLocationFilterParameter>>;
    _or?: InputMaybe<Array<StockLocationFilterParameter>>;
    createdAt?: InputMaybe<DateOperators>;
    description?: InputMaybe<StringOperators>;
    externalId?: InputMaybe<StringOperators>;
    id?: InputMaybe<IdOperators>;
    name?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type StockLocationList = PaginatedList & {
    __typename?: 'StockLocationList';
    items: Array<StockLocation>;
    totalItems: Scalars['Int']['output'];
};

export type StockLocationListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<StockLocationFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<StockLocationSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type StockLocationSortParameter = {
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    externalId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type StockMovement = {
    createdAt: Scalars['DateTime']['output'];
    id: Scalars['ID']['output'];
    productVariant: ProductVariant;
    quantity: Scalars['Int']['output'];
    type: StockMovementType;
    updatedAt: Scalars['DateTime']['output'];
};

export type StockMovementItem =
    | Allocation
    | Cancellation
    | Release
    | Return
    | Sale
    | StockAdjustment;

export type StockMovementList = {
    __typename?: 'StockMovementList';
    items: Array<StockMovementItem>;
    totalItems: Scalars['Int']['output'];
};

export type StockMovementListOptions = {
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    type?: InputMaybe<StockMovementType>;
};

export enum StockMovementType {
    ADJUSTMENT = 'ADJUSTMENT',
    ALLOCATION = 'ALLOCATION',
    CANCELLATION = 'CANCELLATION',
    RELEASE = 'RELEASE',
    RETURN = 'RETURN',
    SALE = 'SALE',
}

export type StringCustomFieldConfig = CustomField & {
    __typename?: 'StringCustomFieldConfig';
    description?: Maybe<Array<LocalizedString>>;
    internal?: Maybe<Scalars['Boolean']['output']>;
    label?: Maybe<Array<LocalizedString>>;
    length?: Maybe<Scalars['Int']['output']>;
    list: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    nullable?: Maybe<Scalars['Boolean']['output']>;
    options?: Maybe<Array<StringFieldOption>>;
    pattern?: Maybe<Scalars['String']['output']>;
    readonly?: Maybe<Scalars['Boolean']['output']>;
    requiresPermission?: Maybe<Array<Permission>>;
    type: Scalars['String']['output'];
    ui?: Maybe<Scalars['JSON']['output']>;
};

export type StringFieldOption = {
    __typename?: 'StringFieldOption';
    label?: Maybe<Array<LocalizedString>>;
    value: Scalars['String']['output'];
};

/** Operators for filtering on a list of String fields */
export type StringListOperators = {
    inList: Scalars['String']['input'];
};

/** Operators for filtering on a String field */
export type StringOperators = {
    contains?: InputMaybe<Scalars['String']['input']>;
    eq?: InputMaybe<Scalars['String']['input']>;
    in?: InputMaybe<Array<Scalars['String']['input']>>;
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
    notContains?: InputMaybe<Scalars['String']['input']>;
    notEq?: InputMaybe<Scalars['String']['input']>;
    notIn?: InputMaybe<Array<Scalars['String']['input']>>;
    regex?: InputMaybe<Scalars['String']['input']>;
};

export type StringStructFieldConfig = StructField & {
    __typename?: 'StringStructFieldConfig';
    description?: Maybe<Array<LocalizedString>>;
    label?: Maybe<Array<LocalizedString>>;
    length?: Maybe<Scalars['Int']['output']>;
    list: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    options?: Maybe<Array<StringFieldOption>>;
    pattern?: Maybe<Scalars['String']['output']>;
    type: Scalars['String']['output'];
    ui?: Maybe<Scalars['JSON']['output']>;
};

export type StructCustomFieldConfig = CustomField & {
    __typename?: 'StructCustomFieldConfig';
    description?: Maybe<Array<LocalizedString>>;
    fields: Array<StructFieldConfig>;
    internal?: Maybe<Scalars['Boolean']['output']>;
    label?: Maybe<Array<LocalizedString>>;
    list: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    nullable?: Maybe<Scalars['Boolean']['output']>;
    readonly?: Maybe<Scalars['Boolean']['output']>;
    requiresPermission?: Maybe<Array<Permission>>;
    type: Scalars['String']['output'];
    ui?: Maybe<Scalars['JSON']['output']>;
};

export type StructField = {
    description?: Maybe<Array<LocalizedString>>;
    label?: Maybe<Array<LocalizedString>>;
    list?: Maybe<Scalars['Boolean']['output']>;
    name: Scalars['String']['output'];
    type: Scalars['String']['output'];
    ui?: Maybe<Scalars['JSON']['output']>;
};

export type StructFieldConfig =
    | BooleanStructFieldConfig
    | DateTimeStructFieldConfig
    | FloatStructFieldConfig
    | IntStructFieldConfig
    | StringStructFieldConfig
    | TextStructFieldConfig;

export type SubmitMultipleSurveyResponsesInput = {
    customerId: Scalars['ID']['input'];
    orderId: Scalars['ID']['input'];
    responses: Array<SurveyResponseInput>;
};

/** Indicates that an operation succeeded, where we do not want to return any more specific information. */
export type Success = {
    __typename?: 'Success';
    success: Scalars['Boolean']['output'];
};

export type Surcharge = Node & {
    __typename?: 'Surcharge';
    createdAt: Scalars['DateTime']['output'];
    description: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    price: Scalars['Money']['output'];
    priceWithTax: Scalars['Money']['output'];
    sku?: Maybe<Scalars['String']['output']>;
    taxLines: Array<TaxLine>;
    taxRate: Scalars['Float']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type SurchargeInput = {
    description: Scalars['String']['input'];
    price: Scalars['Money']['input'];
    priceIncludesTax: Scalars['Boolean']['input'];
    sku?: InputMaybe<Scalars['String']['input']>;
    taxDescription?: InputMaybe<Scalars['String']['input']>;
    taxRate?: InputMaybe<Scalars['Float']['input']>;
};

export type SurveyQuestion = {
    __typename?: 'SurveyQuestion';
    createdAt: Scalars['DateTime']['output'];
    id: Scalars['ID']['output'];
    isActive: Scalars['Boolean']['output'];
    options?: Maybe<Array<Scalars['String']['output']>>;
    sortOrder: Scalars['Int']['output'];
    title: Scalars['String']['output'];
    type: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type SurveyQuestionList = {
    __typename?: 'SurveyQuestionList';
    items: Array<SurveyQuestion>;
    totalItems: Scalars['Int']['output'];
};

export type SurveyResponse = {
    __typename?: 'SurveyResponse';
    answer: Scalars['JSON']['output'];
    createdAt: Scalars['DateTime']['output'];
    customer: Customer;
    id: Scalars['ID']['output'];
    order: Order;
    question?: Maybe<SurveyQuestion>;
    updatedAt: Scalars['DateTime']['output'];
};

export type SurveyResponseInput = {
    answer: Scalars['JSON']['input'];
    questionId: Scalars['ID']['input'];
};

export type SurveyResponseList = {
    __typename?: 'SurveyResponseList';
    items: Array<SurveyResponse>;
    totalItems: Scalars['Int']['output'];
};

export type SyncPricesForVariantResult = PriceSyncError | Success;

export type SynonymGroup = Node & {
    __typename?: 'SynonymGroup';
    createdAt: Scalars['DateTime']['output'];
    enabled: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    label: Scalars['String']['output'];
    terms: Array<Scalars['String']['output']>;
    updatedAt: Scalars['DateTime']['output'];
};

export type SynonymGroupFilterParameter = {
    _and?: InputMaybe<Array<SynonymGroupFilterParameter>>;
    _or?: InputMaybe<Array<SynonymGroupFilterParameter>>;
    createdAt?: InputMaybe<DateOperators>;
    enabled?: InputMaybe<BooleanOperators>;
    id?: InputMaybe<IdOperators>;
    label?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type SynonymGroupLabelAlreadyExistsError = {
    __typename?: 'SynonymGroupLabelAlreadyExistsError';
    errorCode: Scalars['String']['output'];
    message: Scalars['String']['output'];
};

export type SynonymGroupList = PaginatedList & {
    __typename?: 'SynonymGroupList';
    items: Array<SynonymGroup>;
    totalItems: Scalars['Int']['output'];
};

export type SynonymGroupListOptions = {
    filter?: InputMaybe<SynonymGroupFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    sort?: InputMaybe<SynonymGroupSortParameter>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type SynonymGroupNotFoundError = {
    __typename?: 'SynonymGroupNotFoundError';
    errorCode: Scalars['String']['output'];
    message: Scalars['String']['output'];
};

export type SynonymGroupSortParameter = {
    createdAt?: InputMaybe<SortOrder>;
    enabled?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    label?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type SynonymGroupTooFewTermsError = {
    __typename?: 'SynonymGroupTooFewTermsError';
    errorCode: Scalars['String']['output'];
    message: Scalars['String']['output'];
};

export type Tag = Node & {
    __typename?: 'Tag';
    createdAt: Scalars['DateTime']['output'];
    id: Scalars['ID']['output'];
    updatedAt: Scalars['DateTime']['output'];
    value: Scalars['String']['output'];
};

export type TagFilterParameter = {
    _and?: InputMaybe<Array<TagFilterParameter>>;
    _or?: InputMaybe<Array<TagFilterParameter>>;
    createdAt?: InputMaybe<DateOperators>;
    id?: InputMaybe<IdOperators>;
    updatedAt?: InputMaybe<DateOperators>;
    value?: InputMaybe<StringOperators>;
};

export type TagList = PaginatedList & {
    __typename?: 'TagList';
    items: Array<Tag>;
    totalItems: Scalars['Int']['output'];
};

export type TagListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<TagFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<TagSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type TagSortParameter = {
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    value?: InputMaybe<SortOrder>;
};

export type TaxCategory = Node & {
    __typename?: 'TaxCategory';
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<Scalars['JSON']['output']>;
    id: Scalars['ID']['output'];
    isDefault: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type TaxCategoryFilterParameter = {
    _and?: InputMaybe<Array<TaxCategoryFilterParameter>>;
    _or?: InputMaybe<Array<TaxCategoryFilterParameter>>;
    createdAt?: InputMaybe<DateOperators>;
    id?: InputMaybe<IdOperators>;
    isDefault?: InputMaybe<BooleanOperators>;
    name?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type TaxCategoryList = PaginatedList & {
    __typename?: 'TaxCategoryList';
    items: Array<TaxCategory>;
    totalItems: Scalars['Int']['output'];
};

export type TaxCategoryListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<TaxCategoryFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<TaxCategorySortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type TaxCategorySortParameter = {
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type TaxLine = {
    __typename?: 'TaxLine';
    description: Scalars['String']['output'];
    taxRate: Scalars['Float']['output'];
};

export type TaxRate = Node & {
    __typename?: 'TaxRate';
    category: TaxCategory;
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<Scalars['JSON']['output']>;
    customerGroup?: Maybe<CustomerGroup>;
    enabled: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
    value: Scalars['Float']['output'];
    zone: Zone;
};

export type TaxRateFilterParameter = {
    _and?: InputMaybe<Array<TaxRateFilterParameter>>;
    _or?: InputMaybe<Array<TaxRateFilterParameter>>;
    createdAt?: InputMaybe<DateOperators>;
    enabled?: InputMaybe<BooleanOperators>;
    id?: InputMaybe<IdOperators>;
    name?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
    value?: InputMaybe<NumberOperators>;
};

export type TaxRateList = PaginatedList & {
    __typename?: 'TaxRateList';
    items: Array<TaxRate>;
    totalItems: Scalars['Int']['output'];
};

export type TaxRateListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<TaxRateFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<TaxRateSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type TaxRateSortParameter = {
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    value?: InputMaybe<SortOrder>;
};

export type TestEligibleShippingMethodsInput = {
    lines: Array<TestShippingMethodOrderLineInput>;
    shippingAddress: CreateAddressInput;
};

export type TestShippingMethodInput = {
    calculator: ConfigurableOperationInput;
    checker: ConfigurableOperationInput;
    lines: Array<TestShippingMethodOrderLineInput>;
    shippingAddress: CreateAddressInput;
};

export type TestShippingMethodOrderLineInput = {
    productVariantId: Scalars['ID']['input'];
    quantity: Scalars['Int']['input'];
};

export type TestShippingMethodQuote = {
    __typename?: 'TestShippingMethodQuote';
    metadata?: Maybe<Scalars['JSON']['output']>;
    price: Scalars['Money']['output'];
    priceWithTax: Scalars['Money']['output'];
};

export type TestShippingMethodResult = {
    __typename?: 'TestShippingMethodResult';
    eligible: Scalars['Boolean']['output'];
    quote?: Maybe<TestShippingMethodQuote>;
};

export type TextCustomFieldConfig = CustomField & {
    __typename?: 'TextCustomFieldConfig';
    description?: Maybe<Array<LocalizedString>>;
    internal?: Maybe<Scalars['Boolean']['output']>;
    label?: Maybe<Array<LocalizedString>>;
    list: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    nullable?: Maybe<Scalars['Boolean']['output']>;
    readonly?: Maybe<Scalars['Boolean']['output']>;
    requiresPermission?: Maybe<Array<Permission>>;
    type: Scalars['String']['output'];
    ui?: Maybe<Scalars['JSON']['output']>;
};

export type TextStructFieldConfig = StructField & {
    __typename?: 'TextStructFieldConfig';
    description?: Maybe<Array<LocalizedString>>;
    label?: Maybe<Array<LocalizedString>>;
    list: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    type: Scalars['String']['output'];
    ui?: Maybe<Scalars['JSON']['output']>;
};

export type TransferSettings = {
    __typename?: 'TransferSettings';
    transfer_day?: Maybe<Scalars['Int']['output']>;
    transfer_enabled?: Maybe<Scalars['Boolean']['output']>;
    transfer_interval?: Maybe<Scalars['String']['output']>;
};

export type TransferSettingsInput = {
    transfer_day?: InputMaybe<Scalars['Int']['input']>;
    transfer_enabled?: InputMaybe<Scalars['Boolean']['input']>;
    transfer_interval?: InputMaybe<Scalars['String']['input']>;
};

export type TransitionFulfillmentToStateResult =
    | Fulfillment
    | FulfillmentStateTransitionError;

export type TransitionOrderToStateResult = Order | OrderStateTransitionError;

export type TransitionPaymentToStateResult =
    | Payment
    | PaymentStateTransitionError;

export type UpdateActiveAdministratorInput = {
    customFields?: InputMaybe<UpdateAdministratorCustomFieldsInput>;
    emailAddress?: InputMaybe<Scalars['String']['input']>;
    firstName?: InputMaybe<Scalars['String']['input']>;
    lastName?: InputMaybe<Scalars['String']['input']>;
    password?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAddressCustomFieldsInput = {
    neighborhood?: InputMaybe<Scalars['String']['input']>;
    number?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input used to update an Address.
 *
 * The countryCode must correspond to a `code` property of a Country that has been defined in the
 * Vendure server. The `code` property is typically a 2-character ISO code such as "GB", "US", "DE" etc.
 * If an invalid code is passed, the mutation will fail.
 */
export type UpdateAddressInput = {
    city?: InputMaybe<Scalars['String']['input']>;
    company?: InputMaybe<Scalars['String']['input']>;
    countryCode?: InputMaybe<Scalars['String']['input']>;
    customFields?: InputMaybe<UpdateAddressCustomFieldsInput>;
    defaultBillingAddress?: InputMaybe<Scalars['Boolean']['input']>;
    defaultShippingAddress?: InputMaybe<Scalars['Boolean']['input']>;
    fullName?: InputMaybe<Scalars['String']['input']>;
    id: Scalars['ID']['input'];
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
    postalCode?: InputMaybe<Scalars['String']['input']>;
    province?: InputMaybe<Scalars['String']['input']>;
    streetLine1?: InputMaybe<Scalars['String']['input']>;
    streetLine2?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAdministratorCustomFieldsInput = {
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAdministratorInput = {
    customFields?: InputMaybe<UpdateAdministratorCustomFieldsInput>;
    emailAddress?: InputMaybe<Scalars['String']['input']>;
    firstName?: InputMaybe<Scalars['String']['input']>;
    id: Scalars['ID']['input'];
    lastName?: InputMaybe<Scalars['String']['input']>;
    password?: InputMaybe<Scalars['String']['input']>;
    roleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateAssetInput = {
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    focalPoint?: InputMaybe<CoordinateInput>;
    id: Scalars['ID']['input'];
    name?: InputMaybe<Scalars['String']['input']>;
    tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateBannerInput = {
    enabled?: InputMaybe<Scalars['Boolean']['input']>;
    id: Scalars['ID']['input'];
    page?: InputMaybe<BannerPage>;
    position?: InputMaybe<BannerPosition>;
    public?: InputMaybe<Scalars['Boolean']['input']>;
    slug: Scalars['String']['input'];
    type?: InputMaybe<BannerType>;
};

export type UpdateBannerItemInput = {
    asset: Scalars['ID']['input'];
    banner: Scalars['ID']['input'];
    description?: InputMaybe<Scalars['String']['input']>;
    end?: InputMaybe<Scalars['String']['input']>;
    id: Scalars['ID']['input'];
    link: Scalars['String']['input'];
    mobile?: InputMaybe<Scalars['ID']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    start: Scalars['String']['input'];
};

export type UpdateCardBrandInput = {
    brandName?: InputMaybe<Scalars['String']['input']>;
    id: Scalars['ID']['input'];
};

export type UpdateCardFeeInput = {
    brandId?: InputMaybe<Scalars['ID']['input']>;
    feePercentage?: InputMaybe<Scalars['Float']['input']>;
    id: Scalars['ID']['input'];
    installments?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateChannelCustomFieldsInput = {
    color?: InputMaybe<Array<Scalars['String']['input']>>;
    enable?: InputMaybe<Scalars['Boolean']['input']>;
    logoId?: InputMaybe<Scalars['ID']['input']>;
    recipientId?: InputMaybe<Scalars['String']['input']>;
    stateCode?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateChannelInput = {
    availableCurrencyCodes?: InputMaybe<Array<CurrencyCode>>;
    availableLanguageCodes?: InputMaybe<Array<LanguageCode>>;
    code?: InputMaybe<Scalars['String']['input']>;
    customFields?: InputMaybe<UpdateChannelCustomFieldsInput>;
    defaultCurrencyCode?: InputMaybe<CurrencyCode>;
    defaultLanguageCode?: InputMaybe<LanguageCode>;
    defaultShippingZoneId?: InputMaybe<Scalars['ID']['input']>;
    defaultTaxZoneId?: InputMaybe<Scalars['ID']['input']>;
    id: Scalars['ID']['input'];
    outOfStockThreshold?: InputMaybe<Scalars['Int']['input']>;
    pricesIncludeTax?: InputMaybe<Scalars['Boolean']['input']>;
    sellerId?: InputMaybe<Scalars['ID']['input']>;
    token?: InputMaybe<Scalars['String']['input']>;
    trackInventory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateChannelResult = Channel | LanguageNotAvailableError;

export type UpdateChannelSocialMediaInput = {
    id: Scalars['ID']['input'];
    link?: InputMaybe<Scalars['String']['input']>;
    nome?: InputMaybe<SocialMediaName>;
    title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateChannelSocialMediaResult =
    | ChannelSocialMedia
    | SocialMediaNotFoundError;

export type UpdateCollectionCustomFieldsInput = {
    collectionLevel?: InputMaybe<Scalars['String']['input']>;
    facebookImageId?: InputMaybe<Scalars['ID']['input']>;
    twitterImageId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCollectionInput = {
    assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    customFields?: InputMaybe<UpdateCollectionCustomFieldsInput>;
    featuredAssetId?: InputMaybe<Scalars['ID']['input']>;
    filters?: InputMaybe<Array<ConfigurableOperationInput>>;
    id: Scalars['ID']['input'];
    inheritFilters?: InputMaybe<Scalars['Boolean']['input']>;
    isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
    parentId?: InputMaybe<Scalars['ID']['input']>;
    translations?: InputMaybe<Array<UpdateCollectionTranslationInput>>;
};

export type UpdateCollectionTranslationInput = {
    customFields?: InputMaybe<UpdateCollectionTranslationInputCustomFields>;
    description?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    languageCode: LanguageCode;
    name?: InputMaybe<Scalars['String']['input']>;
    slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCollectionTranslationInputCustomFields = {
    seoDescription?: InputMaybe<Scalars['String']['input']>;
    seoTitle?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCountryInput = {
    code?: InputMaybe<Scalars['String']['input']>;
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    enabled?: InputMaybe<Scalars['Boolean']['input']>;
    id: Scalars['ID']['input'];
    translations?: InputMaybe<Array<CountryTranslationInput>>;
};

export type UpdateCustomerCustomFieldsInput = {
    avatarId?: InputMaybe<Scalars['ID']['input']>;
    birthDate?: InputMaybe<Scalars['String']['input']>;
    businessLine?: InputMaybe<Scalars['String']['input']>;
    businessPhone?: InputMaybe<Scalars['String']['input']>;
    cellphone?: InputMaybe<Scalars['String']['input']>;
    channelFindOut?: InputMaybe<Scalars['String']['input']>;
    companyName?: InputMaybe<Scalars['String']['input']>;
    emailForInvoice?: InputMaybe<Scalars['String']['input']>;
    establishmentSize?: InputMaybe<Scalars['String']['input']>;
    exemptStateRegistration?: InputMaybe<Scalars['Boolean']['input']>;
    nationalRegistry?: InputMaybe<Scalars['String']['input']>;
    nationalRegistryIssuer?: InputMaybe<Scalars['String']['input']>;
    numberOfBoxes?: InputMaybe<Scalars['Int']['input']>;
    ownersDocument?: InputMaybe<Scalars['String']['input']>;
    serviceRegion?: InputMaybe<Scalars['String']['input']>;
    stateRegistration?: InputMaybe<Scalars['String']['input']>;
    tradeName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerGroupInput = {
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    id: Scalars['ID']['input'];
    name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerInput = {
    customFields?: InputMaybe<UpdateCustomerCustomFieldsInput>;
    emailAddress?: InputMaybe<Scalars['String']['input']>;
    firstName?: InputMaybe<Scalars['String']['input']>;
    id: Scalars['ID']['input'];
    lastName?: InputMaybe<Scalars['String']['input']>;
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerNoteInput = {
    note: Scalars['String']['input'];
    noteId: Scalars['ID']['input'];
};

export type UpdateCustomerResult = Customer | EmailAddressConflictError;

export type UpdateFacetInput = {
    code?: InputMaybe<Scalars['String']['input']>;
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    id: Scalars['ID']['input'];
    isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
    translations?: InputMaybe<Array<FacetTranslationInput>>;
};

export type UpdateFacetValueInput = {
    code?: InputMaybe<Scalars['String']['input']>;
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    id: Scalars['ID']['input'];
    translations?: InputMaybe<Array<FacetValueTranslationInput>>;
};

export type UpdateGlobalSettingsCustomFieldsInput = {
    retryCount?: InputMaybe<Scalars['Int']['input']>;
    retryDelay?: InputMaybe<Scalars['Int']['input']>;
    retryInterval?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateGlobalSettingsInput = {
    availableLanguages?: InputMaybe<Array<LanguageCode>>;
    customFields?: InputMaybe<UpdateGlobalSettingsCustomFieldsInput>;
    outOfStockThreshold?: InputMaybe<Scalars['Int']['input']>;
    trackInventory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateGlobalSettingsResult =
    | ChannelDefaultLanguageError
    | GlobalSettings;

export type UpdateOrderAddressInput = {
    city?: InputMaybe<Scalars['String']['input']>;
    company?: InputMaybe<Scalars['String']['input']>;
    countryCode?: InputMaybe<Scalars['String']['input']>;
    customFields?: InputMaybe<UpdateAddressCustomFieldsInput>;
    fullName?: InputMaybe<Scalars['String']['input']>;
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
    postalCode?: InputMaybe<Scalars['String']['input']>;
    province?: InputMaybe<Scalars['String']['input']>;
    streetLine1?: InputMaybe<Scalars['String']['input']>;
    streetLine2?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderCustomFieldsInput = {
    installments?: InputMaybe<Scalars['Int']['input']>;
    orderToken?: InputMaybe<Scalars['String']['input']>;
    pagarmeBoletoUrl?: InputMaybe<Scalars['String']['input']>;
    pagarmeOrderId?: InputMaybe<Scalars['String']['input']>;
    pagarmePaymentType?: InputMaybe<Scalars['String']['input']>;
    pagarmeQrcode?: InputMaybe<Scalars['String']['input']>;
    paymentConditionType?: InputMaybe<Scalars['String']['input']>;
    sellerId?: InputMaybe<Scalars['ID']['input']>;
    serviceOrder?: InputMaybe<Scalars['String']['input']>;
    serviceOrderObservation?: InputMaybe<Scalars['String']['input']>;
    splitProcessCompleted?: InputMaybe<Scalars['Boolean']['input']>;
    splitProcessStatus?: InputMaybe<Scalars['String']['input']>;
    splitRetryCount?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateOrderInput = {
    customFields?: InputMaybe<UpdateOrderCustomFieldsInput>;
    id: Scalars['ID']['input'];
};

export type UpdateOrderItemsResult =
    | InsufficientStockError
    | NegativeQuantityError
    | Order
    | OrderInterceptorError
    | OrderLimitError
    | OrderModificationError;

export type UpdateOrderNoteInput = {
    isPublic?: InputMaybe<Scalars['Boolean']['input']>;
    note?: InputMaybe<Scalars['String']['input']>;
    noteId: Scalars['ID']['input'];
};

export type UpdatePackageInput = {
    distanceUnit?: InputMaybe<DistanceUnit>;
    enabled?: InputMaybe<Scalars['Boolean']['input']>;
    height?: InputMaybe<Scalars['Float']['input']>;
    id: Scalars['ID']['input'];
    length?: InputMaybe<Scalars['Float']['input']>;
    massUnit?: InputMaybe<MassUnit>;
    name?: InputMaybe<Scalars['String']['input']>;
    weight?: InputMaybe<Scalars['Float']['input']>;
    width?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdatePartnerResult =
    | AssetNotFoundError
    | ChannelNotFoundError
    | PartnerNotFoundError
    | Success;

export type UpdatePaymentMethodInput = {
    checker?: InputMaybe<ConfigurableOperationInput>;
    code?: InputMaybe<Scalars['String']['input']>;
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    enabled?: InputMaybe<Scalars['Boolean']['input']>;
    handler?: InputMaybe<ConfigurableOperationInput>;
    id: Scalars['ID']['input'];
    translations?: InputMaybe<Array<PaymentMethodTranslationInput>>;
};

export type UpdateProductCustomFieldsInput = {
    externalId?: InputMaybe<Scalars['String']['input']>;
    facebookImageId?: InputMaybe<Scalars['ID']['input']>;
    primaryCollection?: InputMaybe<Scalars['String']['input']>;
    relatedProductsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    twitterImageId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateProductInput = {
    assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    customFields?: InputMaybe<UpdateProductCustomFieldsInput>;
    enabled?: InputMaybe<Scalars['Boolean']['input']>;
    facetValueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    featuredAssetId?: InputMaybe<Scalars['ID']['input']>;
    id: Scalars['ID']['input'];
    translations?: InputMaybe<Array<ProductTranslationInput>>;
};

export type UpdateProductOptionGroupInput = {
    code?: InputMaybe<Scalars['String']['input']>;
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    id: Scalars['ID']['input'];
    translations?: InputMaybe<Array<ProductOptionGroupTranslationInput>>;
};

export type UpdateProductOptionInput = {
    code?: InputMaybe<Scalars['String']['input']>;
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    id: Scalars['ID']['input'];
    translations?: InputMaybe<Array<ProductOptionGroupTranslationInput>>;
};

export type UpdateProductVariantCustomFieldsInput = {
    additionalDeliveryTime?: InputMaybe<Scalars['Int']['input']>;
    boxQuantity?: InputMaybe<Scalars['Int']['input']>;
    distanceUnit?: InputMaybe<Scalars['String']['input']>;
    height?: InputMaybe<Scalars['Float']['input']>;
    length?: InputMaybe<Scalars['Float']['input']>;
    massUnit?: InputMaybe<Scalars['String']['input']>;
    measurementUnit?: InputMaybe<Scalars['String']['input']>;
    minimumQuantity?: InputMaybe<Scalars['Int']['input']>;
    multiple?: InputMaybe<Scalars['Int']['input']>;
    orderPaymentConditionType?: InputMaybe<Scalars['String']['input']>;
    weight?: InputMaybe<Scalars['Float']['input']>;
    width?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateProductVariantInput = {
    assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    customFields?: InputMaybe<UpdateProductVariantCustomFieldsInput>;
    enabled?: InputMaybe<Scalars['Boolean']['input']>;
    facetValueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    featuredAssetId?: InputMaybe<Scalars['ID']['input']>;
    id: Scalars['ID']['input'];
    optionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    outOfStockThreshold?: InputMaybe<Scalars['Int']['input']>;
    /** Sets the price for the ProductVariant in the Channel's default currency */
    price?: InputMaybe<Scalars['Money']['input']>;
    /** Allows multiple prices to be set for the ProductVariant in different currencies. */
    prices?: InputMaybe<Array<UpdateProductVariantPriceInput>>;
    sku?: InputMaybe<Scalars['String']['input']>;
    stockLevels?: InputMaybe<Array<StockLevelInput>>;
    stockOnHand?: InputMaybe<Scalars['Int']['input']>;
    taxCategoryId?: InputMaybe<Scalars['ID']['input']>;
    trackInventory?: InputMaybe<GlobalFlag>;
    translations?: InputMaybe<Array<ProductVariantTranslationInput>>;
    useGlobalOutOfStockThreshold?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Used to set up update the price of a ProductVariant in a particular Channel.
 * If the `delete` flag is `true`, the price will be deleted for the given Channel.
 */
export type UpdateProductVariantPriceInput = {
    currencyCode: CurrencyCode;
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    price: Scalars['Money']['input'];
};

export type UpdatePromotionCustomFieldsInput = {
    assetId?: InputMaybe<Scalars['ID']['input']>;
    mobileId?: InputMaybe<Scalars['ID']['input']>;
    progressiveDiscountType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePromotionInput = {
    actions?: InputMaybe<Array<ConfigurableOperationInput>>;
    conditions?: InputMaybe<Array<ConfigurableOperationInput>>;
    couponCode?: InputMaybe<Scalars['String']['input']>;
    customFields?: InputMaybe<UpdatePromotionCustomFieldsInput>;
    enabled?: InputMaybe<Scalars['Boolean']['input']>;
    endsAt?: InputMaybe<Scalars['DateTime']['input']>;
    id: Scalars['ID']['input'];
    perCustomerUsageLimit?: InputMaybe<Scalars['Int']['input']>;
    startsAt?: InputMaybe<Scalars['DateTime']['input']>;
    translations?: InputMaybe<Array<PromotionTranslationInput>>;
    usageLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePromotionResult = MissingConditionsError | Promotion;

export type UpdateProvinceInput = {
    code?: InputMaybe<Scalars['String']['input']>;
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    enabled?: InputMaybe<Scalars['Boolean']['input']>;
    id: Scalars['ID']['input'];
    translations?: InputMaybe<Array<ProvinceTranslationInput>>;
};

export type UpdateRefundRequestInput = {
    assets?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
    customerId?: InputMaybe<Scalars['ID']['input']>;
    orderId?: InputMaybe<Scalars['ID']['input']>;
    paymentId?: InputMaybe<Scalars['ID']['input']>;
    reason?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRoleInput = {
    channelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    code?: InputMaybe<Scalars['String']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    id: Scalars['ID']['input'];
    permissions?: InputMaybe<Array<Permission>>;
};

export type UpdateSellerCustomFieldsInput = {
    externalId?: InputMaybe<Scalars['String']['input']>;
    phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSellerInput = {
    customFields?: InputMaybe<UpdateSellerCustomFieldsInput>;
    id: Scalars['ID']['input'];
    name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateShippingMethodInput = {
    calculator?: InputMaybe<ConfigurableOperationInput>;
    checker?: InputMaybe<ConfigurableOperationInput>;
    code?: InputMaybe<Scalars['String']['input']>;
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    fulfillmentHandler?: InputMaybe<Scalars['String']['input']>;
    id: Scalars['ID']['input'];
    translations: Array<ShippingMethodTranslationInput>;
};

export type UpdateShoppingListError = ErrorResult & {
    __typename?: 'UpdateShoppingListError';
    errorCode: ErrorCode;
    message: Scalars['String']['output'];
};

export type UpdateShoppingListInput = {
    description?: InputMaybe<Scalars['String']['input']>;
    enabled?: InputMaybe<Scalars['Boolean']['input']>;
    endDate?: InputMaybe<Scalars['DateTime']['input']>;
    id: Scalars['ID']['input'];
    imageId?: InputMaybe<Scalars['ID']['input']>;
    isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateShoppingListResult =
    | UpdateShoppingListError
    | UpdateShoppingListSuccess;

export type UpdateShoppingListSuccess = {
    __typename?: 'UpdateShoppingListSuccess';
    shoppingListId: Scalars['String']['output'];
    success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateStockLocationInput = {
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    id: Scalars['ID']['input'];
    name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSurveyQuestionInput = {
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    options?: InputMaybe<Array<Scalars['String']['input']>>;
    sortOrder?: InputMaybe<Scalars['Int']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSynonymGroupInput = {
    enabled?: InputMaybe<Scalars['Boolean']['input']>;
    id: Scalars['ID']['input'];
    label?: InputMaybe<Scalars['String']['input']>;
    terms?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateSynonymGroupResult =
    | Success
    | SynonymGroupNotFoundError
    | SynonymGroupTooFewTermsError;

export type UpdateTagInput = {
    id: Scalars['ID']['input'];
    value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTaxCategoryInput = {
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    id: Scalars['ID']['input'];
    isDefault?: InputMaybe<Scalars['Boolean']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTaxRateInput = {
    categoryId?: InputMaybe<Scalars['ID']['input']>;
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    customerGroupId?: InputMaybe<Scalars['ID']['input']>;
    enabled?: InputMaybe<Scalars['Boolean']['input']>;
    id: Scalars['ID']['input'];
    name?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<Scalars['Float']['input']>;
    zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateWorkBrandInput = {
    description?: InputMaybe<Scalars['String']['input']>;
    facetValueId?: InputMaybe<Scalars['ID']['input']>;
    id: Scalars['ID']['input'];
    name?: InputMaybe<Scalars['String']['input']>;
    websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateZoneInput = {
    customFields?: InputMaybe<Scalars['JSON']['input']>;
    id: Scalars['ID']['input'];
    name?: InputMaybe<Scalars['String']['input']>;
};

export type User = Node & {
    __typename?: 'User';
    authenticationMethods: Array<AuthenticationMethod>;
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<Scalars['JSON']['output']>;
    id: Scalars['ID']['output'];
    identifier: Scalars['String']['output'];
    lastLogin?: Maybe<Scalars['DateTime']['output']>;
    roles: Array<Role>;
    updatedAt: Scalars['DateTime']['output'];
    verified: Scalars['Boolean']['output'];
};

export type VariantPriceSync = {
    channelCode: Scalars['String']['input'];
    externalVariantId: Scalars['String']['input'];
    prices: Array<PriceInput>;
};

export type VariantPromotionFormatToSearch = {
    __typename?: 'VariantPromotionFormatToSearch';
    discount?: Maybe<Scalars['Float']['output']>;
    promotionId?: Maybe<Scalars['ID']['output']>;
};

export type Webhook = {
    __typename?: 'Webhook';
    event: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    requestTransformer?: Maybe<WebhookRequestTransformer>;
    url: Scalars['String']['output'];
};

export type WebhookInput = {
    event: Scalars['String']['input'];
    transformerName?: InputMaybe<Scalars['String']['input']>;
    url: Scalars['String']['input'];
};

export type WebhookRequestTransformer = {
    __typename?: 'WebhookRequestTransformer';
    name: Scalars['String']['output'];
    supportedEvents: Array<Scalars['String']['output']>;
};

export type WorkBrand = Node & {
    __typename?: 'WorkBrand';
    asset: Asset;
    channels: Array<Channel>;
    createdAt: Scalars['String']['output'];
    description?: Maybe<Scalars['String']['output']>;
    facetValue?: Maybe<FacetValue>;
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    updatedAt: Scalars['String']['output'];
    websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type WorkBrandList = {
    __typename?: 'WorkBrandList';
    items: Array<WorkBrand>;
    totalItems: Scalars['Int']['output'];
};

export type WorkBrandListOptions = {
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type Zone = Node & {
    __typename?: 'Zone';
    createdAt: Scalars['DateTime']['output'];
    customFields?: Maybe<Scalars['JSON']['output']>;
    id: Scalars['ID']['output'];
    members: Array<Region>;
    name: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type ZoneFilterParameter = {
    _and?: InputMaybe<Array<ZoneFilterParameter>>;
    _or?: InputMaybe<Array<ZoneFilterParameter>>;
    createdAt?: InputMaybe<DateOperators>;
    id?: InputMaybe<IdOperators>;
    name?: InputMaybe<StringOperators>;
    updatedAt?: InputMaybe<DateOperators>;
};

export type ZoneList = PaginatedList & {
    __typename?: 'ZoneList';
    items: Array<Zone>;
    totalItems: Scalars['Int']['output'];
};

export type ZoneListOptions = {
    /** Allows the results to be filtered */
    filter?: InputMaybe<ZoneFilterParameter>;
    /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
    filterOperator?: InputMaybe<LogicalOperator>;
    /** Skips the first n results, for use in pagination */
    skip?: InputMaybe<Scalars['Int']['input']>;
    /** Specifies which properties to sort the results by */
    sort?: InputMaybe<ZoneSortParameter>;
    /** Takes n results, for use in pagination */
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type ZoneSortParameter = {
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AssociateAllBuyersWithShoppingListResult =
    | AssociateAllBuyersWithShoppingListError
    | AssociateAllBuyersWithShoppingListSuccess;

export type AssociateBuyersWithShoppingListResult =
    | AssociateBuyersWithShoppingListError
    | AssociateBuyersWithShoppingListSuccess;

export enum PaymentConditionSourceType {
    from_customer = 'from_customer',
    from_integration = 'from_integration',
}

export enum PaymentTokenTypes {
    ANTICIPATED = 'ANTICIPATED',
    BANK_SLIP = 'BANK_SLIP',
    CARD = 'CARD',
    PIX = 'PIX',
}

export type ProductValidationQueryVariables = Exact<{
    productId: Scalars['ID']['input'];
}>;

export type ProductValidationQuery = {
    __typename?: 'Query';
    normalizeProductStatus?: {
        __typename?: 'NormalizeProductStatus';
        isProductOkay: boolean;
        errors: Array<{
            __typename?: 'ProductError';
            type: string;
            message: string;
        }>;
        details: {
            __typename?: 'ProductStatusDetails';
            isActive: boolean;
            hasPrice: boolean;
            hasStock: boolean;
            hasMeasurementUnit: boolean;
        };
    } | null;
};

export const ProductValidationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ProductValidation' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'productId' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ID' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'normalizeProductStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'productId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'productId' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'isProductOkay',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'errors' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'type',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'message',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'details' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'isActive',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'hasPrice',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'hasStock',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'hasMeasurementUnit',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    ProductValidationQuery,
    ProductValidationQueryVariables
>;
